export const pl = {
  app: {
    home: 'Strona główna',
    playerScout: 'Skaut zawodników',
    playerComparison: 'Porównanie zawodników',
    playerRecruitment: 'Radar',
    collections: 'Kolekcje',
    favoritePlayers: 'Ulubieni zawodnicy',
    teamAnalytics: 'Analityka zespołu',
    gameAnalysis: 'Analiza meczu',
    seasonStats: 'Statystyki sezonu',
    leagueTable: 'Tabela ligowa',
    scoresAndFixtures: 'Wyniki i terminarz',
    notifications: 'Powiadomienia',
    administration: 'Administracja',
    inbox: 'Skrzynka odbiorcza',
    teamStats: 'Statystyki zespołu',
    blog: 'Blog',
    leagues: 'Ligi',
    squadBuilder: 'Kreator składu',
    playerAlerts: 'Alerty zawodników',
    searchAlerts: 'Alerty wyszukiwania',
    videoUploadTool: 'Narzędzie do przesyłania wideo',
    videoPlaylists: 'Playlisty',
    uploadedGames: 'Przesłane mecze',
    favoriteTeams: 'Ulubione zespoły',
    arrigo: 'Arrigo',
    validateEvents: 'Zweryfikuj wydarzenia'
  },
  playerRecruitment: {
    title: 'Karta zawodnika',
    subtitle: 'Zagłęb się w cechy i statystyki zawodnika',
    league: 'Liga',
    selectedSeason: 'Wybrany sezon',
    year: 'Rok',
    radar: 'Radar',
    positions: 'Pozycje',
    numberOfPlayers: 'Liczba zawodników',
    template: 'Szablon',
    compareWith: 'Porównaj z',
    previousPerformance: 'Poprzednie występy',
    xGames: '{0} meczów',
    average: 'Średnia',
    leagueAverage: 'Średnia ligowa',
    selectSeason: 'Wybierz sezon',
    positionsPlayed: 'Grane pozycje',
    minMax: 'Min i Max',
    top5Leagues: 'Top 5 lig',
    infoMessage: 'Zaznacz tylko jeden sezon, aby włączyć Min i Max sezonu',
    infoMessage2: 'Wybierz ten sam sezon dla obu zawodników',
    dataPer90MinText: 'Dane na 90 minut',
    adjustToPossessionText: '* Dostosowane do posiadania piłki',
    text: 'Tekst',
    lollipop: 'Lollipop',
    polar: 'Polar',
    noGamesBetweenDates: 'Nie znaleziono meczów między wybranymi datami',
    radarTemplates: {
      Goalkeeper: 'Bramkarz',
      GoalkeeperCustom: 'Bramkarz niestandardowy',
      GoalkeeperCustom1: 'Bramkarz niestandardowy 1',
      GoalkeeperCustom2: 'Bramkarz niestandardowy 2',
      GoalkeeperCustom3: 'Bramkarz niestandardowy 3',
      GoalkeeperCustom4: 'Bramkarz niestandardowy 4',
      GoalkeeperCustom5: 'Bramkarz niestandardowy 5',
      GoalkeeperCustom6: 'Bramkarz niestandardowy 6',
      Defender: 'Obrońca',
      DefenderCustom: 'Obrońca niestandardowy',
      DefenderCustom1: 'Obrońca niestandardowy 1',
      DefenderCustom2: 'Obrońca niestandardowy 2',
      DefenderCustom3: 'Obrońca niestandardowy 3',
      DefenderCustom4: 'Obrońca niestandardowy 4',
      DefenderCustom5: 'Obrońca niestandardowy 5',
      DefenderCustom6: 'Obrońca niestandardowy 6',
      FullBack: 'Boczny obrońca',
      FullBackCustom: 'Boczny obrońca niestandardowy',
      FullBackCustom1: 'Boczny obrońca niestandardowy 1',
      FullBackCustom2: 'Boczny obrońca niestandardowy 2',
      FullBackCustom3: 'Boczny obrońca niestandardowy 3',
      FullBackCustom4: 'Boczny obrońca niestandardowy 4',
      FullBackCustom5: 'Boczny obrońca niestandardowy 5',
      FullBackCustom6: 'Boczny obrońca niestandardowy 6',
      FullBackPredictive: 'Boczny obrońca',
      Midfielder: 'Pomocnik',
      MidfielderCustom: 'Pomocnik niestandardowy',
      MidfielderCustom1: 'Pomocnik niestandardowy 1',
      MidfielderCustom2: 'Pomocnik niestandardowy 2',
      MidfielderCustom3: 'Pomocnik niestandardowy 3',
      MidfielderCustom4: 'Pomocnik niestandardowy 4',
      MidfielderCustom5: 'Pomocnik niestandardowy 5',
      MidfielderCustom6: 'Pomocnik niestandardowy 6',
      MidfielderPredictive: 'Pomocnik',
      MidfielderDefensive: 'Pomocnik defensywny',
      MidfielderOffensive: 'Pomocnik ofensywny',
      AttackingMidfielder: 'Ofensywny pomocnik',
      MidfielderWing: 'Pomocnik skrzydłowy',
      Winger: 'Skrzydłowy',
      WingerCustom: 'Skrzydłowy niestandardowy',
      WingerCustom1: 'Skrzydłowy niestandardowy 1',
      WingerCustom2: 'Skrzydłowy niestandardowy 2',
      WingerCustom3: 'Skrzydłowy niestandardowy 3',
      WingerCustom4: 'Skrzydłowy niestandardowy 4',
      WingerCustom5: 'Skrzydłowy niestandardowy 5',
      WingerCustom6: 'Skrzydłowy niestandardowy 6',
      WingerOffensive: 'Skrzydłowy ofensywny',
      Forward: 'Napastnik',
      ForwardCustom: 'Napastnik niestandardowy',
      ForwardCustom1: 'Napastnik niestandardowy 1',
      ForwardCustom2: 'Napastnik niestandardowy 2',
      ForwardCustom3: 'Napastnik niestandardowy 3',
      ForwardCustom4: 'Napastnik niestandardowy 4',
      ForwardCustom5: 'Napastnik niestandardowy 5',
      ForwardCustom6: 'Napastnik niestandardowy 6',
      ForwardPredictive: 'Napastnik',
      WingBack: 'Wahadłowy',
      WingBackCustom: 'Wahadłowy niestandardowy',
      WingBackCustom1: 'Wahadłowy niestandardowy 1',
      WingBackCustom2: 'Wahadłowy niestandardowy 2',
      WingBackCustom3: 'Wahadłowy niestandardowy 3',
      WingBackCustom4: 'Wahadłowy niestandardowy 4',
      WingBackCustom5: 'Wahadłowy niestandardowy 5',
      WingBackCustom6: 'Wahadłowy niestandardowy 6',
      WingBackMedia: 'Wahadłowy (media społecznościowe)',
      FullBackMedia: 'Boczny obrońca (media społecznościowe)',
      MidfielderMedia: 'Pomocnik (media społecznościowe)',
      WingerMedia: 'Skrzydłowy (media społecznościowe)',
      ForwardMedia: 'Napastnik (media społecznościowe)',
      PhysicalWingBack: 'Fizyczny wahadłowy',
      PhysicalForward: 'Fizyczny napastnik',
      PhysicalWinger: 'Fizyczny skrzydłowy',
      PhysicalMidfielder: 'Fizyczny pomocnik',
      PhysicalFullBack: 'Fizyczny boczny obrońca',
      PhysicalDefender: 'Fizyczny obrońca',
      PhysicalWingBackLMO: 'Fizyczny wahadłowy',
      PhysicalForwardLMO: 'Fizyczny napastnik',
      PhysicalWingerLMO: 'Fizyczny skrzydłowy',
      PhysicalMidfielderLMO: 'Fizyczny pomocnik',
      PhysicalFullBackLMO: 'Fizyczny boczny obrońca',
      PhysicalDefenderLMO: 'Fizyczny obrońca'
    },
    radarTemplatesWomen: {
      Goalkeeper: 'Bramkarz',
      Defender: 'Obrońca',
      FullBack: 'Boczny obrońca',
      FullBackPredictive: 'Boczny obrońca',
      Midfielder: 'Pomocnik',
      MidfielderPredictive: 'Pomocnik',
      MidfielderDefensive: 'Pomocnik defensywny',
      MidfielderOffensive: 'Pomocnik ofensywny',
      AttackingMidfielder: 'Ofensywny pomocnik',
      MidfielderWing: 'Pomocnik skrzydłowy',
      Winger: 'Skrzydłowy',
      WingerOffensive: 'Skrzydłowy ofensywny',
      Forward: 'Napastnik',
      ForwardPredictive: 'Napastnik',
      WingBack: 'Wahadłowy',
      WingBackMedia: 'Wahadłowy (media społecznościowe)',
      FullBackMedia: 'Boczny obrońca (media społecznościowe)',
      MidfielderMedia: 'Pomocnik (media społecznościowe)',
      WingerMedia: 'Skrzydłowy (media społecznościowe)',
      ForwardMedia: 'Napastnik (media społecznościowe)',
      PhysicalWingBack: 'Fizyczny wahadłowy',
      PhysicalForward: 'Fizyczny napastnik',
      PhysicalWinger: 'Fizyczny skrzydłowy',
      PhysicalMidfielder: 'Fizyczny pomocnik',
      PhysicalFullBack: 'Fizyczny boczny obrońca',
      PhysicalDefender: 'Fizyczny obrońca',
      PhysicalWingBackLMO: 'Fizyczny wahadłowy',
      PhysicalForwardLMO: 'Fizyczny napastnik',
      PhysicalWingerLMO: 'Fizyczny skrzydłowy',
      PhysicalMidfielderLMO: 'Fizyczny pomocnik',
      PhysicalFullBackLMO: 'Fizyczny boczny obrońca',
      PhysicalDefenderLMO: 'Fizyczny obrońca'
    },
    radarDescription: {
      basicStatistics: {
        title: 'STATYSTYKI PODSTAWOWE',
        minutes: 'minuty',
        goals: 'gole',
        assists: 'asysty',
        redCards: 'czerwone kartki',
        yellowCards: 'żółte kartki',
        games: 'mecze',
        goalsReceived: 'stracone gole bez rzutów karnych',
        xGFaced: 'xG przeciw'
      },
      profiles: {
        3: {
          1: 'Zdolny bramkarz grający nogami, zarówno w krótkich, jak i długich podaniach.',
          2: 'Umiejętność gry nogami i bycia ważnym na początku meczu, z dobrym odsetkiem podań zarówno z krótkich, jak i długich.',
          3: 'Dobra praca nóg, która sprawia, że ​​ten profil jest interesującą opcją ze względu na wskaźniki podań.',
          4: 'Profil wyróżniający się podaniami, zarówno na własnym polu, jak i na polu przeciwnika.',
          5: 'Świetne bezpieczeństwo z piłką u nóg i wysokie umiejętności podań.',
          6: 'Dobra praca nóg, zapewniająca bezpieczeństwo podczas wystrzeliwania piłki i wykonywania wysokiego odsetka krótkich i długich podań.',
          7: 'Wysoki procent zrealizowanych przebiegów, zarówno krótkich jak i długich, zapewniający jakość w obiegu.'
        },
        5: {
          1: 'Obrońca wyróżniający się w pojedynkach 1 na 1 oraz wykonujący dużą liczbę wślizgów i przechwytów.',
          2: 'Bardzo skuteczny środkowy obrońca w pojedynkach indywidualnych, zarówno w ataku, jak i w ataku, z dobrym przewidywaniem.',
          3: 'Środkowa obrona dobrze radząca sobie w indywidualnych pojedynkach obronnych, co przekłada się na dużą ilość zbiórek.',
          4: 'Profil o wysokim poziomie defensywnym, zdolny do odzyskiwania dużej ilości piłek dzięki odbiorom i przechwytom.',
          5: 'Bardzo skuteczna obrona w odbiorze i z dużą ilością przechwytów, wyróżniająca się w indywidualnej konfrontacji.',
          6: 'Środkowy obrońca z dużą liczbą zbiórek na mecz, biegły w czytaniu gry rywali i cięciach, charakteryzujący się dużą precyzją i częstotliwością odbiorów.',
          7: 'Profil defensywny z dużą liczbą odzyskań dzięki skuteczności i częstotliwości odbiorów oraz dobrej przewidywalności.'
        },
        6: {
          1: 'Obrońca z dużym wkładem w tworzenie sytuacji i dobrą wizją gry.'
        },
        7: {
          1: 'Zawodnik zrównoważony między grą ofensywną (duży wkład w "xG Buildup") a defensywą (wysoki wolumen odbiorów).'
        },
        8: {
          1: 'Solidny w defensywnych pojedynkach 1 na 1 oraz z wysokim wolumenem odbiorów, zarówno po wślizgach, jak i przechwytach.'
        },
        9: {
          1: 'Zawodnik o dużym wkładzie ofensywnym, generujący groźne akcje i kreujący okazje.'
        },
        10: {
          1: 'Kompletny zawodnik, pokrywający dużo przestrzeni; pomaga w odbiorach i ma istotny udział w "xG Buildup" względem całkowitej kreacji zespołu.'
        },
        11: {
          1: 'Pomocnik o wysokiej jakości w defensywie i dużej skuteczności podań, mimo niewielkiego wpływu na atak.'
        },
        12: {
          1: 'Kompletny pomocnik z dużym wkładem w kreowanie sytuacji i dobrą skutecznością w powietrzu, a także wieloma przechwytami i wślizgami.'
        },
        15: {
          1: 'Skrzydłowy dobrze radzący sobie w pojedynkach 1 na 1 i z wysoką skutecznością dośrodkowań, generujący więcej oczekiwanych asyst niż strzałów.'
        },
        16: {
          1: 'Zawodnik z dużą liczbą prostopadłych podań i progresji z piłką, kreujący sytuacje i mający większy wpływ w środkowej strefie niż typowy skrzydłowy.'
        },
        17: {
          1: 'Zawodnik z dobrym dryblingiem; jego ruchy polegają na wchodzeniu do środka, by generować więcej strzałów (xG) niż kluczowych podań (xA).'
        },
        18: {
          1: 'Napastnik świetnie pracujący bez piłki, umiejący właściwie wybrać, kiedy zakończyć akcję strzałem, a kiedy podaniem.'
        },
        22: {
          1: 'Napastnik o dużej mobilności do wychodzenia do prostopadłych podań, schodzenia do skrzydła i tworzenia wielu okazji. Wysoki odsetek kontaktów poza polem karnym względem łącznej liczby kontaktów w meczu.'
        }
      },
      description: 'OPIS',
      conjuction: ' i ',
      conjuction2: ' i ',
      over: 'powyżej',
      under: 'poniżej',
      respectively: ', odpowiednio',
      Defending1: {
        1: 'Jego gra w defensywie należy do najsłabszych w top 5 ligach'
      },
      Defending2: {
        1: 'Poziom w grze defensywnej nie jest wysoki, ponieważ osiągi są poniżej średniej'
      },
      Defending3: {
        1: 'Gra na średnim poziomie, poziom jest nieco powyżej_poniżej_średniej'
      },
      Defending4: {
        1: 'Wyróżniająca praca w defensywie z wynikami powyżej średniej'
      },
      Defending5: {
        1: 'Wybitny w zadaniach defensywnych, o poziomie zbliżonym do najlepszych player_positions top 5 lig'
      },
      Saving1: {
        1: 'Bramkarz o bardzo niskiej dyspozycji, mający duże trudności z zatrzymywaniem strzałów'
      },
      Saving2: {
        1: 'Nie prezentuje dobrego poziomu bramkarskiego, ponieważ jego forma jest poniżej średniej'
      },
      Saving3: {
        1: 'Bramkarz o akceptowalnym poziomie, w okolicach średniej top 5 lig, wymagający poprawy w metric_name'
      },
      Saving4: {
        1: 'Bramkarz na dobrym poziomie, powyżej średniej top 5 lig, wyróżniający się szczególnie w metric_name'
      },
      Saving5: {
        1: 'Bardzo kompletny bramkarz; jego metryki lokują go w Top 20% w porównaniu z golkiperami top 5 lig w Europie.'
      },
      Passing1: {
        1: 'Z piłką przy nodze prezentuje poziom wśród najsłabszych zawodników'
      },
      Passing2: {
        1: 'Jeśli chodzi o podania, jego skuteczność jest poniżej średniej'
      },
      Passing3: {
        1: 'Poziom podań jest akceptowalny, nieco over_under_average średniej'
      },
      Passing4: {
        1: 'Bardzo dobry poziom podań, wyraźnie powyżej średniej'
      },
      Passing5: {
        1: 'Świetna skuteczność podań, wyniki lepsze niż u większości zawodników'
      },
      Aerial1: {
        1: 'Bardzo słaby w grze w powietrzu, jeden z najsłabszych na swojej pozycji w tym elemencie'
      },
      Aerial2: {
        1: 'Jeśli chodzi o wygrywanie pojedynków w powietrzu, wypada poniżej średniej'
      },
      Aerial3: {
        1: 'Akceptowalny poziom gry w powietrzu, nieco over_under_average średniej'
      },
      Aerial4: {
        1: 'Bardzo dobry występ w grze w powietrzu, z wysoką skutecznością'
      },
      Aerial5: {
        1: 'Jego metryki gry w powietrzu lokują go wśród najlepszych'
      },
      Shooting1: {
        1: 'Bardzo słabe statystyki pod bramką; jeden z najsłabszych w tym aspekcie'
      },
      Shooting2: {
        1: 'Poziom strzelecki mocno do poprawy, poniżej średniej'
      },
      Shooting3: {
        1: 'Akceptowalny wkład ofensywny, nieco over_under_average średniej'
      },
      Shooting4: {
        1: 'Bardzo dobra skuteczność w polu karnym, wyniki powyżej 60% zawodników'
      },
      Shooting5: {
        1: 'Świetne umiejętności ofensywne, znakomite wyniki lokujące go wśród najlepszych'
      },
      Association1: {
        1: 'Bardzo niski poziom gry kombinacyjnej, wśród najsłabszych w top 5 ligach'
      },
      Association2: {
        1: 'Dużo do poprawy w grze z piłką, obecnie poniżej średniej w tym aspekcie'
      },
      Association3: {
        1: 'Dobrze współpracuje z piłką, nieco over_under_average średniej'
      },
      Association4: {
        1: 'Bardzo dobra gra kombinacyjna na wyróżniającym się poziomie'
      },
      Association5: {
        1: 'Wyjątkowa umiejętność gry kombinacyjnej, wśród najlepszych zawodników'
      },
      BallHandling1: {
        1: 'Bardzo słabe panowanie nad piłką, wśród najsłabszych na tle top 5 lig'
      },
      BallHandling2: {
        1: 'Panowanie nad piłką na poziomie poniżej średniej'
      },
      BallHandling3: {
        1: 'Akceptowalne panowanie nad piłką, nieco over_under_average średniej'
      },
      BallHandling4: {
        1: 'Wysoki poziom panowania nad piłką, wyniki zbliżone do najlepszych'
      },
      BallHandling5: {
        1: 'Wyjątkowe panowanie nad piłką, wśród najlepszych w top 5 ligach'
      },
      Crosses1: {
        1: 'Słaba skuteczność dośrodkowań w pole karne. Wśród najsłabszych w metrykach dośrodkowań'
      },
      Crosses2: {
        1: 'Poniżej średniej w tworzeniu zagrożenia dośrodkowaniami'
      },
      Crosses3: {
        1: 'Akceptowalny poziom dośrodkowań w pole karne, nieco over_under_average'
      },
      Crosses4: {
        1: 'Dobre statystyki dośrodkowań, wyraźnie powyżej średniej'
      },
      Crosses5: {
        1: 'Bardzo wysoka skuteczność dośrodkowań w pole karne; w Top 20% najbardziej efektywnych profili w tej kategorii'
      },
      Carries1: {
        1: 'Wśród 20% zawodników z najgorszymi wynikami w prowadzeniu piłki'
      },
      Carries2: {
        1: 'Prowadzenie piłki zdecydowanie poniżej średniej dla jego pozycji'
      },
      Carries3: {
        1: 'Wyniki zbliżone do średniej, nieco over_under_average, jeśli chodzi o prowadzenie piłki'
      },
      Carries4: {
        1: 'Wyróżniający się zawodnik z bardzo dobrymi liczbami progresji i prowadzenia piłki'
      },
      Carries5: {
        1: 'Bardzo utalentowany w prowadzeniu piłki, z wysokimi wynikami w metrykach kategorii Carries'
      },
      Turnovers1: {
        1: 'Bardzo negatywne wyniki z powodu dużej liczby strat ułatwiających rywalom tworzenie zagrożenia. Wśród najsłabszych w tej metryce'
      },
      Turnovers2: {
        1: 'Liczne groźne straty pomagają rywalom; konieczne jest znaczne ograniczenie ich liczby'
      },
      Turnovers3: {
        1: 'Zawodnik jest nieco over_under_average pod względem strat, więc wciąż ma pole do poprawy'
      },
      Turnovers4: {
        1: 'Godne uwagi wyniki w ograniczaniu strat, lepsze niż u 60% zawodników z najmniejszą liczbą strat'
      },
      Turnovers5: {
        1: 'Warto podkreślić niewielką liczbę strat, co plasuje go wśród najlepszych w utrzymaniu posiadania dla zespołu'
      },
      SequenceInvolvement1: {
        1: 'W kontekście posiadania piłki statystyki są słabe; akcje bardzo rzadko kończą się strzałem'
      },
      SequenceInvolvement2: {
        1: 'Wykończenie posiadania wymaga poprawy; akcje rzadko kończą się strzałem, co plasuje wynik wyraźnie poniżej średniej'
      },
      SequenceInvolvement3: {
        1: 'Akceptowalny poziom jeśli chodzi o kończenie akcji pod bramką; percentyl nieco over_under_average średniej, z dużym potencjałem poprawy'
      },
      SequenceInvolvement4: {
        1: 'Dobra umiejętność kończenia akcji zespołu strzałami, część zamieniana na gole; godne uwagi wyniki w tej kategorii'
      },
      SequenceInvolvement5: {
        1: 'Wyróżnia się wśród tych, którzy najlepiej kończą akcje zespołu strzałami generującymi zagrożenie'
      },
      OutPlay1: {
        1: 'Zawodnik ma minimalny wpływ na zaburzanie struktur defensywnych przeciwnika'
      },
      OutPlay2: {
        1: 'Jego wkład w progresję i przełamywanie obrony jest poniżej standardów dla pozycji'
      },
      OutPlay3: {
        1: 'Sporadycznie generuje przewagi, wyniki w okolicach średniej dla pozycji'
      },
      OutPlay4: {
        1: 'Często przyczynia się do przełamywania linii defensywnych i tworzenia przewag'
      },
      OutPlay5: {
        1: 'Wyróżnia się wśród tych, którzy na tej pozycji najlepiej eliminują rywali i generują progresje'
      },
      LineBreakingPasses1: {
        1: 'Rzadko próbuje lub zagrywa podania przełamujące linie obrony; bardzo mały wkład w takie akcje'
      },
      LineBreakingPasses2: {
        1: 'Ma trudności z regularnym znajdowaniem partnerów między liniami lub za pressingiem; wkład poniżej standardów pozycji'
      },
      LineBreakingPasses3: {
        1: 'Sporadycznie zagrywa podania przełamujące linie; poziom około średniej dla pozycji'
      },
      LineBreakingPasses4: {
        1: 'Często przełamuje linie podaniami i pomaga rozbijać bloki rywala'
      },
      LineBreakingPasses5: {
        1: 'Wśród najskuteczniejszych podających w lidze w przełamywaniu linii i wychodzeniu spod pressingu. To jedna z głównych mocnych stron'
      },
      PassUnderPressure1: {
        1: 'Widać, że ma trudności z zachowaniem spokoju lub skuteczności, gdy rywale wywierają presję'
      },
      PassUnderPressure2: {
        1: 'Ma problem z utrzymaniem dokładności podań w sytuacjach wysokiego pressingu'
      },
      PassUnderPressure3: {
        1: 'Poziom podań pod presją jest zbliżony do średniej; radzi sobie całkiem dobrze, choć wykonanie nie zawsze jest w pełni czyste'
      },
      PassUnderPressure4: {
        1: 'Często udaje się znaleźć partnerów mimo presji; wyniki są powyżej średniej w tego typu podaniach'
      },
      PassUnderPressure5: {
        1: 'Wyróżnia się wyjątkowym spokojem i precyzją podań pod intensywną presją, należąc w tym aspekcie do najlepszych na swojej pozycji'
      },
      BallReceived1: {
        1: 'Otrzymuje bardzo niewiele podań w zaawansowanych strefach; rzadko operuje między liniami'
      },
      BallReceived2: {
        1: 'Notuje pewne niekryte przyjęcia na połowie rywala, ale bez dużej regularności'
      },
      BallReceived3: {
        1: 'Rejestruje średni wolumen nieatakowanych przyjęć w strefach ataku'
      },
      BallReceived4: {
        1: 'Często przyjmuje piłkę między liniami i w strefach wolnych od presji'
      },
      BallReceived5: {
        1: 'Gromadzi wiele przyjęć między liniami, bez krycia i w kluczowych strefach'
      },
      OnBallPressure1: {
        1: 'Rzadko pressuje i prawie nigdy blisko zawodnika z piłką. Niewielka intensywność'
      },
      OnBallPressure2: {
        1: 'Zdarzają mu się mocne doskoki, ale rzadko. Ogólna intensywność raczej niska'
      },
      OnBallPressure3: {
        1: 'Notuje średni wolumen pressingu blisko przeciwnika przy piłce'
      },
      OnBallPressure4: {
        1: 'Zdyscyplinowany pressing, regularnie doskakuje do zawodnika z piłką'
      },
      OnBallPressure5: {
        1: 'Bardzo intensywny bez piłki, zdyscyplinowany i ciężko pracujący w pressingu'
      },
      SpatialCoverage1: {
        1: 'Zawodnik ma bardzo ograniczony wkład w zajmowanie i kontrolę przestrzeni, z minimalnym udziałem w formacji i strukturze taktycznej zespołu. Jego pokrycie przestrzenne jest słabe zarówno w ataku, jak i w obronie, co odzwierciedla niewielki wpływ na organizację i kompaktowość'
      },
      SpatialCoverage2: {
        1: 'Zawodnik zapewnia poniżej przeciętne pokrycie przestrzenne; wykazuje pewne uczestnictwo w zajmowaniu pola, ale z lukami w ciągłości pozycyjnej i spójności z resztą zespołu. Jego wpływ na strukturę taktyczną jest przerywany i mniej spójny niż u lepszych zawodników'
      },
      SpatialCoverage3: {
        1: 'Zawodnik prezentuje przeciętne pokrycie przestrzenne, regularnie przyczyniając się do zajmowania i kontroli przestrzeni. Jego ustawienie jest na ogół poprawne i funkcjonalne, z umiarkowanym wpływem zarówno w fazie ataku, jak i obrony'
      },
      SpatialCoverage4: {
        1: 'Zawodnik oferuje ponadprzeciętne pokrycie przestrzenne, wykazując duże zaangażowanie w zajmowanie pola i strukturę pozycyjną zespołu. Umiejętność utrzymania kształtu i adaptacji do przejść znacząco wpływa na kompaktowość i kontrolę kluczowych stref'
      },
      SpatialCoverage5: {
        1: 'Zawodnik osiąga znakomity poziom pokrycia przestrzennego, optymalizując ustawienie i wyraźnie wpływając na formację oraz strukturę taktyczną zespołu. Zrozumienie gry i synchronizacja z blokiem pozwalają maksymalizować zajmowanie strategicznych stref, w ataku i w obronie'
      },
      OffBallPressure1: {
        1: 'Zawodnik wywiera bardzo ograniczoną presję w defensywie bez piłki; rzadko angażuje rywali, by zakłócić ich działania lub wymusić błędy. Wkład w pressing i strukturę obronną jest minimalny'
      },
      OffBallPressure2: {
        1: 'Zawodnik zapewnia poniżej przeciętną presję bez piłki; sporadycznie angażuje rywali, lecz z nieregularnym timingiem i ustawieniem. Wpływ na odbiór piłki lub zakłócanie budowy akcji przeciwnika jest ograniczony'
      },
      OffBallPressure3: {
        1: 'Zawodnik prezentuje przeciętną presję bez piłki, regularnie wspierając działania defensywne zespołu. Ustawienie i timing są na ogół skuteczne, zapewniając odpowiednią presję'
      },
      OffBallPressure4: {
        1: 'Zawodnik oferuje ponadprzeciętną presję bez piłki, często zakłócając działania rywali i ograniczając ich czas oraz przestrzeń. Dobrze zgrane wysiłki pomagają utrzymać mocną strukturę obronną'
      },
      OffBallPressure5: {
        1: 'Zawodnik wyróżnia się presją bez piłki: konsekwentnie niepokoi rywali, wymusza straty i ogranicza linie podań. Intensywność, ustawienie i antycypacja znacząco podnoszą efektywność defensywy'
      },
      Distance1: {
        1: 'Pokrywa zdecydowanie mniej terenu niż średnia (ruch po boisku jest bardzo ograniczony)'
      },
      Distance2: {
        1: 'Dystans pokonywany na mecz jest poniżej typowego dla najwyższego poziomu (mniej aktywny niż średnia)'
      },
      Distance3: {
        1: 'Pokrywa rozsądną ilość terenu, z liczbami około ligowej średniej (zrównoważone obciążenie fizyczne)'
      },
      Distance4: {
        1: 'Konsekwentnie pokonuje duże dystanse, co odzwierciedla dobrą wytrzymałość (solidna wydolność)'
      },
      Distance5: {
        1: 'Jego wolumen pracy fizycznej jest znakomity. Wśród najbardziej aktywnych w top 5 ligach pod względem pokrywanego terenu'
      },
      Sprint1: {
        1: 'Wykonuje bardzo niewiele sprintów w porównaniu do średniej (minimalny wysiłek szybkościowy w meczach)'
      },
      Sprint2: {
        1: 'Częstotliwość sprintów niższa niż średnia dla pozycji (ograniczona eksplozywność)'
      },
      Sprint3: {
        1: 'Wykonuje umiarkowaną liczbę sprintów na mecz, w granicach średniej ligowej'
      },
      Sprint4: {
        1: 'Wyróżnia się częstotliwością sprintów, zdecydowanie powyżej średniej. Prezentuje stałą eksplozywność w całym meczu'
      },
      Sprint5: {
        1: 'W Top 20% zawodników z największą liczbą sprintów na 90 minut. Świetna wydolność w powtarzalnych wysiłkach szybkościowych'
      },
      Acceleration1: {
        1: 'Zdolność do zmiany tempa wyraźnie poniżej średniej; wykonuje bardzo niewiele eksplozywnych przyspieszeń'
      },
      Acceleration2: {
        1: 'Parametry przyspieszenia poniżej średniej względem podobnych graczy; ograniczona częstotliwość krótkich zrywów'
      },
      Acceleration3: {
        1: 'Rejestruje przyzwoitą liczbę przyspieszeń, blisko średniej ligowej. Zmiany tempa nie wyróżniają się, ale mieszczą się w normie'
      },
      Acceleration4: {
        1: 'Wykazuje dużą zdolność do szybkiego i powtarzalnego przyspieszania; wskaźniki wyraźnie powyżej średniej, z częstymi krótkimi zrywami'
      },
      Acceleration5: {
        1: 'W Top 20% najbardziej eksplozywnych zawodników pod względem powtarzalnych przyspieszeń; bardzo wysokie wartości szybkich startów i zmian tempa'
      },
      Speed1: {
        1: 'Prawdopodobnie fizycznie wolniejszy zawodnik lub oszczędzający wysiłki o wysokiej intensywności'
      },
      Speed2: {
        1: 'Maksymalne prędkości nieznacznie poniżej średniej konkurencyjnej'
      },
      Speed3: {
        1: 'Utrzymuje przeciętne wartości prędkości maksymalnej w trakcie meczu'
      },
      Speed4: {
        1: 'Często osiąga wysokie prędkości, co sugeruje szybkość i siłę'
      },
      Speed5: {
        1: 'Osiąga bardzo wysokie prędkości maksymalne; zawodnik robiący różnicę tempem'
      },
      LineBreakingCarries1: {
        1: 'Rzadko przełamuje linie poprzez prowadzenie piłki. Brakuje inicjatywy w progresji z piłką'
      },
      LineBreakingCarries2: {
        1: 'Zdarzają się prowadzenia przełamujące linie, lecz bez większej regularności'
      },
      LineBreakingCarries3: {
        1: 'Notuje umiarkowaną liczbę udanych prowadzeń przełamujących linie'
      },
      LineBreakingCarries4: {
        1: 'Wnosi wkład w budowę akcji, często prowadząc piłkę za linie i wspierając progresję'
      },
      LineBreakingCarries5: {
        1: 'Prawdziwy specjalista od prowadzenia piłki: regularnie i w dużej liczbie przełamuje linie'
      },
      LineBreakingActions1: {
        1: 'Rejestruje bardzo niewiele akcji przełamujących linie (podań i prowadzeń). Rzadko ryzykuje'
      },
      LineBreakingActions2: {
        1: 'Wykonuje pewne działania progresywne (podania i prowadzenia), lecz rzadko. Często gra horyzontalnie'
      },
      LineBreakingActions3: {
        1: 'Regularnie łączy podania i prowadzenia przełamujące linie. Wnosi wkład w progresję'
      },
      LineBreakingActions4: {
        1: 'Techniczny i inteligentny, aby często wykonywać akcje (podania i prowadzenia) przełamujące linie rywala'
      },
      LineBreakingActions5: {
        1: 'Prawdziwy specjalista od progresji. Ma duży wpływ na zespół, stale przełamując linie podaniami i prowadzeniami'
      },
      OffBallRuns1: {
        1: 'Zawodnik wykonuje bardzo niewiele intencjonalnych ruchów bez piłki, oferując ograniczone wsparcie fazie ataku. Jego biegi bez piłki rzadko tworzą przestrzeń, zaburzają linie obrony lub poprawiają koordynację zespołu w posiadaniu'
      },
      OffBallRuns2: {
        1: 'Ruch bez piłki poniżej średniej; okazjonalnie wspiera atak, lecz brakuje regularności w timingu, kierunku i zamiarze taktycznym. Biegi mają ograniczony wpływ na otwieranie przestrzeni i strukturę ataku'
      },
      OffBallRuns3: {
        1: 'Średni poziom intencjonalnych biegów bez piłki; stabilny wkład w fazę ataku. Ruchy na ogół w dobrym timingu i funkcjonalne, tworzące przestrzeń i wspierające grę zespołu'
      },
      OffBallRuns4: {
        1: 'Ponadprzeciętna aktywność bez piłki; często wykonuje intencjonalne biegi zaburzające struktury defensywne, tworzące opcje podań i otwierające przestrzenie ataku. Wzorce ruchu znacząco wspierają koordynację w posiadaniu'
      },
      OffBallRuns5: {
        1: 'Wyróżnia się intencjonalnymi ruchami bez piłki, konsekwentnie antycypując grę i wykonując inteligentne biegi maksymalizujące okazje. Timing, ustawienie i orientacja przestrzenna tworzą stałe zagrożenie i płynność gry w posiadaniu'
      },
      OverMaxValue: {
        1: 'Posiada ekstremalną umiejętność w over_max_metric_name, z wynikiem powyżej wartości maksymalnej, co plasuje go w tym aspekcie w top 10% zawodników top 5 lig'
      },
      OverAverageSeason: {
        1: 'Jeśli chodzi o over_average_metric_name, jest powyżej średniej ligi league_name (over_average_metric_value vs average_metric_value)',
        2: 'Porównując jego liczby z ligą league_name, w over_average_metric_name wypada powyżej średniej (over_average_metric_value vs average_metric_value)'
      },
      UnderMinValue: {
        1: 'Jeśli chodzi o under_min_metric_name, powinien znacząco się poprawić, ponieważ znajduje się w najniższym percent_metric_name top 5 lig'
      },
      Over70Percent: {
        1: ', szczególnie wyróżniając się w over_70_metric_name z wynikiem over_70_metric_value na 90 minut, odpowiednio',
        2: ', powyżej 70% w over_70_metric_name z wynikiem over_70_metric_value na 90 minut, odpowiednio',
        3: ', wykonując znakomitą pracę w over_70_metric_name z wynikiem over_70_metric_value na 90 minut, odpowiednio'
      },
      Under30Percent: {
        1: ', musi mocniej popracować nad under_30_metric_name, ponieważ przy under_30_metric_value na 90 minut jego wyniki są niskie, odpowiednio',
        2: ', wymaga znacznej poprawy w under_30_metric_name, gdyż przy under_30_metric_value na 90 minut wyniki są poniżej oczekiwań, odpowiednio',
        3: ', w zakresie under_30_metric_name przy under_30_metric_value na 90 minut powinien bardziej się postarać, by poprawić liczby, odpowiednio'
      },
      OverAverageSeasonMoreThanOne: {
        1: 'Warto podkreślić, że jego wyniki przewyższają średnią ligi league_name w '
      },
      OverAverageStats: {
        1: 'over_average_metric_name (over_average_metric_value vs average_metric_value średnio)'
      },
      Over70PercentIndividualPressure: {
        1: ', wykonując bardzo dobry indywidualny pressing w celu odzyskania piłki',
        2: ', wysoka presja na rywalu, aby odzyskać piłkę'
      },
      Under30PercentIndividualPressure: {
        1: ', musi zintensyfikować pressing, aby częściej odzyskiwać piłkę',
        2: ', powinien włożyć więcej wysiłku w wywieranie presji na rywalu'
      }
    },
    himSelf: 'sam',
    ownSeason: 'Własny sezon',
    minMaxTooltip: 'Dopasuj minimalne i maksymalne wartości radaru',
    infoMessage3: 'This option is only available from matchday 6'
  },
  login: {
    login: 'Logowanie',
    latestBlogPosts: 'Najnowsze wpisy na blogu',
    signIn: 'Zaloguj się',
    username: 'Nazwa użytkownika',
    password: 'Hasło',
    passwordForgotten: 'Zapomniane hasło',
    signUp: 'Zarejestruj się',
    enter: 'Wejdź',
    forceTitle: 'Konto w użyciu',
    forceMessage: 'Konto jest już zalogowane na innym urządzeniu. Czy chcesz je wylogować i połączyć na tym urządzeniu?',
    forgotMyPassword: 'Zapomniałem hasła',
    firstLogin: 'Pierwsze logowanie',
    firstLoginMessage: 'Ze względów bezpieczeństwa przy pierwszym logowaniu musisz ustawić nowe hasło oraz wybrać preferowany język aplikacji',
    firstLoginOverview: 'Oto przegląd Twojego konta, lig i produktów, do których masz dostęp.',
    passwordConfirmation: 'Potwierdzenie hasła',
    forgotPasswordMessage: 'Wpisz swój e‑mail; jeśli istnieje ważne konto powiązane z tym adresem, otrzymasz w skrzynce odbiorczej dalsze kroki resetu hasła',
    resetPassword: 'Zresetuj hasło',
    resetPasswordLinkInvalid: 'Ten link jest nieprawidłowy lub wygasł. Poproś o nowe zresetowanie hasła na stronie logowania.',
    skipSettings: 'Pomiń ustawienia',
    contact: 'Kontakt',
    cookiesText: 'Ta strona używa plików cookie Google w celu świadczenia usług oraz analizowania ruchu, aby zapewnić jakość usług, generować statystyki użycia i wykrywać oraz rozwiązywać nadużycia.',
    contactUs: 'Skontaktuj się z nami',
    newsTitle: 'Nowość: Oceny fizyczne!',
    newsText: 'Dodaliśmy dwie nowe oceny wydajności fizycznej obok naszej pierwotnej oceny opartej na danych zdarzeniowych: <b>Ocenę wytrzymałości</b> oraz <b>Ocenę szybkości i mocy</b>.<br> Wytrzymałość wyróżnia zawodników, którzy regularnie pokrywają duży obszar boiska i utrzymują wysokie obciążenie, natomiast Szybkość i moc koncentruje się na prędkości maksymalnej, sprintach i eksplozywnych przyspieszeniach.'
  },
  settings: {
    pageSubtitle: 'Skonfiguruj działanie aplikacji',
    language: 'Język',
    availableLeagues: 'Dostępne ligi',
    availableSeasons: 'Dostępne sezony',
    availableProducts: 'Dostępne produkty',
    organization: 'Firma',
    changePassword: 'Zmień hasło',
    seasonTemplates: 'Szablony sezonów',
    seasonTemplatesSubtitle: 'Twórz własne szablony sezonu, dostępne później do wyboru w Rankingu zawodników i Skaucie zawodników',
    templateName: 'Nazwa szablonu',
    selectTemplate: 'Wybierz istniejący szablon do edycji',
    radarDefault: 'Domyślny radar',
    default: 'Domyślny',
    tabs: {
      options: 'Opcje',
      templates: 'Szablony',
      availableLeagues: 'Dostępne ligi',
      contactData: 'Dane kontaktowe GBE'
    },
    contactData: {
      userDetails: 'Dane użytkownika',
      firstName: 'Imię',
      lastName: 'Nazwisko',
      contactDetails: 'Dane kontaktowe dla GBE',
      name: 'Imię i nazwisko',
      phone: 'Telefon',
      mobile: 'Telefon komórkowy',
      email: 'E‑mail',
      representativeDetails: 'Dane przedstawiciela dla GBE'
    },
    currency: 'Waluta',
    fieldPreferences: 'Preferencje boiska',
    visualizationsPreferences: 'Preferencje wizualizacji',
    fieldColor: 'Kolor boiska',
    fieldColors: {
      green: 'Zielony',
      blue: 'Niebieski',
      white: 'Biały',
      black: 'Czarny',
      grey: 'Szary'
    },
    defaultPlayerVisualization: 'Domyślna wizualizacja zawodnika',
    appPreferences: 'Preferencje aplikacji',
    darkMode: 'Tryb ciemny',
    showTour: 'Pokaż przewodnik',
    customStats: 'Własne statystyki',
    radarTemplates: 'Szablony radaru',
    radarTemplatesSubtitle: 'Twórz własne szablony metryk, dostępne później w Radarach i Rankingu',
    radarCategories: {
      Custom1: 'Niestandardowy 1',
      Custom2: 'Niestandardowy 2',
      Custom3: 'Niestandardowy 3',
      Custom4: 'Niestandardowy 4',
      Custom5: 'Niestandardowy 5',
      Custom6: 'Niestandardowy 6',
      Physical: 'Fizyczne',
      CustomPhysical1: 'Niestandardowe fizyczne 1',
      CustomPhysical2: 'Niestandardowe fizyczne 2',
      CustomPhysical3: 'Niestandardowe fizyczne 3',
      CustomPhysical4: 'Niestandardowe fizyczne 4',
      CustomPhysical5: 'Niestandardowe fizyczne 5',
      CustomPhysical6: 'Niestandardowe fizyczne 6'
    },
    templateRemoveTitle: 'Usuń szablon',
    templateRemoveMsg: 'Czy chcesz usunąć ten szablon?',
    templateEditTitle: 'Zapisz szablon',
    templateEditMsg: 'Istnieje niezapisany szablon. Czy chcesz go zapisać przed wczytaniem innego szablonu?',
    category: 'Kategoria',
    playerRadar: 'Radar zawodnika',
    teamRadar: 'Radar zespołu',
    statsAlert: 'Aby zapisać, dodaj co najmniej jedną statystykę',
    recommended: 'Rekomendowane',
    warning: 'Są pozycje, które osiągnęły maksymalną liczbę dozwolonych radarów. Usuń lub edytuj któryś z szablonów',
    fieldPositions: {
      default: 'Driblab',
      fifa: 'FIFA',
      spanish: 'Hiszpański',
      numeric: 'Numeryczny'
    },
    showMediaMode: 'Pokaż tryb medialny',
    statTemplates: 'Szablony statystyk',
    statTemplatesSubtitle: 'Stwórz własny szablon statystyk, wybierając spośród wielu metryk',
    ratingFormat: {
      ratingFormat: 'Format oceny',
      numbers: 'Takty muzyczne',
      letters: 'Litery A–F'
    }
  },
  playerDetail: {
    passport: 'Paszport',
    secondPassport: 'Drugi paszport',
    age: 'Wiek',
    dateOfBirth: 'Data urodzenia',
    height: 'Wzrost',
    weight: 'Waga',
    wage: 'Wynagrodzenie',
    history: 'Historia',
    positions: 'Pozycje',
    injuries: 'Kontuzje',
    transfers: 'Transfery',
    nationalTeam: 'Reprezentacja',
    addFavorite: 'Dodaj do ulubionych',
    removeFavorite: 'Usuń z ulubionych',
    contractEnd: 'Koniec kontraktu',
    yearsOld: ' lat',
    playerAvailability: 'Dostępność',
    playerUsage: 'Rozegrane minuty',
    usage: 'Użycie',
    addToCollection: 'Dodaj do kolekcji',
    performance: 'Występy',
    info: 'Informacje',
    career: 'Kariera',
    playerStyle: 'Styl zawodnika',
    radar: 'Radar',
    finishingMap: 'Mapa wykończeń',
    threatMap: 'Mapa zagrożenia',
    keyPassMap: 'Mapa kluczowych podań',
    beeswarm: 'Ranking',
    allGames: 'Wszystkie mecze',
    eventsMap: 'Mapa zdarzeń',
    lbpMap: 'Przejścia łamania linii',
    obpMap: 'Nacisk na piłkę',
    pupMap: 'Przechodzi pod presją',
    obrMap: 'Wpływy na bale',
    fullName: 'Imię i nazwisko',
    academy: 'Akademia',
    name: 'Imię',
    lastName: 'Nazwisko',
    playerAvailabilityLong: '% sezonu bez kontuzji lub zawieszeń',
    playerUsageLong: 'Rozegrane minuty',
    playerAvailability1: 'meczy bez kontuzji lub zawieszeń',
    playerAvailability2: 'mecze w tym sezonie',
    playerUsage1: 'rozegrane minuty',
    playerUsage2: 'łączna liczba minut zespołu',
    notMinutesThisSeason: 'Nie rozegrał minut w tym sezonie',
    seasonPlaceholder: 'Brak aktywnego sezonu',
    inactivePlayer: 'Nieaktywny zawodnik',
    inactivePlayerMessage: 'Jeśli potrzebujesz więcej informacji, możesz poprosić o raport',
    goRequest: 'Przejdź do prośby',
    warningMinutes: 'Uwaga: mniej niż 450 minut – analiza może być niereprezentatywna',
    scoreWarningMinutes: 'Zawodnicy z co najmniej 450 minutami rozegranymi łącznie',
    pdScoreWarningMinutes: 'Zawodnicy z co najmniej 450 minutami rozegranymi łącznie (minimum 60 minut na mecz)',
    warningSeasonGames: 'Sezon ma mniej niż 5 rozegranych meczów, więc Min i Max to \'Top 5 lig\'',
    warningStatsRemoved: 'Niektóre statystyki nie są pokazane, ponieważ nie są dostępne dla wybranego sezonu',
    warningBeeswarm: 'Zawodnik niewyświetlany, ponieważ brak danych dla tej statystyki w wybranym sezonie',
    warningPlayersZeroValue: 'Nie pokazujemy {x} zawodników z wartością 0 ',
    onlyPlayersThatFit: 'Tylko zawodnicy pasujący do szablonu radaru',
    gamesPlayedNotEnough: 'Opcje wyłączone z powodu zbyt małej liczby rozegranych meczów',
    gbe: 'GBE',
    analysis: 'Analiza',
    documents: 'Dokumenty',
    rankDefensive: 'Defensywa',
    rankBallHandling: 'Panowanie nad piłką',
    rankGoal: 'Wkład bramkowy',
    rankXt: 'Zagrożenie',
    rankIndex: 'Indeks',
    visitHistory: 'Historia wizyt',
    placer: 'Boisko',
    touchesMap: 'Mapa kontaktów',
    heatMap: 'Mapa cieplna',
    ageProfile: 'Profil wiekowy',
    strongFoot: 'Silna noga',
    player: 'Zawodnik',
    outOf: 'z',
    in: 'w',
    radius: 'Promień',
    blur: 'Rozmycie',
    careerTable: {
      nationalTeamCareer: 'Kariera w reprezentacji',
      nationalTeamCompetitions: 'Rozgrywki reprezentacyjne'
    },
    physicalProgression: 'Progresja fizyczna',
    gpi: 'Globalny Indeks Zawodnika',
    warningGPI: 'Dostępne tylko dla zawodników aktywnych w ligach ELO w ostatnich 30 dniach',
    diffGPI: 'Zmiana względem ostatniego meczu',
    rankingInTheWorld: '#{0} na świecie',
    rankingInTheLeague: '#{0} w {1}',
    max: 'Maks',
    gpiChart: 'Wykres oparty na wartości Global Player Index z ostatnich {0} meczów',
    percentileRange: 'Percentyle {0} do {1}',
    months: 'miesiące',
    month: 'miesiąc',
    contractExpOver4Years: 'Umowa wygasa za',
    contractExpSoon: 'Umowa wkrótce wygaśnie',
    contractFinalYear: 'Ostatni rok umowy',
    freeAgent: 'Wolny agent',
    gpiDescription: 'Global Player Index (GPI) to ustandaryzowany system oceny zawodników, który ocenia piłkarzy na podstawie siły ich drużyny, siły przeciwnika, występów w meczach i dostępności. Zainspirowany systemem ocen Elo, zapewnia, że ​​oceny graczy odzwierciedlają rzeczywiste środowisko konkurencyjne, a nie arbitralne wartości bazowe.',
    turnoversMap: 'Mapa obrotów i odzyskań',
    playerProfiles: {
      24: {
        label: 'Libero',
        abbreviation: 'LIB'
      },
      25: {
        label: 'Box Goalkeeper',
        abbreviation: 'PAR'
      },
      26: {
        label: 'Line',
        abbreviation: 'LIN'
      },
      27: {
        label: 'Initiator',
        abbreviation: 'INI'
      },
      28: {
        label: 'Ball Carrier',
        abbreviation: 'CON'
      },
      29: {
        label: 'Anticipator',
        abbreviation: 'ANT'
      },
      30: {
        label: 'Cover',
        abbreviation: 'COB'
      },
      31: {
        label: 'Box Defender',
        abbreviation: 'DAR'
      },
      32: {
        label: 'Deep Forward',
        abbreviation: 'DPR'
      },
      33: {
        label: 'Inside',
        abbreviation: 'INT'
      },
      34: {
        label: 'Playmaker',
        abbreviation: 'PLY'
      },
      35: {
        label: 'Defensive',
        abbreviation: 'DEF'
      },
      36: {
        label: 'Central',
        abbreviation: 'CEN'
      },
      37: {
        label: 'Ball Winner',
        abbreviation: 'REC'
      },
      38: {
        label: 'Regista',
        abbreviation: 'REG'
      },
      39: {
        label: 'Pressing',
        abbreviation: 'PRS'
      },
      40: {
        label: 'Progressive',
        abbreviation: 'PRG'
      },
      41: {
        label: 'Box-to-box',
        abbreviation: 'B2B'
      },
      42: {
        label: 'Attacking Regista',
        abbreviation: 'ROF'
      },
      43: {
        label: 'Final Third',
        abbreviation: 'ULT'
      },
      44: {
        label: 'Workhorse',
        abbreviation: 'CAB'
      },
      45: {
        label: 'Late Runner',
        abbreviation: 'LLE'
      },
      46: {
        label: 'Difference Maker',
        abbreviation: 'DES'
      },
      47: {
        label: 'Inverted Scorer',
        abbreviation: 'ING'
      },
      48: {
        label: 'Creator',
        abbreviation: 'CRE'
      },
      49: {
        label: 'Deep Midfielder',
        abbreviation: 'MPR'
      },
      50: {
        label: 'Target',
        abbreviation: 'REF'
      },
      51: {
        label: 'Link-up',
        abbreviation: 'ASO'
      },
      52: {
        label: 'Runner',
        abbreviation: 'RUP'
      },
      53: {
        label: 'Finisher',
        abbreviation: 'FIN'
      }
    },
    sucessfulTouch: 'Udane dotknięcia',
    unsuccessfulTouch: 'Nieudane dotknięcia',
    showLegend: 'Pokaż legendę'
  },
  finishingMap: {
    typesOfShot: 'Rodzaje strzałów',
    shotStrategy: 'Strategia strzałów',
    strategiesCount: '{count} strategii',
    areas: 'Strefy',
    bodyPart: 'Część ciała',
    more: 'więcej',
    selectAll: 'Zaznacz wszystko',
    minutes: 'Minuty',
    circles: 'Okręgi',
    boxes: 'Mapa Cieplna pola karnego',
    lines: 'Linie',
    games: 'Mecze',
    perShot: 'na strzał',
    goal: 'Gol',
    missedShot: 'Strzał niecelny',
    savedShot: 'Strzał obroniony',
    shotOnPost: 'Strzał w słupek',
    missedChance: 'Zmarnowana okazja',
    openPlay: 'Akcja z gry',
    regularPlay: 'Gra regularna',
    fastBreak: 'Kontra',
    individualPlay: 'Akcja indywidualna',
    setPiece: 'Stały fragment',
    fromCorner: 'Po rogu',
    freeKick: 'Rzut wolny',
    indirectFreeKick: 'Rzut wolny pośredni',
    throwInSetPiece: 'Wyrzut z autu (SFG)',
    inBox: 'W polu karnym',
    goalArea: 'Pięć metrów',
    boxLeft: 'Pole karne lewa',
    boxCenter: 'Pole karne środek',
    boxRight: 'Pole karne prawa',
    outOfBox: 'Poza polem karnym',
    outBoxDeepLeft: 'Głęboko lewa poza polem',
    outBoxDeepRight: 'Głęboko prawa poza polem',
    outBoxLeft: 'Poza polem lewa',
    outBoxCentreLeft: 'Poza polem lewa-środek',
    outBoxCentre: 'Poza polem środek',
    outBoxCentreRight: 'Poza polem prawa-środek',
    outBoxRight: 'Poza polem prawa',
    left35: '+35 Lewa',
    centreLeft35: '+35 Lewy środek',
    centre35: '+35 Środek',
    centreRight35: '+35 Prawy środek',
    right35: '+35 Prawa',
    head: 'Głowa',
    rightFooted: 'Prawa noga',
    leftFooted: 'Lewa noga',
    otherBodyPart: 'Inna część ciała',
    chart: {
      shots: 'Strzały',
      xGPerShot: 'xG na strzał',
      exceptionTextPenaltyGoals: '* Rzuty karne = 0.765 xG',
      exceptionTextGKPenaltyGoals: '* Rzuty karne = 0.765 xGOT',
      exceptionTextOwnGoals: '* Bramki samobójcze nieuwzględnione',
      og: 'OG',
      penaltiesExcluded: 'Rzuty karne wyłączone',
      ownGoalsExcluded: 'Samobóje wyłączone',
      sumOfxG: 'Suma xG',
      exceptionShotsOutOfRange: '* Strzały poza zakresem niewyświetlane'
    },
    inGoal: 'W bramce',
    outOfGoal: 'Poza bramką',
    highLeft: 'Góra lewa',
    highCenter: 'Góra środek',
    highRight: 'Góra prawa',
    lowLeft: 'Dół lewa',
    lowCenter: 'Dół środek',
    lowRight: 'Dół prawa',
    outHighLeft: 'Poza bramką góra lewa',
    high: 'Poza bramką góra środek',
    outHighRight: 'Poza bramką góra prawa',
    closeHighLeft: 'Blisko góra lewa',
    closeHigh: 'Blisko góra środek',
    closeHighRight: 'Blisko góra prawa',
    closeLeft: 'Blisko dół lewa',
    closeRight: 'Blisko dół prawa',
    finishingTable: 'Tabela wykończeń',
    onGoal: 'W światło bramki',
    distributionFilters: 'Filtry dystrybucji',
    penalty: 'Rzut karny',
    penaltyShootout: 'Rzuty karne (seria)',
    onlyPercentage: 'Pokaż procenty',
    showAll: 'Pokaż wszystko',
    chanceMissed: 'Szansa stracona'
  },
  keyPassMap: {
    chart: {
      keyPasses: 'Kluczowe podania',
      xAPerPass: 'xA na podanie',
      xAOpenPlay: 'xA z akcji',
      xASetPiece: 'xA ze stałych fragmentów'
    }
  },
  beeswarm: {
    template: 'Szablon',
    templates: {
      Goalkeeper: 'Bramkarz',
      Defender: 'Obrońca',
      'Full-Back': 'Boczny obrońca',
      FullBack: 'Boczny obrońca',
      'Wing-Back': 'Wahadłowy',
      WingBack: 'Wahadłowy',
      Midfielder: 'Pomocnik',
      AttackingMidfielder: 'Ofensywny pomocnik',
      Winger: 'Skrzydłowy',
      Forward: 'Napastnik',
      Physical: 'Fizyczne'
    },
    compareWith: 'Porównaj z',
    highlightPlayersOf: 'Wyróżnij zawodników z',
    highlightPlayers: 'Wyróżnij zawodników',
    per90: 'Dane na 90 minut',
    highlightTeams: 'Wyróżnij zespoły',
    filterTeams: 'Filtruj zespoły',
    warningZeros: 'Tylko dla statystyk nieodwróconych'
  },
  collections: {
    newCollection: 'Nowa kolekcja',
    editCollection: 'Edytuj kolekcję',
    name: 'Nazwa',
    visibility: 'Widoczność',
    privacity: {
      publicTitle: 'Publiczna',
      publicDescription: 'Widoczna dla Ciebie i Twojego klubu',
      privateTitle: 'Prywatna',
      privateDescription: 'Widoczna tylko dla Ciebie',
      supervisedTitle: 'Nadzorowana',
      supervisedDescription: 'Widoczna dla Ciebie i Twojego przełożonego'
    },
    addSuccess: 'Pomyślnie dodano',
    createAddSuccess: 'Utworzono i dodano pomyślnie',
    editSuccess: 'Zaktualizowano pomyślnie',
    deleteSuccess: 'Usunięto pomyślnie',
    title: 'Kolekcje zawodników',
    publics: 'Publiczne',
    privates: 'Prywatne',
    supervised: 'Nadzorowane',
    totalMarketValue: 'Łączna wartość rynkowa',
    avgMarketValue: 'Średnia wartość rynkowa',
    avgAge: 'Średni wiek',
    searchBarPlaceholder: 'Aby dodać do kolekcji, wyszukaj i wybierz zawodników',
    deleteCollection: 'Usuń kolekcję',
    deleteCollectionMessage: 'Kolekcja zostanie usunięta. Czy na pewno?',
    removePlayer: 'Usuń zawodnika',
    removePlayerMessage: 'Zawodnik zostanie usunięty z kolekcji. Czy na pewno?',
    subtitle: 'Organizuj skauting',
    notExitingTemplate: 'Brak jeszcze szablonów'
  },
  searchbar: {
    placeholder: 'Wpisz, aby szukać (np. `david arsenal`)',
    players: 'Zawodnicy',
    teams: 'Zespoły',
    games: 'Mecze',
    leagues: 'Ligi',
    explore: 'Zobacz więcej wyników',
    placeholderNoResults: 'Brak wyników dla szablonu',
    teamPlaceholder: 'Aby porównać zespół, wyszukaj i wybierz go'
  },
  favorites: {
    showOnly: 'Pokaż tylko',
    selfFavorites: 'Moje ulubione',
    clubFavorites: 'Ulubione klubu',
    contractExpiration: 'Wygaśnięcie kontraktu',
    groupBy: 'Grupuj wg',
    noGrouped: 'Brak',
    maxSelection: 'Można wybrać tylko',
    selectAtleastOne: 'Wybierz co najmniej jednego',
    comparePlayers: 'Porównaj zawodników',
    selectedPlayers: 'zawodników wybrano',
    subtitle: 'Zarządzaj swoimi ulubionymi',
    generateXlsx: 'Generuj XLSX',
    generating: 'Generowanie...',
    subscribed: 'Subskrybowano',
    subscribedTooltip: 'Zasubskrybuj, aby otrzymać e‑mail po rozegraniu meczu',
    deleteSelected: 'Usuń wybrane'
  },
  expiration: {
    summer: 'Lato',
    winter: 'Zima'
  },
  positions: {
    noposition: 'Brak pozycji',
    goalkeeper: 'Bramkarz',
    goalkeepers: 'Bramkarze',
    defender: 'Obrońca',
    defenders: 'Obrońcy',
    defenses: 'Obrońcy',
    fullback: 'Boczny obrońca',
    fullbacks: 'Boczni obrońcy',
    midfielder: 'Pomocnik',
    midfielders: 'Pomocnicy',
    winger: 'Skrzydłowy',
    wingers: 'Skrzydłowi',
    forward: 'Napastnik',
    forwards: 'Napastnicy',
    wingback: 'Wahadłowy',
    wingbacks: 'Wahadłowi'
  },
  dPos: {
    1: {
      name: 'Bramkarz',
      alias: ''
    },
    2: {
      name: 'Prawy boczny obrońca',
      alias: 'RFB'
    },
    3: {
      name: 'Prawy środkowy obrońca',
      alias: 'RCB'
    },
    4: {
      name: 'Lewy środkowy obrońca',
      alias: 'LCB'
    },
    5: {
      name: 'Lewy boczny obrońca',
      alias: 'LFB'
    },
    6: {
      name: 'Defensywny pomocnik',
      alias: 'DM'
    },
    7: {
      name: 'Prawy skrzydłowy',
      alias: 'RW'
    },
    8: {
      name: 'Środkowy pomocnik',
      alias: 'CM'
    },
    9: {
      name: 'Napastnik',
      alias: 'ST'
    },
    10: {
      name: 'Ofensywny pomocnik',
      alias: 'AM'
    },
    11: {
      name: 'Lewy skrzydłowy',
      alias: 'LW'
    }
  },
  charts: {
    seasonsCompareSelectLabel: 'Porównaj z',
    lastSeasonSelectText: 'Poprzedni sezon',
    lastAndCurrentSeasonSelectText: 'Poprzedni + bieżący sezon',
    currentSeasonSelectText: 'Bieżący sezon',
    lastNgamesSelectText: 'Ostatnie {x} meczów',
    npgVsXGTitle: 'Gole bez karnych vs xG',
    totalXGLabel: 'Suma xG',
    xGLabel: 'xG',
    totalNPGLabel: 'Suma goli bez karnych',
    xGAgainstvsNPGAgainstTitle: 'xG przeciw vs gole bez karnych przeciw',
    totalXGAgainstLabel: 'Suma xG przeciw',
    xGAgainstLabel: 'xG przeciw',
    totalNPGAgainstLabel: 'Suma goli bez karnych przeciw',
    xGvsxGAgainstTitle: 'xG vs xG przeciw',
    pointsVsXPointsTitle: 'Punkty vs oczekiwane punkty',
    xTTitle: 'Przepływ gry',
    totalXPoints: 'Suma xP',
    totalPoints: 'Suma punktów',
    requestedReports: 'Zgłoszone raporty',
    playersScouted: 'Zeskanowani zawodnicy',
    performanceVSAverageChart: 'Występ vs średnia',
    perPositions: 'Według pozycji',
    perLeagues: 'Według lig',
    perMonths: 'Według miesięcy',
    perClients: 'Według klientów',
    ofPreposition: 'z',
    idJChartTitle: 'Inicjatywa w grze',
    idJChartLabel: 'Indeks GI',
    vJOChartTitle: 'Wolumen gry ofensywnej',
    vJOChartLabel: 'Indeks OGV',
    preJOChartTitle: 'Precyzja gry ofensywnej',
    preJOChartLabel: 'Indeks OGPre',
    proJOChartTitle: 'Progresja gry ofensywnej',
    proJOChartLabel: 'Indeks OGPro',
    chart: 'Wykres',
    table: 'Tabela',
    showLeaguesWithAtLeast: 'Pokaż ligi z co najmniej',
    playersScoutedSuffix: 'zeskanowanych zawodników'
  },
  table: {
    history: {
      season: 'Sezon',
      team: 'Zespół',
      position: 'Pozycja',
      side: 'Strona',
      games: 'Mecze',
      minutes: 'Min',
      goals: 'NPG (G)',
      assists: 'A',
      yellowCards: 'ŻK',
      redCards: 'CK',
      gameLost: 'NB',
      gamesMissed: 'Mecze opuszczone',
      goalsReceived: 'NPGC (GC)'
    },
    injury: {
      season: 'Sezon',
      team: 'Zespół',
      injury: 'Kontuzja',
      dateFrom: 'Data początku',
      dateTo: 'Data końca',
      daysLost: 'Dni stracone',
      gamesLost: 'Mecze stracone',
      allInjuries: 'Wszystkie kontuzje'
    },
    transfers: {
      season: 'Sezon',
      date: 'Data',
      teamFrom: 'Zespół z',
      teamTo: 'Zespół do',
      marketValue: 'Wartość rynkowa',
      fee: 'Kwota',
      type: 'Typ'
    },
    caps: {
      team: 'Zespół',
      debut: 'Debiut',
      games: 'Mecze',
      goals: 'Gole',
      coachDuringDebut: 'Trener podczas debiutu',
      debutAge: 'Wiek debiutu'
    },
    roster: {
      country: 'Kraj',
      player: 'Zawodnik',
      positions: 'Pozycje',
      minutes: 'Minuty',
      games: 'Mecze',
      goals: 'Gole',
      assists: 'Asysty',
      cards: 'Kartki',
      gamesExplicit: 'Rozegrane mecze'
    },
    league: {
      title: 'Karta ligi',
      subtitle: 'Zagłęb się w ranking i statystyki ligi',
      team: 'Zespół',
      games: 'M',
      gamesExplicit: 'Rozegrane mecze',
      gamesRanking: 'M',
      gamesRankingExplicit: 'Rozegrane mecze',
      points: 'Pkt',
      pointsExplicit: 'Punkty',
      expectedPoints: 'xP',
      expectedPointsExplicit: 'Oczekiwane punkty',
      goalsScored: 'NPG',
      goalsScoredExplicit: 'Gole bez karnych',
      xG: 'xG',
      xGExplicit: 'Gole oczekiwane',
      goalsAgainst: 'NPGA',
      goalsAgainstExplicit: 'Gole bez karnych przeciw',
      xGAgainst: 'xGA',
      xGAgainstExplicit: 'Oczekiwane gole przeciw',
      xGAgainstDiff: 'Różn. xGA',
      xGAgainstDiffExplicit: 'Różnica oczekiwanych goli przeciw',
      form: 'Forma',
      sos: 'SoS',
      sosExplicit: 'Siła terminarza',
      sosHfa: 'SoS HFA',
      sosHfaExplicit: 'Atut własnego boiska',
      difficultyAboveAvg: 'Trudność powyżej średniej',
      differentGames: '* Różna liczba rozegranych meczów',
      berth: 'Miejsce'
    },
    usersOfClient: {
      userName: 'Nazwa',
      userRole: 'Użytkownik',
      devRole: 'Dev',
      adminRole: 'Admin',
      servicesRole: 'Usługi',
      xgRole: 'XG',
      radarRole: 'Radar',
      beeswarmRole: 'Ranking',
      elevenRole: 'Jedenastki',
      similarityRole: 'Podobieństwo',
      gameAnalysisRole: 'Analiza meczu',
      clientStatsRole: 'Statystyki klienta',
      created: 'Utworzono',
      type: 'Typ',
      logins: 'Logowania',
      lastLogin: 'Ostatnie logowanie',
      trialDate: 'Data testu'
    },
    clientLeagues: {
      league: 'Liga',
      area: 'Strefa',
      tier: 'Poziom',
      seasons: 'Sezony',
      currentMatchDay: 'Kolejka',
      regular: 'Seniorzy',
      youthLeague: 'Młodzież',
      clientActive: 'Aktywna',
      visibleLeagues: 'Widoczne ligi',
      male: 'Liga mężczyzn',
      female: 'Liga kobiet'
    },
    connections: {
      title: 'Najczęstsze połączenia',
      playerFrom: 'Od zawodnika',
      playerTo: 'Do zawodnika',
      passes: 'Podania',
      passesTooltip: 'Łączna liczba udanych podań',
      passesFinalThird: 'PF ⅓',
      passesFinalThirdTooltip: 'Podania do trzeciej tercji'
    },
    playerPassMapData: {
      title: 'Statystyki podań',
      player: 'Zawodnik',
      passes: 'Podania',
      passesPct: '% podań',
      xA: 'xA',
      xG: 'xG',
      xT: 'xThreat',
      playerTooltip: 'Imię i nazwisko zawodnika',
      passesTooltip: 'Łączna liczba podań',
      passesPctTooltip: '% udanych podań',
      xATooltip: 'Oczekiwane asysty',
      xGTooltip: 'Oczekiwane gole',
      xTTooltip: 'Oczekiwane zagrożenie'
    },
    playerAllGames: {
      gameDate: 'Data',
      game: 'Mecz',
      team: 'Zespół',
      positionsPlayed: 'Pozycje',
      minsPlayed: 'Minuty',
      gameActions: 'Akcje',
      gameDateTooltip: 'Data meczu',
      gameTooltip: 'Mecz',
      positionsPlayedTooltip: 'Rozegrane pozycje',
      minsPlayedTooltip: 'Rozegrane minuty',
      gameActionsTooltip: 'Gole, asysty, kartki',
      from: 'Początek',
      to: 'Koniec',
      goalText: 'Gol w',
      assistText: 'Asysta w',
      penaltyText: 'Rzut karny w',
      ownGoalText: 'Samobój w',
      yellowCardText: 'Żółta kartka w',
      secondYellowCardText: 'Druga żółta kartka w',
      redCardText: 'Czerwona kartka w',
      substitutionIN: 'Wejście w',
      substitutionOUT: 'Zejście w',
      suspendedText: 'Zawieszenie',
      Team: 'Sprzęt'
    },
    gameFlow: {
      phase: 'Faza ',
      mins: 'Minuty',
      team: 'Zespół',
      period: 'Okres',
      possession: '%Pos.',
      possessionTooltip: '% posiadania',
      xT: 'xThreat',
      xTTooltip: 'Oczekiwane zagrożenie',
      pft: 'PF ⅓',
      pftTooltip: 'Podania do trzeciej tercji',
      xG: 'xG',
      xGTooltip: 'Oczekiwane gole'
    }
  },
  game: {
    title: 'Karta meczu',
    subtitle: 'Zagłęb się w charakterystykę i statystyki meczu',
    header: {
      gameDetails: 'Szczegóły',
      gameStats: 'Statystyki',
      gameFinishingMap: 'Mapa wykończeń',
      gameKeyPassMap: 'Mapa kluczowych podań',
      gamePassMap: 'Mapa podań',
      gameThreat: 'Zagrożenie',
      gameFlow: 'Przepływ gry',
      gameAnalysis: 'Analiza meczu',
      gamePhysicalStats: 'Statystyki fizyczne',
      possessions: 'Posiadania',
      bench: 'Ławka',
      video: 'Skróty wideo',
      preGame: 'Przed meczem',
      postGame: 'Po meczu',
      areaCoverage: 'Pokrycie obszaru'
    },
    passMap: {
      typeOfPlay: 'Typ gry:',
      passes: 'Podania:',
      team: 'Zespół',
      minutes: 'Minuty:',
      select: 'Wybierz',
      all: 'Wszystko',
      attacking: 'Atak',
      defending: 'Obrona',
      forwards: 'Do przodu',
      backwards: 'Do tyłu',
      sideways: 'W bok',
      longBall: 'Długie podanie',
      successfullPasses: 'Udane podania',
      homeTeam: 'Gospodarze',
      awayTeam: 'Goście',
      passingMatrix: 'Macierz podań',
      passer: 'Podający',
      receiver: 'Odbierający',
      passOutcome: 'Wynik Podania',
      passDirection: 'Kierunek Podania',
      half: 'Połowa',
      offensive: 'Ofensywna',
      defensive: 'Defensywna',
      passingConnections: 'Połączenia podań',
      pitchView: 'Boisko',
      passSingular: 'Podanie',
      passPlural: 'Podania',
      playerLocation: 'Lokalizacja gracza',
      passLegend: 'Średnia pozycja dotykowa',
      minuteRange: 'Zakres minut'
    },
    stats: {
      summary: 'Podsumowanie',
      attacking: 'Atak',
      defending: 'Obrona',
      contribution: 'Wkład',
      possession: 'Posiadanie',
      expectedPoints: 'Oczekiwane punkty',
      directness: 'Bezpośredniość',
      ppda: 'PPDA',
      xg: 'xG',
      xG: 'xG',
      xGSetPiece: 'xG stałe fragmenty',
      xA: 'xA',
      xASetPiece: 'xA stałe fragmenty',
      xT: 'xT',
      xTSetPiece: 'xT stałe fragmenty',
      touchesInOppBox: 'Kontakty w polu karnym rywala',
      passesFinalThird: 'Podania do trzeciej tercji',
      interceptions: 'Przechwyty',
      recoveries: 'Odbiory',
      recoveriesOppHalf: 'Odbiory na połowie rywala',
      tackles: 'Wślizgi',
      tacklesWasDribbled: 'Wygrane pojedynki defensywne 1 na 1',
      fouls: 'Faule',
      yellowCards: 'Żółte kartki',
      redCards: 'Czerwone kartki',
      passes: 'Podania',
      passing: 'Skuteczność podań %',
      crosses: 'Dośrodkowania',
      crossing: 'Skuteczność dośrodkowań %',
      shots: 'Strzały',
      shotsOnTarget: 'Strzały celne',
      ppdaExplicit: 'Przepuszczone podania na akcję obronną',
      xgExplicit: 'Oczekiwane gole',
      xp: 'xP',
      ExpectedPassing: 'xP %',
      seasonAvg: 'Średnia rozgrywek',
      winChanceTooltip: 'Prawdopodobieństwo wygranej na podstawie wygenerowanego i straconego xG',
      drawChance: 'Remis',
      xgAgainst: 'xG przeciw',
      averagePossession: 'Posiadanie',
      averageShots: 'Liczba strzałów',
      averagexG: 'XG',
      fieldTilt: 'Przechył boiska',
      fieldTiltExplicit: 'Przechył boiska',
      recoveriesRate: 'Szybkość odzyskiwania',
      turnoversRate: 'Wskaźnik obrotu'
    },
    detail: {
      halfTime: 'Przerwa',
      overTime: 'Dogrywka',
      showStats: 'Pokaż statystyki',
      hideStats: 'Ukryj statystyki',
      bench: 'Ławka',
      showShotOptions: 'Pokaż opcje strzałów',
      hideShotOptions: 'Ukryj opcje strzałów',
      showPassOptions: 'Pokaż opcje podań',
      hidePassOptions: 'Ukryj opcje podań',
      endGame: 'Koniec meczu',
      penalties: 'Rzuty karne'
    },
    timeline: {
      events: {
        goal: 'Gol',
        goal_ownGoal: 'Samobój',
        goal_penalty: 'Gol z karnego',
        card: 'Kartka',
        card_yellowCard: 'Żółta kartka',
        card_secondYellowCard: 'Druga żółta kartka',
        card_redCard: 'Czerwona kartka',
        formationChange: 'Zmiana ustawienia',
        substitution: 'Zmiana',
        saveShot: 'Obroniony strzał',
        saveShot_penalty: 'Obroniony rzut karny',
        missedShot: 'Niecelny strzał',
        missedShot_penalty: 'Niestrzelony karny',
        shotOnPost: 'Strzał w słupek',
        shotOnPost_penalty: 'Słupek po karnym',
        drinksBreak_startDrinksBreak: 'Start Cooling Break',
        drinksBreak_endDrinksBreak: 'End Cooling Break',
        assist: 'Assist'
      },
      gameTimeline: 'Game Timeline'
    },
    gameFlow: {
      goalOf: 'Gol ',
      redCardTo: 'Czerwona kartka dla ',
      missedPenalty: 'Niestrzelony karny'
    },
    gameThreat: {
      typeOfPlay: 'Rodzaj akcji',
      regularPlay: 'Akcja z gry',
      setPiece: 'Stały fragment',
      setPiecePlay: 'Stały fragment',
      throwInSetPiecePlay: 'Wznowienie z autu',
      throwInPlay: 'Wznowienie z autu',
      gkThrow: 'Wyrzut bramkarza',
      gkKick: 'Wykop bramkarza',
      kickOff: 'Rozpoczęcie',
      actionEnding: 'Zakończenie akcji',
      pass: 'Podanie',
      shot: 'Strzał',
      foul: 'Faul',
      other: 'Inne',
      threat: 'Zagrożenie',
      legendSumOfXT: 'Suma xT',
      legendPass: 'Podanie',
      legendShot: 'Strzał',
      legendCarryAndAction: 'Prowadzenie i akcja',
      legendCarryAndPass: 'Prowadzenie i podanie',
      legendOnlyShowing: 'Pokazano tylko akcje indywidualne z xT > ',
      legendOnlyShowingPart1: 'Pokazano tylko akcje indywidualne',
      legendOnlyShowingPart2: 'z xT > ',
      legendOnlyShowingSetPiece: 'Pokazano tylko stałe fragmenty z xT > ',
      legendOnlyShowingOpenPlay: 'Pokazano tylko akcje z gry z xT > ',
      legendPlays: 'Akcje',
      legendPerPlay: 'na akcję',
      legendCarry: 'Prowadzenie',
      penaltyPlay: 'Karny',
      freeKickTakenPlay: 'Rzut wolny',
      cornerTakenPlay: 'Rzut rożny',
      fromCornerPlay: 'Rzut rożny',
      keeperThrowPlay: 'Wyrzut bramkarza',
      fastBreakPlay: 'Kontra',
      indirectPlay: 'Rzut pośredni',
      minutes: 'Minuty',
      games: 'Mecze',
      xT: 'xT',
      xTPer90: 'xT na 90\''
    },
    gameAnalysis: {
      next: 'Dalej',
      previous: 'Wstecz',
      phaseLabel: 'Faza',
      phasesLabel: 'Fazy',
      dot: '. ',
      comma: ', ',
      from: 'Od',
      to: 'Do',
      and: ' i ',
      steps: {
        finishingMapFullGame: 'Mapa wykończeń',
        keyPassMapFullGame: 'Mapa kluczowych podań',
        gameFlow: 'Przepływ gry',
        finishingMapPerPhases: 'Mapa wykończeń wg faz',
        keyPassMapPerPhases: 'Mapa kluczowych podań wg faz',
        passMapPerPhases: 'Mapa podań wg faz'
      },
      step1: {
        table: {
          draw: 'Remis',
          win: 'Wygrana',
          lose: 'Porażka',
          possession: 'Posiadanie',
          xP: 'Oczekiwane punkty',
          directness: 'Bezpośredniość',
          ppda: 'PPDA',
          xG: 'xG',
          xGOpenPlay: 'xG z akcji',
          xGSetPiece: 'xG stałe fragmenty',
          xA: 'xA',
          xAOpenPlay: 'xA z akcji'
        },
        text: {
          firstParagraph: {
            1: 'The map on the right displays the expected goals generated by home_team_name and away_team_name. The refilled circles are the shots that ended in goal. The size of the circles depends on the xG value of each shot. '
          },
          lastParagraph: {
            1: 'The probability percentage of a result and the number of expected points are calculated through shot simulation (100,000 simulations of the shots are carried out and the possibility of results and of getting points is evaluated in a predictive way). '
          },
          targetHighTeamXG: {
            1: 'target_team_name, as well as rival_team_name, managed to create a high volume of expected goals'
          },
          targetHighTeamOpenPlayXG: {
            1: 'In this game, most of target_team_name chances came from open plays'
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: 'In this game, most of target_team_name chances were originiated by open plays (unlike rival_team_name)'
          },
          targetHighTeamSetPieceXG: {
            1: 'In this game, most of target_team_name chances came from set piece plays'
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: 'In this game, most of target_team_name chances were originiated by set piece plays (unlike rival_team_name)'
          },
          targetHighTeamCornerXG: {
            1: 'In this game, most of target_team_name chances came from corner kicks'
          },
          targetLowTeamGoalConversion: {
            1: ' but the goal conversion was low'
          },
          dot: {
            1: '. '
          },
          targetHighTeamXGOPandSP: {
            1: 'target_team_name created a high volume of expected goals in both open plays and set pieces'
          },
          targetHighTeamGoalConversion: {
            1: ' also having a high goal conversion ratio. '
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: ', not being able to score any of the chances created'
          },
          targetLowTeamGoalConversionScoringGoals: {
            1: ' but created danger to score more goals'
          },
          targetHighTeamXGvsGameRival: {
            1: 'In this game, target_team_name generated more danger than rival_team_name'
          },
          targetLowTeamGoalConversionScoringGoals2: {
            1: ' and could have scored more goals. '
          },
          targetHighTeamXGZeroGoals: {
            1: ' but was not able to score any goals out of the chances created. '
          },
          targetHighTeamXGGoalDiff: {
            1: ' matching a winning chance of team_winning_chance according to our post-game simulation. '
          },
          startTargetHighTeamOpenPlayXG: {
            1: ' Most of the target_team_name chances came from open plays. '
          },
          startTargetHighTeamSetPieceXG: {
            1: ' Most of the target_team_name chances were originiated by set piece plays. '
          },
          startTargetHighTeamCornerXG: {
            1: ' Most of the chances came from corner kicks. '
          },
          targetSimilarTeamXG: {
            1: 'In this game, both teams generated a similar amount of danger to the opponent in terms of xG, '
          },
          targetSimilarTeamXGGoalDiff: {
            1: 'but target_team_name performed better at finalizing chances. '
          },
          targetLowTeamXGGoalDiff: {
            1: 'Regardless the result, target_team_name did not generate much danger to the opponent in terms of Expected Goals. '
          },
          targetLowTeamXGZeroGoalDiff: {
            1: 'target_team_name did not generate enough danger to the opponent in terms of Expected Goals to win the game'
          },
          rivalHighTeamXG: {
            1: 'and allowed rival_team_name to generate too much danger. '
          },
          rivalHighTeamXGGoalDiff: {
            1: ' With this creation, this is a game that target_team_name would only win team_winning_chance of the times according to our post-game simulation. '
          },
          targetHighTeamGoalConversion2: {
            1: ' having a high goal conversion ratio'
          },
          winningChance: {
            1: 'Given the number of shots and xG of both teams, target_team_name should have won this game team_winning_chance of the times. '
          },
          highPlayerXGManyShots: {
            1: 'It is interesting to note that player_name generated xg_value xG in shots_value shots'
          },
          highPlayerXGMoreThanOneGoal: {
            1: ' needing xg_value xG to score a goal. '
          },
          highPlayerXGOneGoal: {
            1: ' to score the goal. '
          },
          highPlayerXGAnyGoal: {
            1: ', although he was not able to score any goal. '
          },
          highPlayerXGNotManyShots: {
            1: 'It is worth mentioning that player_name generated xg_value xG in a few shots'
          },
          highManyPlayerXG: {
            1: 'It is interesting to note that player_name and player_name2 generated xg_value and xg_value2 <b>xG</b> respectively. '
          },
          highTeamXGPerShot: {
            1: 'Regarding the selection of shots taken by target_team_name, they were very good in terms of probability of becoming a goal, with an average xG per shot of xg_per_shot_value. '
          },
          highTeamXGPerShotVSGameRival: {
            1: 'The selection of shots of target_team_name was much better than rival_team_name, having an average of xg_per_shot_value xG per shot. '
          },
          xGTimesNotAfter70xG: {
            1: 'Despite the high xG generated, target_team_name had problems to create danger at the end of the game. '
          },
          xGTimesBefore25xG: {
            1: 'target_team_name created a lot of danger especially at the beginning of both halves. '
          },
          xGTimesAfter25xG: {
            1: 'target_team_name created a lot of danger especially at the end of both halves. '
          },
          xGTimesBefore25xGvsItself: {
            1: 'target_team_name created most of the danger at the beginning of the first half. '
          },
          xGTimesAfter25xGvsItself: {
            1: 'target_team_name created most of the danger at the end of the first half. '
          },
          xGTimesBefore70xGvsItself: {
            1: 'target_team_name created most of the danger at the beginning of the second half. '
          },
          xGTimesAfter70xGvsItself: {
            1: 'target_team_name created most of the danger at the end of the second half. '
          },
          xGTimesBefore25xG2: {
            1: 'target_team_name started the game very solid with chances that generated xg_value expected goals. '
          },
          xGTimesAfter25xG2: {
            1: 'target_team_name finished the first half of the game with chances that generated xg_value expected goals. '
          },
          xGTimesBefore70xG: {
            1: 'target_team_name came off the half-time break with chances that generated xg_value expected goals. '
          },
          xGTimesAfter70xG: {
            1: 'target_team_name finished the second half with chances that generated xg_value expected goals. '
          },
          xGTimesAfter70xGOverOneDotTwo: {
            1: 'target_team_name created a lot of danger at the end of the second half. '
          },
          xGTimesBefore70xGOverOneDotTwo: {
            1: 'target_team_name created a lot of danger at the beginning of the second half. '
          },
          xGTimesAfter25xGOverOneDotTwo: {
            1: 'target_team_name created a lot of danger at the end of the first half. '
          },
          xGTimesBefore25xGOverOneDotTwo: {
            1: 'target_team_name created a lot of danger at the beginning of the first half. '
          },
          xGTimesFirstHalfXGSecondHalfXGRival: {
            1: 'target_team_name generated most of its danger in the first half while rival_team_name did the same in the second half. '
          },
          xGTimesSecondHalfXGFirstHalfXGRival: {
            1: 'target_team_name generated most of its danger in the second half while rival_team_name did the same in the first half. '
          },
          xGTimesFirstHalfXGFirstHalfXGRival: {
            1: 'It is a game where most of the danger in terms of Expected Goals was generated during the first half. '
          },
          xGTimesSecondHalfXGSecondHalfXGRival: {
            1: 'It is a game where most of the danger in terms of Expected Goals was generated during the second half. '
          },
          xGTimesFirstHalfXG: {
            1: 'target_team_name managed to create most of the danger in the first half. '
          },
          xGTimesSecondHalfXG: {
            1: 'target_team_name managed to create most of the danger during the second half. '
          },
          xGTimesFirstHalfXGRival: {
            1: 'target_team_name allowed most of the danger in terms of Expected Goals in the first half. '
          },
          xGTimesSecondHalfXGRival: {
            1: 'target_team_name allowed most of the danger in terms of Expected Goals during the second half. '
          },
          highInBoxXG: {
            1: 'The shot map displays how most of the danger came from shots inside the box. '
          },
          highOutOfBoxXG: {
            1: 'It can be observed in the shot map that, in this game, target_team_name generated a lot of danger from outside the box. '
          },
          highInBoxXGRival: {
            1: 'We want to point out that, most of the danger conceded by target_team_name came from shots inside the box. '
          },
          highInBoxXGRival2: {
            1: ' It is also interesting to highlight that most of the danger conceded by target_team_name came from shots inside the box. '
          },
          highOutOfBoxXGRival: {
            1: 'target_team_name performed well avoiding danger inside the box. '
          },
          highTeamChancesHighPPDARival: {
            1: 'The lack of pressure of target_team_name, allowing ppda_value Passes per Defensive Action, was one of the keys for rival_team_name to create a high number of chances. '
          },
          lowPPDAWithGoalDiff: {
            1: 'target_team_name only allowed ppda_value Passes per Defensive Action being this one of the keys to victory. '
          },
          lowPPDA: {
            1: 'target_team_name did a great job at interrupting the plays of rival_team_name allowing only an average of ppda_value Passes per Defensive Action. '
          },
          highPossession: {
            1: 'target_team_name had the control of the ball with a possession_value of possession'
          },
          highPPDARival: {
            1: ' as well as a fluid distribution of the ball'
          },
          chancesCreated: {
            1: ', which allowed them to have a high number of open play chances (chances_value). '
          },
          chancesCreatedRival: {
            1: ', although rival_team_name was able to create a high number of open play chances (chances_value). '
          },
          xGPerShotRival: {
            1: ', although rival_team_name was able to create more dangerous chances with a xg_per_shot_value xG per Shot. '
          },
          winGame: {
            1: ' being one of the keys to win the game. '
          },
          notEnoughWinGame: {
            1: ' not being enough to win the game. '
          },
          goalsFromErrorsFirstGoal: {
            1: 'The first goal came from a mistake of player_error_name seized by player_name'
          },
          goalsFromErrorsFirstGoalFinalResult: {
            1: 'The first and only goal came from a mistake of player_error_name seized by player_name'
          },
          lastPhaseOfGame: {
            1: ' at the last phase of the game. '
          },
          goalsFromErrorsFinalResultGoalToLead: {
            1: 'The final goal to win the game came from a mistake of player_error_name that led to the goal of player_name. '
          },
          goalsFromErrorsFinalResultGoalToTie: {
            1: 'The final goal to tie the game came from a mistake of player_error_name that led to the goal of player_name. '
          },
          goalsFromErrorsGoalToTie: {
            1: 'An error from player_error_name led to a chance to tie the game for target_team_name. '
          },
          goalsFromErrorsGoalToLead: {
            1: 'target_team_name took the lead taking advantage of an error from player_error_name'
          },
          xGChance: {
            1: ' with a chance of xg_value xG. '
          },
          rivalGoalsFromErrorsFinalResultGoalToLead: {
            1: 'The final goal of rival_team_name to win the game came from a mistake of player_error_name that led to the goal of player_name. '
          },
          rivalGoalsFromErrorsGoalToTie: {
            1: 'An error from player_error_name led to a chance to tie the game for rival_team_name. '
          },
          rivalGoalsFromErrorsGoalToLead: {
            1: 'rival_team_name took the lead taking advantage of an error from player_error_name'
          },
          hugeChancesMissedOneScored: {
            1: 'target_team_name happened to score the only big chance that created during the game, that is the goal of player_name that we see in the xG map with an xG of xg_value. '
          },
          hugeChancesMissedMoreThanOneScored: {
            1: 'target_team_name happened to score all the big chances that created during the game'
          },
          hugeChancesMissedZeroGoalsOneChance: {
            1: 'player_name had the only great chance of target_team_name to score with an xG of xg_value. '
          },
          hugeChancesMissedZeroGoalsMoreChances: {
            1: 'target_team_name  was not able to score any of the chances_value chances above 40% of likelihood to become a goal. '
          },
          oneHugeChancesBeforeFirstGameGoal: {
            1: 'player_name had a great chance of xg_value xG to get ahead in the score. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoal: {
            1: 'target_team_name had chances_value chances with xG above 40% to get ahead in the score. '
          },
          moreThanOneBigChancesBeforeFirstGameGoal: {
            1: 'target_team_name had chances_value chances with high xG to get ahead in the score. '
          },
          shotOnPostBeforeFirstGameGoal: {
            1: 'player_name had a chance to get ahead in the score of xg_value xG that hit the post. '
          },
          beforeEndOfGame: {
            1: 'Before the end of the game, '
          },
          oneHugeChancesAfterFirstGameGoal: {
            1: 'player_name had a chance of xg_value xG to win the match. '
          },
          moreThanOneHugeChancesAfterFirstGameGoal: {
            1: 'target_team_name had chances_value chances with an xG above 40% to win the match. '
          },
          moreThanOneBigChancesAfterFirstGameGoal: {
            1: 'target_team_name had chances_value chances with high xG to win the match. '
          },
          oneHugeChancesBeforeFirstGameGoalRival: {
            1: 'player_name had a great chance of xg_value xG to get ahead in the score. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name had chances_value chances with xG above 40% to get ahead in the score. '
          },
          moreThanOneBigChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name had chances_value chances with high xG to get ahead in the score. '
          },
          shotOnPostBeforeFirstGameGoalRival: {
            1: 'player_name had a chance to get ahead in the score of xg_value xG that hit the post. '
          },
          bigChancesMissedWhenLosingByOne: {
            1: 'player_name had a chance of xg_value xG to tie the game with no luck. '
          },
          moreThanOneBigChancesMissedWhenLosingByOne: {
            1: 'target_team_name had chances_value chances to tie the game with a probability to score higher than 30%. '
          },
          shotOnPostWhenLosingByOne: {
            1: 'player_name had a chance of xg_value xG to tie the game that ended hitting the post. '
          }
        }
      },
      step2: {
        table: {
          draw: 'Remis',
          win: 'Wygrana',
          possession: 'Posiadanie',
          xP: 'Oczekiwane punkty',
          directness: 'Bezpośredniość',
          ppda: 'PPDA',
          xA: 'xA',
          xAOpenPlay: 'xA z akcji',
          xASetPiece: 'xA stałe fragmenty',
          chancesCreated: 'Stworzone okazje',
          shotsOnTarget: 'Strzały celne'
        },
        text: {
          firstParagraph: {
            1: 'Ten obraz pokazuje oczekiwane asysty <b style=\'color:home_color\'>home_team_name</b> i <b>away_team_name</b>.'
          },
          xAPerKeyPass: {
            1: ' xA na kluczowe podanie. '
          },
          keyPassesGeneratedFrom: {
            1: ', szczególnie kluczowe podania generowane z '
          },
          highTeamXAvsXG: {
            1: 'Jak pokazuje mapa xA, większość zagrożenia target_team_name wynika z akcji kombinacyjnych, a nie indywidualnych'
          },
          openPlay: {
            1: 'akcji'
          },
          setPiece: {
            1: 'stałych fragmentów'
          },
          cornerKicks: {
            1: 'ruchów rożnych'
          },
          combinationPlays: {
            1: 'akcji kombinacyjnych'
          },
          dot: {
            1: '. '
          },
          comma: {
            1: ', '
          },
          averageTeamXAvsXG: {
            1: 'W tym meczu target_team_name tworzył zagrożenie zarówno z akcji kombinacyjnych'
          },
          individualActions: {
            1: ' jak i działań indywidualnych. '
          },
          dangerFromIndividualActions: {
            1: 'W tym meczu większość zagrożenia target_team_name wynikała z działań indywidualnych.'
          },
          highTeamXAvsXGRival: {
            1: ' Szanse dopuszczone przez target_team_name wynikały z akcji kombinacyjnych, co pokazuje mapa xA.'
          },
          rivalStrongKeyPassesFrom: {
            1: ' rival_team_name był mocny w kluczowych podaniach z '
          },
          manyPlayerKeyPasses: {
            1: 'It is interesting to note that player_name created xa_value xA in key_passes key passes'
          },
          playerAssists: {
            1: ' needing xa_per_assist xA per assist.'
          },
          giveAssist: {
            1: ' to give the assist.'
          },
          noAssists: {
            1: ', although none of his passes ended up in an assist.'
          },
          highXANotManyShots: {
            1: 'It is interesting to note that player_name created xa_value xA in a few passes'
          },
          manyPlayersHighXA: {
            1: 'It is interesting to note that player_name and player_name2 generated xa_value and xa_value2 xA respectively.'
          },
          xATimes: {
            1: 'target_team_name generated most of its danger in the first half while rival_team_name did the same in the '
          },
          firstHalf: {
            1: ' first half. '
          },
          secondHalf: {
            1: ' second half. '
          },
          left: {
            1: 'left side '
          },
          center: {
            1: 'center '
          },
          right: {
            1: 'right side '
          },
          xAFirstHalfFirstHalfRival: {
            1: 'It is a game where most of the danger in terms of Expected Goals was generated during the '
          },
          xAFirstHalf: {
            1: 'target_team_name managed to create most of the danger in the '
          },
          xATimesXARival: {
            1: 'target_team_name allowed too much danger in terms of Expected Goals in the '
          },
          xASides: {
            1: ' Most of the danger of target_team_name was produced from the side_name (xa_value <b>xA</b>)'
          },
          xASidesRival: {
            1: 'while rival_team_name generated the majority of it from the side_name (xa_value <b>xA</b>)'
          },
          dangerCreationRival: {
            1: 'The creation of danger of rival_team_name came, especially, from the side_name (xa_value <b>xA</b>). '
          },
          speciallyEffective: {
            1: 'target_team_name was especially effective at '
          },
          xAPerChanceCreated: {
            1: ' with an average of xa_value'
          },
          speciallyEffectiveRival: {
            1: 'rival_team_name was especially effective at '
          }
        }
      },
      step3: {
        text: {
          chance: ' okazja',
          chances: ' okazje',
          goal: ' gol',
          goals: ' gole',
          home: 'gospodarz',
          away: 'gość',
          last: 'ostatnia',
          first: 'pierwsza',
          goalScorer: 'strzelec',
          goalScorers: 'strzelcy',
          lastPhase: 'Ostatnia faza meczu, ',
          phase: {
            1: 'W fazie phase_position tego meczu, '
          },
          moreXT: {
            1: '<b style=\'color:more_color\'>more_xt_team_name</b> wygenerował więcej oczekiwanego zagrożenia (<b style=\'color:more_color\'>more_xt_team_value xT</b>) niż <b style=\'color:less_color\'>less_xt_team_name</b> (<b style=\'color:less_color\'>less_xt_team_value xT</b>)'
          },
          sameTeamMoreMinutes: {
            1: 'i robił to dłużej w tym okresie (<b style=\'color:more_color\'>more_time_xt_minutes min</b> vs <b style=\'color:less_color\'>less_time_xt_minutes min</b> rywala)'
          },
          rivalTeamMoreMinutes: {
            1: 'jednak to rywal dłużej generował zagrożenie (<b style=\'color:more_color\'>more_time_xt_minutes min</b> vs <b style=\'color:less_color\'>less_time_xt_minutes min</b>) w tym okresie'
          },
          maxXTValue: {
            1: '<b style=\'color:max_color\'>max_xt_team_name</b> stworzył największe zagrożenie (<b style=\'color:max_color\'>max_xt_team_value xT</b>) w <b style=\'color:max_color\'>max_xt_team_minute\'</b>'
          },
          maxXTValueRival: {
            1: ', podczas gdy <b style=\'color:max_rival_color\'>max_xt_rival_team_name</b> największe zagrożenie (<b style=\'color:max_rival_color\'>max_xt_rival_team_value xT</b>) wygenerował w <b style=\'color:max_rival_color\'>max_xt_rival_team_minute\'</b>'
          },
          bothTeamsScoreButDraw: {
            1: 'Oba zespoły pokonały bramkarza rywala po <b>number_of_goals_each_team</b> razy. Gospodarze dzięki <b style=\'color:#3366FF\'>home_player_name_goals</b>, a goście dzięki <b>away_player_name_goals</b>'
          },
          oneTeamTakesTheLead: {
            1: 'W bramkach <b style=\'color:replace_color\'>goal_scored_team_name</b> był lepszy o <b style=\'color:replace_color\'>difference_number_of_goals</b>, pokonując bramkarza rywala; gole: <b style=\'color:replace_color\'>home_player_name_goals</b> jako goal_scorer_word'
          }
        }
      },
      step4: {
        table: {
          team: 'Zespół',
          period: 'Okres',
          possession: 'Pos.',
          ppda: 'PPDA',
          xGOpenPlay: 'xG OP',
          tooltip: {
            team: 'Zespół',
            period: 'Okres',
            possession: 'Posiadanie',
            ppda: 'Przepuszczone podania na akcję obronną',
            xGOpenPlay: 'xG z akcji'
          }
        },
        text: {
          clearly: 'wyraźnie',
          very: 'bardzo ',
          haveGotText1: 'zdobył tylko',
          haveGotText2: 'powinien był zdobyć więcej niż',
          gaveUpPoss: 'oddał posiadanie',
          lostPoss: 'stracił posiadanie piłki',
          too: 'zbyt ',
          possession: {
            1: 'W tej fazie meczu <b style=\'color:team_color\'>team_name</b> clearly_text kontrolował posiadanie piłki'
          },
          equalPossession: {
            1: 'W tej fazie nikt nie dominował – posiadanie było dość wyrównane, choć liczby pokazują, że <b style=\'color:team_color\'>team_name</b> minimalnie przeważał z posiadaniem <b style=\'color:team_color\'>possession_value%</b>'
          },
          lowPossessionHighPPDA: {
            1: '. <b style=\'color:target_team_color\'>target_team_name</b> słabym pressingiem pozwolił <b style=\'color:rival_team_color\'>rival_team_name</b> na <b style=\'color:target_team_color\'>ppda_value podań na akcję obronną</b>'
          },
          lowPossessionLowPPDA: {
            1: ', ale <b style=\'color:target_team_color\'>target_team_name</b> dobrze pressował przy posiadaniu rywala, z <b>PPDA</b> równym <b>ppda_value</b>'
          },
          highPossessionLowPPDA: {
            1: ' i mógł swobodnie grać dzięki very_textlow intensywności pressingu rywala'
          },
          highPossessionHighPPDA: {
            1: ' mimo że intensywność pressingu rival_team_name była very_texthigh'
          },
          highPossessionHighPFT: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> przy wysokim posiadaniu wykonał <b>pft_value</b> <b>podań w trzeciej tercji</b> boiska. '
          },
          highPossessionMidLowPFT: {
            1: 'Pomimo wysokiego posiadania, <b style=\'color:target_team_color\'>target_team_name</b> have_got_text <b>pft_value</b> <b>podań w trzeciej tercji</b>. '
          },
          lowPossessionHighPFT: {
            1: 'Choć <b style=\'color:target_team_color\'>target_team_name</b> possession_text w tej fazie, zdołał wykonać <b>pft_value</b> <b>podań w trzeciej tercji</b>. '
          },
          midPossessionHighPFT: {
            1: 'Wyrównane posiadanie w tej fazie nie przeszkodziło <b style=\'color:target_team_color\'>target_team_name</b> w wykonaniu <b>pft_value</b> <b>podań w trzeciej tercji</b>. '
          },
          highPFTHighTouchesIOB: {
            1: ' Oprócz kontroli gry w trzeciej tercji, <b style=\'color:target_team_color\'>target_team_name</b> często gościł w polu karnym rywala. '
          },
          highPFTLowTouchesIOB: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> kontrolował piłkę w trzeciej tercji, lecz rzadko wprowadzał ją w pole karne rywala'
          },
          highPFTMidTouchesIOB: {
            1: 'Biorąc pod uwagę liczbę <b>podań w trzeciej tercji</b>, <b style=\'color:target_team_color\'>target_team_name</b> powinien stworzyć więcej zagrożenia w polu karnym'
          },
          lowPFTHighTouchesIOB: {
            1: 'Choć <b style=\'color:target_team_color\'>target_team_name</b> nie wykonał wielu podań w trzeciej tercji, często docierał w pole karne rywala. '
          },
          midPFTHighTouchesIOB: {
            1: 'Przy tej liczbie podań w trzeciej tercji, <b style=\'color:target_team_color\'>target_team_name</b> wielokrotnie wchodził w pole karne. '
          },
          maxDirectness: {
            1: 'Warto odnotować, że w tej fazie <b style=\'color:max_dir_color\'>target_team_name</b> grał najbardziej bezpośrednio – <b>Directness</b> <b>directness_value</b>. '
          },
          maxXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> wygenerował więcej xG niż w innych fazach gry '
          },
          highXGFifthQuintile: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b> stworzył wysoki wolumen oczekiwanych goli'
          },
          highXG: {
            1: 'wygenerował dobry wolumen oczekiwanych goli'
          },
          highXGLowPossession: {
            1: ' mimo braku kontroli nad piłką'
          },
          highXGLowShots: {
            1: ' przy niewielkiej liczbie strzałów – <b>xG na strzał</b> <b>xg_per_shot_value</b>'
          },
          highXGLowXGPerShot: {
            1: ' choć xG na strzał było too_textlow. '
          },
          lowXGZeroXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> nie był w stanie wygenerować zagrożenia'
          },
          lowXGMinXG: {
            1: 'Pod względem generowania xG była to słaba faza dla <b style=\'color:target_team_color\'>target_team_name</b>'
          },
          lowXGFirstQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> wygenerował bardzo niski wolumen xG'
          },
          lowXGSecondQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> nie wygenerował zadowalającego wolumenu xG'
          },
          lowXGHighPossession: {
            1: ' mimo kontroli nad piłką. '
          },
          lowXGHighShots: {
            1: ' pomimo wielu strzałów'
          },
          lowXGHighPFT: {
            1: ' pomimo wykonania <b>pft_value</b> <b>podań w trzeciej tercji</b>. '
          },
          midXGQuintileMinXG: {
            1: 'Choć generowanie xG nie było złe, była to najsłabsza faza dla <b style=\'color:target_team_color\'>target_team_name</b> pod tym względem'
          },
          midXGQuintileMaxXG: {
            1: 'W tej fazie <b style=\'color:target_team_color\'>target_team_name</b> wygenerował najwyższe <b>xG (xg_value)</b>'
          }
        }
      },
      step5: {
        table: {
          team: 'Zespół',
          period: 'Okres',
          possession: 'Pos.',
          directness: 'Bezpośr.',
          passesFinalThird: 'PF ⅓',
          tooltip: {
            team: 'Zespół',
            period: 'Okres',
            possession: 'Posiadanie',
            directness: 'Bezpośredniość',
            passesFinalThird: 'Podania w trzeciej tercji'
          }
        },
        text: {
          last: 'ostatnia',
          goal: 'bramka',
          goals: 'bramki',
          chance: 'okazja',
          chances: 'okazje',
          first: 'pierwsza',
          homeTeam: 'gospodarze',
          awayTeam: 'goście',
          home: 'dom',
          away: 'wyjazd',
          clearly: 'wyraźnie',
          slightly: 'nieznacznie',
          firstOrLastPhase: {
            1: 'W fazie phase_position tego meczu, ',
            2: 'W okresie phase_position spotkania, '
          },
          phase: {
            1: 'W tym okresie meczu, '
          },
          bothZeroGoalsScored: {
            1: 'bez zmiany wyniku przez którąkolwiek z drużyn.'
          },
          equalGoalsScored: {
            1: 'strzelając po <b>number_goals</b>'
          },
          differentGoalsScored: {
            1: 'strzelając <b>number_goals</b>'
          },
          equalPossesion: {
            1: 'obie drużyny miały piłkę dokładnie przez <b>poss_value%</b> czasu'
          },
          morePossesion: {
            1: '<b style=\'color:more_color\'>more_poss_team_name</b> miał piłkę dłużej (<b style=\'color:more_color\'>more_poss_team_value%</b> czasu) niż <b style=\'color:less_color\'>less_poss_team_name</b> (<b style=\'color:less_color\'>less_poss_team_value%</b>)'
          },
          equalDirectness: {
            1: 'obie drużyny grały z taką samą bezpośredniością (<b>directness_value</b>)'
          },
          moreDirectnessSameTeam: {
            1: 'byli też bardziej bezpośredni: <b style=\'color:more_color\'>more_dir_team_value</b> vs <b style=\'color:less_color\'>less_dir_team_value</b>'
          },
          moreDirectnessDifferentTeam: {
            1: 'natomiast home_away grał bardziej bezpośrednio (<b style=\'color:more_color\'>more_dir_team_value</b>) niż rywal (<b style=\'color:less_color\'>less_dir_team_value</b>)'
          },
          equalChancesCreated: {
            1: 'Obie drużyny stworzyły tyle samo okazji – dokładnie <b>chances_created_value</b> chance_text.'
          },
          moreChancesCreated: {
            1: '<b style=\'color:less_color\'>less_cc_team_name</b> stworzył tylko <b style=\'color:less_color\'>less_cc_team_value less_chance_text</b> i został adverb_text przewyższony przez rywala (<b style=\'color:more_color\'>more_cc_team_value more_chance_text</b>). '
          },
          equalXA: {
            1: 'Obie drużyny miały podobne szanse, co widać po <b>xa_value oczekiwanych asyst</b>, '
          },
          moreXA: {
            1: 'Zespół home_away wygenerował o <b>diff_xa_team_value oczekiwanych asyst</b> więcej (<b style=\'color:more_color\'>more_xa_team_value</b> vs <b style=\'color:less_color\'>less_xa_team_value</b>) niż rywal, '
          },
          xAOpenPlay: {
            1: 'tworząc odpowiednio <b style=\'color:more_color\'>more_xa_op_value</b> i <b style=\'color:less_color\'>less_xa_op_value xA z akcji</b>.'
          }
        }
      },
      step6: {
        text: {
          eachOne: ' każdy ',
          respectively: ', odpowiednio',
          with: ' (z <b style=\'color:replace_color\'>other_player_name</b>)',
          playerWas: 'zawodnik był',
          playerWere: 'zawodnicy byli',
          firstPhase: {
            1: 'W pierwszej części meczu kluczowy był player_text ',
            2: 'W pierwszej połowie wyróżniał się '
          },
          otherPhase: {
            1: 'Między <b style=\'color:replace_color\'>min_from\'</b> a <b style=\'color:replace_color\'>min_to\'</b> warto wyróżnić '
          },
          lastPhase: {
            1: 'W końcowej części meczu wyróżnił się ',
            2: 'W ostatniej fazie spotkania '
          },
          playerMaxSuccessfullPasses: {
            1: '<b style=\'color:replace_color\'>player_name</b>, bo wykonał najwięcej udanych podań w zespole – <b style=\'color:replace_color\'>successfull_passes_value</b> '
          },
          playerMaxTotalPasses: {
            1: 'co cenniejsze, bo statystyki pokazują, że był także'
          },
          playerMaxTotalPasses2: {
            1: 'with_text zawodnikiem z największą liczbą prób podań (<b style=\'color:replace_color\'>total_passes_value</b>). '
          },
          playerNotMaxTotalPasses: {
            1: 'choć nie miał największej liczby prób podań (<b style=\'color:replace_color\'>player_name</b> – <b style=\'color:replace_color\'>total_passes_value</b>). '
          },
          playersMaxSuccessfullPassesTotalPasses: {
            1: 'każdy próbował w tym okresie <b style=\'color:replace_color\'>total_passes_value</b> razy. '
          },
          playerMaxPctPasses: {
            1: 'Jeśli chodzi o <b style=\'color:replace_color\'>% udanych podań</b>, <b style=\'color:replace_color\'>player_name</b> osiągnął <b style=\'color:replace_color\'>max_pct_passes_value%</b>. ',
            2: 'Wspominając o skuteczności podań: <b style=\'color:replace_color\'>player_name</b> – <b style=\'color:replace_color\'>max_pct_passes_value%</b>.</b> '
          },
          playerSumTotalXG: {
            1: 'W tym przedziale czasowym zespół wygenerował łącznie <b style=\'color:replace_color\'>sum_xg_value xG</b>, ',
            2: 'W tym okresie <b style=\'color:replace_color\'>team_name</b> stworzył <b style=\'color:replace_color\'>xG</b> równy <b style=\'color:replace_color\'>sum_xg_value</b>, '
          },
          ZeroSumXG: {
            1: 'Mimo że cały zespół wykonał <b style=\'color:replace_color\'>all_team_total_passes</b> podań, nie stworzył ani jednej okazji. ',
            2: '<b style=\'color:replace_color\'>all_team_total_passes</b> podań w tym okresie nie przełożyło się na żadną sytuację bramkową. '
          },
          playerMaxXGMaxXADiffPlayer: {
            1: 'gdzie <b style=\'color:replace_color\'>player_xg_name</b> ( <b style=\'color:replace_color\'>xg_value xG</b>) i <b style=\'color:replace_color\'>player_xa_name</b> (<b style=\'color:replace_color\'>xa_value xA</b>) byli najgroźniejsi w kreacji. '
          },
          playerMaxXGMaxXASamePlayer: {
            1: '<b style=\'color:replace_color\'>player_name</b> był autorem większości okazji zespołu (<b style=\'color:replace_color\'>xg_value xG</b> i <b style=\'color:replace_color\'>xa_value xA</b>). '
          },
          playersMaxXGMaxXA: {
            1: 'm.in. dzięki <b style=\'color:replace_color\'>players_name</b>, którzy dołożyli po <b style=\'color:replace_color\'>xa_value xA</b> kluczowymi podaniami. '
          },
          playerMaxXGZeroXA: {
            1: '<b style=\'color:replace_color\'>player_xg_name</b> ( <b style=\'color:replace_color\'>xg_value xG</b>) samodzielnie tworzył okazje – bez otrzymanych kluczowych podań. '
          },
          playersMaxXGZeroXA: {
            1: '<b style=\'color:replace_color\'>player_xg_name</b> ( <b style=\'color:replace_color\'>xg_value xG</b>) mieli okazje, tworząc je samodzielnie – bez kluczowych podań. '
          },
          oneMaxConnections: {
            1: 'Najwięcej podań między sobą wymieniła para <b style=\'color:replace_color\'>couple_name</b> – łącznie <b style=\'color:replace_color\'>connections_value</b>. ',
            2: 'Duo <b style=\'color:replace_color\'>couple_name</b> wymieniło piłkę <b style=\'color:replace_color\'>connections_value</b> razy. ',
            3: 'Para <b style=\'color:replace_color\'>couple_name</b> najczęściej podawała w tym fragmencie meczu – nawet <b style=\'color:replace_color\'>connections_value</b> razy. '
          },
          twoMaxConnections: {
            1: 'Dwie pary – <b style=\'color:replace_color\'>couple_name</b> i <b style=\'color:replace_color\'>couple_name2</b> – najczęściej łączyły się w tym okresie (<b style=\'color:replace_color\'>connections_value</b> wymian). '
          },
          moreThanTwoMaxConnections: {
            1: 'Pary zawodników – np. <b style=\'color:replace_color\'>couple_name</b> – wymieniały między sobą <b style=\'color:replace_color\'>connections_value</b> podań. '
          },
          oneMinConnections: {
            1: 'Z drugiej strony, najmniej łączyła się para <b style=\'color:replace_color\'>couple_name</b> – tylko <b style=\'color:replace_color\'>connections_value</b> razy. ',
            2: 'Na drugim biegunie duet <b style=\'color:replace_color\'>couple_name</b> połączył się zaledwie <b style=\'color:replace_color\'>connections_value</b> razy. '
          },
          twoMinConnections: {
            1: 'Z kolei <b style=\'color:replace_color\'>couple_name</b> i <b style=\'color:replace_color\'>couple_name2</b> wymienili między sobą zaledwie (<b style=\'color:replace_color\'>connections_value</b>) podań. '
          },
          moreThanTwoMinConnections: {
            1: 'Kilka kombinacji łączyło się rzadko, np. duet <b style=\'color:replace_color\'>couple_name</b> – tylko <b style=\'color:replace_color\'>connections_value</b> podań. '
          }
        }
      },
      step7: {
        ballPossession: 'Posiadanie piłki',
        gamePossessionDist: 'Dystrybucja posiadania piłki'
      }
    },
    gamePossessionMap: {
      of: 'z',
      to: 'do',
      and: 'i',
      endsWith: 'Kończy się',
      time: 'Czas',
      touches: 'Kontakty',
      passes: 'Podania',
      threat: 'Zagrożenie',
      xG: 'xG',
      xT: 'xT',
      minutes: 'Minuty',
      duration: 'Czas trwania',
      endsGoal: 'Kończy się golem',
      endsInBox: 'Kończy się w polu',
      withShot: 'Ze strzałem',
      withCross: 'Z dośrodkowaniem',
      possession: 'Posiadanie',
      events: 'Zdarzenia',
      filters: 'Filtry',
      filtersWarning: 'Zagrożenie dotyczy tylko posiadan bez strzałów',
      sumWarning: 'Filtr dotyczy sumy xG wszystkich strzałów w sekwencji, więc może być > 1',
      show: 'Pokaż',
      sequenceNumbers: 'Numer sekwencji',
      jerseyNumbers: 'Numer',
      pass: 'Podanie',
      carryAndPass: 'Prowadzenie i podanie',
      carryAndAction: 'Prowadzenie i akcja',
      carryAndShot: 'Prowadzenie i strzał',
      shotFailed: 'Nieudany strzał',
      goal: 'Gol',
      savedShot: 'Obroniony strzał',
      missedShot: 'Niecelny strzał',
      shotOnPost: 'Strzał w słupek',
      headerGoal: 'Gol głową',
      headerFailed: 'Nieudana główka',
      failed: 'nieudane',
      with: 'z'
    },
    report: {
      title: 'Raport meczowy',
      maps: 'Mapy',
      xGRace: 'Wyścig xG',
      lineups: 'Składy',
      button: 'Wygeneruj pełny raport PDF z meczu',
      mobileButton: 'Raport PDF',
      most: 'Najwięcej',
      topXPlayers: 'Top {x} zawodników',
      mobileButtonXY: 'XY report',
      mobileButtonPD: 'PD report',
      pDReportTitle: 'Raport danych fizycznych gry'
    },
    avgScoreTooltip: 'Średni wynik na minutę',
    status: {
      scheduled: 'Zaplanowany',
      postponed: 'Odłożony',
      cancelled: 'Odwołany',
      inPlay: 'Na żywo',
      finished: 'Gotowy',
      awarded: 'Wyróżniony',
      dataAvailable: 'Dane będą dostępne w ciągu najbliższych godzin'
    },
    preGameAnalysis: {
      showExpectations: 'Pokaż oczekiwania',
      hideExpectations: 'Ukryj oczekiwania',
      goalsPeriods: 'Okresy celów',
      synergyIndex: 'Indeks synergii',
      synergyIndexSubtitle: 'Ogólna siła połączenia przechodnia-finiszera'
    }
  },
  general: {
    1: 'Jeden',
    2: 'Dwa',
    3: 'Trzy',
    4: 'Cztery',
    5: 'Pięć',
    8: 'Lewa',
    9: 'Obie',
    10: 'Prawa',
    create: 'Utwórz',
    save: 'Zapisz',
    cancel: 'Anuluj',
    delete: 'Usuń',
    edit: 'Edytuj',
    reset: 'Nastawić',
    go: 'Przejdź',
    formErrors: {
      required: 'Pole wymagane',
      passwordMatch: 'Hasła nie są identyczne',
      minLength: 'Minimalna długość',
      maxLength: 'Maksymalna długość',
      emailValid: 'E-mail musi być poprawny',
      youthAge: 'Wiek musi być między 10 a 23',
      seasonYear: 'Rok musi być między 2016 a 2050',
      integer: 'Liczby dziesiętne niedozwolone'
    },
    confirmationTitle: 'Na pewno?',
    confirmationMessage: 'Potwierdź wykonanie akcji',
    yes: 'Tak',
    no: 'Nie',
    search: 'Szukaj',
    clearFilters: 'Wyczyść filtry',
    minimum: 'Minimum',
    maximum: 'Maksimum',
    minimumPercent: '(%) Minimalny procent',
    period: 'Okres',
    exclude: 'Wyklucz',
    team: 'Zespół',
    clear: 'Wyczyść',
    all: 'Wszystko',
    ground1: 'Wszystko',
    ground2: 'Dom',
    ground3: 'Wyjazd',
    filter: 'Filtruj',
    noData: 'Brak wyników',
    noDataGivenFilters: 'Brak wyników dla podanych filtrów',
    similarityMinutesWarning: 'Brak danych z powodu < 450 rozegranych minut',
    templateOnlyEditable: 'Szablon edytowalny tylko przez ',
    close: 'Zamknij',
    load: 'Wczytaj',
    filters: 'Filtry',
    players: 'zawodników',
    teams: 'zespołów',
    compare: 'Porównaj',
    seeMore: 'Zobacz więcej',
    seeLess: 'Zobacz mniej',
    request: 'Zgłoś prośbę',
    notes: 'Notatki',
    closeSession: 'Wyloguj',
    settings: 'Ustawienia',
    player: 'Zawodnik',
    state: 'Stan',
    updated: 'Zaktualizowano',
    file: 'Plik',
    uploadFile: 'Prześlij plik',
    reports: 'Raporty',
    download: 'Pobierz',
    new: 'Nowy',
    comparison: 'Porównanie',
    scout: 'Skauting',
    favorites: 'Ulubione',
    moreOptions: 'Więcej opcji',
    lessOptions: 'Mniej opcji',
    today: 'Dziś',
    home: 'Dom',
    away: 'Wyjazd',
    until: 'do',
    firstHalf: 'Pierwsza połowa',
    secondHalf: 'Druga połowa',
    firstPeriodOT: 'I poł. dogr.',
    secondPeriodOT: 'II poł. dogr.',
    postponed: 'Przełożony',
    stats: 'Statystyki',
    yesterday: 'Wczoraj',
    last: 'Ostatnie',
    startDate: 'Data początkowa',
    active: 'Aktywne',
    playerLimit: 'Limit zawodników',
    type: 'Typ',
    successMessage: 'Operacja zakończona sukcesem',
    failMessage: 'Operacja nie powiodła się',
    by: 'Przez',
    checkYourInbox: 'Sprawdź skrzynkę',
    faq: 'Słownik',
    globalSearch: 'Wyszukiwanie globalne',
    gamesLost: 'Mecze stracone',
    outOf: 'z',
    avgSeason: 'Średnia sezonu',
    leftDays: 'pozostałe dni',
    notifyError: 'Zgłoś błąd',
    notify: 'Powiadom',
    comments: 'Komentarze',
    searches: 'Wyszukiwania',
    now: 'Teraz',
    twoHoursAgo: 'Dwie godziny temu',
    incomings: 'Przybycia',
    departures: 'Odejścia',
    transferLoans: 'Wypożyczenia',
    transfers: 'Transfery',
    movements: 'Ruchy',
    incomes: 'Przychody',
    expenditures: 'Wydatki',
    action: 'Akcja',
    target: 'Cel',
    uses: 'Użycia',
    users: 'Użytkownicy',
    since: 'od',
    mediaMode: 'Tryb medialny',
    white: 'Biały',
    enabled: 'Włączone',
    disabled: 'Wyłączone',
    left: 'Lewa',
    right: 'Prawa',
    both: 'Obie',
    'left-both': 'Lewa Obie',
    'right-both': 'Prawa Obie',
    'left foot': 'Lewa',
    'right foot': 'Prawa',
    files: 'Pliki',
    confirm: 'Potwierdź',
    currentStep: 'Bieżący krok',
    phases: 'Fazy',
    entries: 'Wpisy',
    none: 'Brak',
    times: 'razy',
    darkMode: 'Tryb ciemny',
    client: 'Klient',
    visits: 'Wizyty',
    lastVisit: 'Ostatnia wizyta',
    strong: 'Silny',
    medium: 'Średni',
    weak: 'Słaby',
    goal: 'Gol',
    list: 'Lista',
    map: 'Mapa',
    copiedToClipboard: 'Skopiowano do schowka',
    division: 'Dywizja',
    many: 'Dużo',
    few: 'Mało',
    median: 'Mediana',
    topRight: 'Prawy górny',
    topLeft: 'Lewy górny',
    bottomRight: 'Prawy dolny',
    bottomLeft: 'Lewy dolny',
    library: 'Biblioteka',
    mediaLibrary: 'Biblioteka mediów',
    for: 'Dla',
    stat: 'Statystyka',
    position: 'Pozycja',
    order: 'Kolejność',
    add: 'Dodaj',
    visualization: 'Wizualizacja',
    basic: 'Podstawowe',
    selectAll: 'Zaznacz wszystko',
    unselectAll: 'Odznacz wszystko',
    distribution: 'Dystrybucja',
    end: 'Koniec',
    accuracy: 'dokładność',
    opponent: 'Przeciwnik',
    ownTeam: 'Własny zespół',
    center: 'Środek',
    line: 'Linia',
    live: 'Na żywo',
    unavailable: 'niedostępne',
    calendar: 'Kalendarz',
    activeLeague: 'Trwająca liga',
    similarity: 'Podobieństwo',
    emptyForSelectAll: 'Puste zaznacz wszystko',
    size: 'Rozmiar',
    selectPlayersRestriction: 'Wybierz między 1 a {x} zawodników',
    group: 'Grupa',
    alerts: 'Alerty',
    shortcuts: 'Skróty',
    share: 'Udostępnij',
    dataAvailable: 'Dane będą wkrótce dostępne',
    someStatsAvailableSoon: 'Niektóre statystyki będą wkrótce dostępne',
    monthGamesWarning: 'Mecze wybranego miesiąca będą wkrótce dostępne',
    metrics: 'Metryki',
    competition: 'Rozgrywki',
    code: 'Kod',
    alias: 'Alias',
    never: 'Nigdy',
    unlimited: 'Nielimitowane',
    user: 'Użytkownik',
    warning: 'Ostrzeżenie',
    requests: 'Prośby',
    contactSales: 'Skontaktuj się ze sprzedażą',
    comingSoon: 'Już wkrótce!',
    firstPost: '1. słupek',
    secondPost: '2. słupek',
    dZone: 'Strefa D',
    penaltySpot: 'Jedenastka',
    secondPlay: 'Druga piłka',
    otherZone: 'Inna strefa',
    baseline: 'Linia końcowa',
    youth: 'Młodzież',
    male: 'Mężczyźni',
    direct: 'Bezpośredni',
    indirect: 'Pośredni',
    processing: 'Przetwarzanie',
    addNew: 'Dodaj nowy',
    createdBy: 'Utworzone przez',
    downloading: 'Pobieranie',
    displayType: 'Typ wyświetlania',
    alreadyExists: 'już istnieje',
    aggregation: 'Agregacja',
    unavailableLeagues: 'Nie masz dostępu do żadnej z lig, w których grał zawodnik',
    meters: 'Metry',
    quantity: 'Ilość',
    allTime: 'Cały okres',
    games: 'Mecze',
    unit: 'Jednostka',
    categories: 'Kategorie',
    maintenanceWarning: 'Trwają prace serwisowe',
    maintenanceMessage: 'Wprowadzamy aktualizacje. Zmiany dokonane teraz nie zostaną zapisane. Dziękujemy za cierpliwość!',
    seeAll: 'Zobacz wszystko',
    from: 'Od',
    to: 'do',
    showFilters: 'Pokaż filtry',
    hideFilters: 'Ukryj filtry',
    horizontal: 'Poziomy',
    vertical: 'Pionowy',
    drop: 'Upuszczać',
    orientation: 'Orientacja',
    goalProbability: 'Prawdopodobieństwo celu',
    assistProbability: 'Prawdopodobieństwo pomocy',
    attackingDirection: 'Kierunek ataku',
    currentTeam: 'Obecny zespół',
    expectations: 'Oczekiwania',
    sideBySide: 'Obok siebie',
    teamValue: 'Wartość zespołu',
    fieldLayout: 'Układ pola',
    searchPlaceholder: 'Type {x} letters at least to search',
    crests: 'Herby',
    pcts: 'PCT'
  },
  playerScout: {
    dlabDatabase: 'Baza Driblab',
    league: 'Liga',
    top5: 'Top 5',
    topCountries: 'Kraje',
    tier: 'Poziom',
    division1: 'Pierwsza liga',
    division2: 'Druga liga',
    division3: 'Trzecia liga',
    division4: 'Czwarta liga',
    division5: 'Piąta liga',
    division6: 'Oddział szósty',
    summary: 'Podsumowanie',
    offensive: 'Of',
    defensive: 'Def',
    gk: 'BR',
    all: 'Wszystko',
    physical: 'Fiz',
    arrigo: 'Arrigo',
    yearTooltip: 'Dozwolony tylko jeden rok',
    expectedThreat: 'xThreat',
    expectedThreatTooltip: 'Zagrożenie dodane do wszystkich posiadania',
    expectedThreatOP: 'xThreat OP',
    expectedThreatOPTooltip: 'Zagrożenie dodane do posiadania z akcji',
    expectedThreatInTeam: 'xThreat w zespole %',
    expectedThreatInTeamTooltip: '% zagrożenia dodane przez zawodnika do zespołu',
    ballProgression: 'Progresja piłki',
    ballProgressionTooltip: 'Progresje o +10 metrów',
    deepProgression: 'Głębokie progresje',
    deepProgressionTooltip: 'Progresje do ostatniej piątej',
    ballRetention: '% Utrzymanie piłki',
    ballRetentionTooltip: 'Odsetek akcji zakończonych utrzymaniem piłki',
    ballRetentionOppHalf: '% Utrzymanie OH',
    ballRetentionOppHalfExplicit: 'Procent czasu z posiadaniem bez straty na połowie rywala',
    finishing: 'Wykończenie',
    finishingTooltip: '% strzałów zakończonych golem',
    scoringContribution: 'Wkład bramkowy',
    scoringContributionTooltip: 'Asysty + Gole',
    xgPerShot: 'xG na strzał',
    xgPerGoal: 'xG na gola',
    headerPerCross: 'Główka na dośrodkowanie',
    completedCrosses: 'Udane dośrodkowania',
    crossingPct: '% dośrodkowań',
    crossingEfficiency: 'Efektywność dośrodkowań',
    crossingEfficiencyTooltip: 'Efektywność dośrodkowań (jakość i ilość)',
    longBalls: 'Długie piłki',
    longPassing: '% długich podań',
    dribblingPct: '% dryblingu',
    throughBalls: 'Prostopadłe podania',
    oppBoxTouches: 'Kontakty w polu karnym',
    oppBoxTouchesTooltip: 'Kontakty w polu karnym przeciwnika',
    openPlayKeyPasses: 'OP kluczowe podania',
    openPlayKeyPassesTooltip: 'Podania z akcji kończące się strzałem',
    xGBuildup: 'xG Buildup',
    xGBuildupTooltip: 'xG sekwencji kończących się strzałem z udziałem zawodnika (bez xG strzału i kluczowego podania)',
    Assists: 'Asysty',
    passPercentage: '% podań',
    passPerLongBall: 'Podań na LB',
    passPerLongBallExplicit: 'Podań na długą piłkę',
    nonPenaltyGoals: 'Gole bez karnych',
    xG: 'xG',
    xGExplicit: 'Oczekiwane gole',
    shots: 'Strzały',
    xGShot: 'xG na strzał',
    xGChain: 'xG Chain',
    xGChainTooltip: 'xG sekwencji kończących się strzałem z udziałem zawodnika',
    chancesCreated: 'Podania zakończone strzałem',
    chances: 'Okazje',
    dribbles: 'Dryblingi',
    dribblesSuccessfull: 'Udane dryblingi',
    touches: 'Kontakty w polu karnym',
    xA: 'xA',
    xAExplicit: 'Oczekiwane asysty',
    xAOpenPlay: 'xA OP',
    xAOpenPlayExplicit: 'Oczekiwane asysty z akcji',
    passesOpponentBox: 'Podania w polu karnym',
    passesOB: 'Podania w PK',
    passesFinalThirdTooltip: 'Podania w trzeciej tercji',
    passesSuccessful: 'Udane podania',
    passesSuccessfulTooltip: 'Udane podania',
    ballProgressionPassing: 'Progresja podaniami',
    ballProgressionPassingTooltip: 'Progresja podaniami',
    ballProgressionDribbling: 'Progresja prowadzeniem',
    ballProgressionDribblingTooltip: 'Progresja prowadzeniem',
    passesTotal: 'Podania',
    passesTotalTooltip: 'Łączna liczba prób podań',
    shortPassesSuccessful: 'Udane KP',
    shortPassesSuccessfulTooltip: 'Liczba udanych krótkich podań',
    shortPassesTotal: 'Łącznie KP',
    shortPassesTotalTooltip: 'Liczba prób krótkich podań',
    tackles: 'Wślizgi *',
    adjustedTackles: 'Wślizgi skoryg. o posiadanie',
    interceptions: 'Przechwyty *',
    adjustedInterceptions: 'Przechwyty skoryg. o posiadanie',
    aerials: 'Pojedynki powietrzne',
    aerialsPercent: '% powietrznych',
    aerialEfficiency: 'Ef. w powietrzu',
    aerialEfficiencyTooltip: 'Efektywność w powietrzu (jakość i ilość)',
    twd: 'TwD',
    tacklesWasDribbled: 'Ominięty dryblingiem',
    fouls: 'Faule',
    indPressure: 'Presja indywidualna',
    pressure: 'Presja',
    dispossessed: 'Utraty',
    recoveries: 'Odbiory',
    primary: 'Główna',
    secondary: 'Drugorzędna',
    position: 'Pozycja',
    nationality: 'Narodowość',
    height: 'Wzrost (cm)',
    minHeight: 'Min. wzrost',
    maxHeight: 'Maks. wzrost',
    age: 'Wiek',
    minAge: 'Min. wiek',
    maxAge: 'Maks. wiek',
    games: 'Mecze',
    minGames: 'Min. mecze',
    maxGames: 'Maks. mecze',
    minutes: 'Minuty',
    minMinutes: 'Min. minuty',
    maxMinutes: 'Maks. minuty',
    minPercentMinutes: 'Min. % minut',
    dates: 'Daty',
    marketValue: '(€) Wartość rynkowa',
    teams: 'Zespoły',
    contractEnd: 'Koniec kontraktu',
    minValue: 'Min. wartość',
    maxValue: 'Maks. wartość',
    excludeTeams: 'Wyklucz zespoły',
    recentSearches: 'Ostatnie wyszukiwania',
    saveSearch: 'Zapisz wyszukiwanie',
    loadSearch: 'Wczytaj wyszukiwanie',
    loadCollection: 'Wczytaj kolekcję',
    collection: 'Kolekcja',
    search: 'Szukaj',
    searchesList: 'Listy wyszukiwań',
    mySearches: 'Moje wyszukiwania',
    mySearchesDescription: 'Te zapisane wcześniej',
    recentSearchesDescription: 'Ostatnie 10 wyszukiwań',
    searchToLoad: 'Wyszukiwanie do wczytania',
    recentSearch: 'Ostatnie wyszukiwanie',
    saveSearchSuccess: 'Wyszukiwanie zapisane',
    removeSearch: 'Usuń wyszukiwanie',
    removeSearchMessage: 'Czy na pewno chcesz usunąć wyszukiwanie?',
    updateSearch: 'Aktualizuj wyszukiwanie',
    updateSearchMessage: 'Czy na pewno chcesz zaktualizować wyszukiwanie?',
    deleteSearchSuccess: 'Wyszukiwanie usunięte',
    playersFound: 'znaleziono zawodników',
    addToCollection: 'Dodaj do kolekcji',
    npg: 'NPG',
    goals: 'Gole',
    value: 'Wartość',
    nationalTeams: 'Reprezentacje',
    gbeScore: 'GBE',
    dlIndex: 'Wynik',
    minGbe: 'Min. GBE',
    goalsConceded: 'Stracone gole',
    npgConceded: 'Stracone NPG',
    npgConcededTooltip: 'Gole bez karnych stracone',
    xGOTConceded: 'xG On Target stracone',
    xGOTConcededTooltip: 'xG strzałów w światło bramki',
    goalsPrevented: 'Zapobiegnięte gole',
    xGFacedPerShotOnTarget: 'xGOT na strzał',
    xGFacedPerShotOnTargetTooltip: 'xG On Target na strzał stracony',
    xGSavedPerxGFacedOnTarget: 'xG Saving',
    xGSavedPerxGFacedOnTargetTooltip: '% obron z uwzględnieniem xG',
    savesPct: '% obron',
    savesOutOfBoxPct: '% obron spoza pola',
    savesInBoxPct: '% obron w polu',
    xGFacedPerGoal: 'xG na straconego gola',
    xGFacedPerGoalTooltip: 'xG potrzebne na gola',
    catchingPct: '% chwytów',
    catchingTooltip: '% chwytów spośród obron',
    passingOwnHalfPct: '% podań własna połowa',
    passingOwnHalfPctTooltip: 'Odsetek udanych podań na własnej połowie',
    passingOppHalfPct: '% podań połowa rywala',
    passingOppHalfPctTooltip: 'Odsetek udanych podań na połowie rywala',
    passingContribution: '% wkład podań',
    passingContributionTooltip: 'Wkład zagrożenia podaniami – powyżej średniej',
    shotsPerGoal: 'Strzałów na gola',
    passesFinalThird: 'Podania w ⅓',
    passingFinalThird: '% podań w ⅓',
    claimAccuracy: 'Skuteczność wyjść',
    claimAccuracyTooltip: 'Chwyty powyżej średniej',
    highTurnovers: 'Wysokie straty',
    highTurnoversTooltip: 'Straty bliżej niż 40 m od bramki',
    shotEndingHighTurnovers: 'Strzał po WS',
    shotEndingHighTurnoversTooltip: 'Strzał po wysokiej stracie',
    goalEndingHighTurnovers: 'Gol po WS',
    goalEndingHighTurnoversTooltip: 'Gol po wysokiej stracie',
    avgCarriesProgress: 'Śr. progresja',
    avgCarriesProgressTooltip: 'Śr. pionowy dystans prowadzenia (m)',
    carriesChance: 'Kończy się okazją',
    carriesChanceTooltip: 'Prowadzenia zakończone kluczowym podaniem',
    carriesAssist: 'Kończy się asystą',
    carriesAssistTooltip: 'Prowadzenia zakończone asystą',
    carriesShot: 'Kończy się strzałem',
    carriesShotTooltip: 'Prowadzenia zakończone strzałem',
    carriesGoal: 'Kończy się golem',
    carriesGoalTooltip: 'Prowadzenia zakończone golem',
    shotEndingSequence: 'Kończy się strzałem',
    shotEndingSequenceTooltip: 'Liczba sekwencji zakończonych strzałem z udziałem',
    goalEndingSequence: 'Kończy się golem',
    goalEndingSequenceTooltip: 'Liczba sekwencji zakończonych golem z udziałem',
    gbeScoreTooltip: 'FA Governing Body Endorsement',
    goalsPreventedTooltip: 'Gole bez karnych obronione przez bramkarza (xG Faced - NPG Conceded)',
    freePlayers: 'Wolni zawodnicy',
    index: 'Indeks',
    playerName: 'Imię i nazwisko',
    teamName: 'Zespół',
    secondPos: 'Druga poz.',
    side: 'Strona',
    onlyOnLoan: 'Tylko wypożyczenie',
    dob: 'Urodz.',
    countryName: 'Kraj',
    secondCountryName: 'Drugi kraj',
    seasonYear: 'Sezon',
    assists: 'Asysty',
    placeholder: 'Możesz zacząć dodawać filtry ligowe',
    placeholder2: 'Kliknij Szukaj, aby zobaczyć wyniki',
    passesPct: '% podań',
    passingPct: '% podań',
    oppBoxPasses: 'Podania w PK',
    adjustedClearances: 'Wybitki skoryg.',
    aerialsPct: '% powietrznych',
    leagueCountryCode: 'Kod kraju ligi',
    shooting: '% strzałów w światło',
    xtPassing: 'xT podania',
    xtPassingTooltip: 'Zagrożenie dodane podaniami',
    xtDribbling: 'xT prowadzenia',
    xtDribblingTooltip: 'Zagrożenie dodane prowadzeniem',
    foot: 'Silniejsza noga',
    aggressiveActions: 'Agresywne akcje',
    aggressiveActionsTooltip: 'Liczba wślizgów w 2 s po stracie posiadania',
    tacklesAttempted: 'Łącznie prób wślizgów',
    highDefensiveActionPct: '% akcji wysoko',
    highDefensiveActionPctTooltip: 'Odsetek akcji defensywnych <=40 m od bramki rywala',
    individualPressureOppHalf: 'Presja na poł. rywala',
    individualPressureOppHalfTooltip: 'Skuteczne próby (odzyskania) przy pressingu na połowie rywala',
    xGBuildUp5Pass: 'xG Buildup 5p',
    xGBuildUp5PassTooltip: 'Suma xG z udziałem – ostatnie 5 podań (bez strzału/kluczowego)',
    chancesCreatedOpenPlay: 'Okazje z akcji',
    chancesCreatedOpenPlayTooltip: 'Liczba podań prowadzących do strzału w akcji',
    fmf: {
      Defender: 'Obrońca',
      aerial: 'Gra w powietrzu',
      goodDefender: 'Dobry obrońca',
      goodPresence: 'Dobra prezencja',
      playmaking: 'Kreacja gry',
      Fullback: 'Boczny obrońca',
      defensiveness: 'Defensywa',
      offensiveness: 'Ofensywa',
      fast: 'Szybki',
      Forward: 'Napastnik',
      goalChances: 'Sytuacje bramkowe',
      goodDecissions: 'Dobre decyzje',
      individualTechnique: 'Technika indywidualna',
      Goalkeeper: 'Bramkarz',
      footWork: 'Gra nogami',
      leadership: 'Przywództwo',
      Midfielder: 'Defensywny pomocnik',
      balance: 'Równowaga',
      ballRetention: '% utrzymania piłki',
      offensivePasses: 'Podania ofensywne',
      recoveries: 'Odbiory',
      shotToGoal: 'Strzał na bramkę',
      'Attacking-Midfielder': 'Ofensywny pomocnik',
      defensiveGame: 'Gra defensywna',
      offensiveGame: 'Gra ofensywna',
      Winger: 'Skrzydłowy',
      crossing: 'Dośrodkowania',
      deepProgressions: 'Głębokie progresje',
      defendingEffort: 'Wysiłek w defensywie',
      facing: 'Gra na wprost'
    },
    yellowCards: 'Żółte kartki',
    redCards: 'Czerwone kartki',
    alert: 'Alert',
    yearOfBirth: 'Rok urodzenia',
    minYearOfBirth: 'Min. rok urodzenia',
    maxYearOfBirth: 'Maks. rok urodzenia',
    women: 'Kobiet',
    continental: 'Kontynentalne',
    countryCup: 'Puchar krajowy',
    statsName: 'Nazwa statystyki',
    abbreviation: 'Skrót',
    abbr: {
      position: 'POS',
      secondPos: 'SP',
      seasonYear: 'SY',
      marketValue: 'MV(€)',
      contractEnd: 'CE',
      height: 'H(cm)',
      side: 'SD',
      strongFoot: 'SF',
      games: 'G'
    },
    warningRegularSeason: 'Wyświetlanie tylko ostatniego rozegranego sezonu zasadniczego',
    gamesWith60PlusMinsTooltip: 'Minimalna liczba gier rozegranych dłużej niż 60 minut',
    starts: 'Rozpoczyna się',
    minGPI: 'Min. GPI',
    maxGPI: 'Max. GPI',
    tertiary: 'Tertiary'
  },
  playerComparison: {
    upTo5Players: 'Porównaj do 5 zawodników',
    requestReport: 'Zamów raport',
    searchBarPlaceholder: 'Szukaj zawodnika lub drużyny',
    allStats: 'Wszystkie statystyki',
    placeholder: 'Możesz zacząć dodawać zawodników'
  },
  reports: {
    detailedInsights: 'Uzyskaj szczegółowe analizy',
    features: 'Funkcje raportu',
    performance: 'Występy',
    evolution: 'Ewolucja',
    compareWithMyTeam: 'Porównaj z moim zespołem',
    similarPlayers: 'Podobni zawodnicy',
    potentialTeams: 'Potencjalne zespoły',
    requestSuccess: 'Prośba wysłana pomyślnie',
    requestAt: 'Wysłano',
    reportConversation: 'Konwersacja o raporcie',
    writeYourMessage: 'Napisz wiadomość...',
    you: 'Ty'
  },
  state: {
    requested: 'Wysłano',
    inProgress: 'W toku',
    delivered: 'Dostarczono'
  },
  langs: {
    es: 'Hiszpański',
    en: 'Angielski',
    fr: 'Francuski',
    de: 'Niemiecki',
    it: 'Włoski',
    pt: 'Portugalski',
    tr: 'Turecki',
    jp: 'Japoński',
    cn: 'Chiński',
    sa: 'Arabski',
    nl: 'Holenderski',
    pl: 'Polski',
    sv: 'Szwedzki',
    cs: 'Czeski',
    ko: 'Koreański',
    hu: 'Weński',
    ru: 'Rosyjski'
  },
  langsArea: {
    europe: 'Europa',
    asia: 'Azja',
    arabic: 'Arabski'
  },
  inbox: {
    subtitle: 'Bądź na bieżąco',
    new_injury_alert: 'Nowy alert kontuzji',
    new_contract_alert: 'Nowy alert kontraktu',
    new_team_alert: 'Nowy alert transferu',
    new_marketValue_alert: 'Nowy alert wartości rynkowej',
    new_game_alert: 'Nowy alert rozegranego meczu',
    receive_mail: 'Otrzymuj e‑maile',
    receive_mail_subtitle: 'Codzienny e‑mail z zawodnikami spełniającymi filtry',
    receive_notifications: 'Powiadomienia',
    receive_notifications_subtitle: 'Powiadomienia w aplikacji o zawodnikach spełniających filtry',
    changedTo: 'Zmieniono na',
    alerts: 'Alerty',
    includedIn: 'Uwzględniony w',
    noContract: 'Brak kontraktu',
    newMessages: 'Nowe wiadomości',
    reply: {
      reply: 'Odpowiedz',
      replyTitle: 'Przekaż opinię klientowi:',
      replyPlaceholder: 'Użytkownik otrzyma odpowiedź wraz z aktualizacją statusu'
    }
  },
  gameAnalysis: {
    subtitle: 'Uzyskaj wgląd z ostatnich meczów',
    subtitle2: 'Pokazywane mecze w ciągu najbliższych siedmiu dni',
    subtitle3: 'Uzyskaj wgląd z ostatnich meczów i poznaj nadchodzące',
    seeDetail: 'Zobacz szczegóły'
  },
  statsNaming: {
    Possession: 'Posiadanie',
    TimePossession: 'Czas posiadania',
    PassesPerShots: 'Podania na strzał',
    PPDA: 'PPDA',
    ExpectedPoints: 'Oczekiwane punkty',
    Points: 'Punkty',
    Directness: 'Bezpośredniość',
    PassesPerLongBall: 'Podania na długą piłkę',
    CrossingPerXG: 'Dośrodkowania na xG',
    PenaltySavedPenaltyFaced: 'Obronione karne/Karne przeciw',
    Goals: 'Gole',
    PenaltyShots: 'Rzuty karne',
    PenaltyGoals: 'Gole z karnych',
    NonPenaltyGoals: 'Gole bez karnych',
    NPGOpenPlay: 'NPG z akcji',
    NPGSetPiece: 'NPG ze stałych frag.',
    Shooting: 'Strzały (celność)',
    Finishing: 'Wykończenie',
    xGEfficiency: 'Efektywność xG',
    HeaderPerShot: 'Główka na strzał',
    HeaderPerCross: 'Główka na dośrodkowanie',
    HeadedGoals: 'Cele na czele',
    GoalsConceded: 'Stracone bramki',
    SavesInBox: 'Zapisuje w pudełku',
    SavesOutBox: 'Zapisuje po wyjęciu z pudełka',
    Assists: 'Asysty',
    ThroughBalls: 'Prostopadłe podania',
    CrossEfficiency: 'Efektywność dośrodkowań',
    ScoringContribution: 'Wkład bramkowy',
    xAssistsOpenPlay: 'xAssists z akcji',
    xAssistsSetPiece: 'xAssists ze stałych frag.',
    xAssistsOpenPlayInTeam: 'xAssists z akcji w zespole',
    xAssistsSetPieceInTeam: 'xAssists SFG w zespole',
    xGBuildupFinalThird: 'xG Build Up ⅓',
    xGChainFinalThird: 'xG Chain ⅓',
    BallProgressionPassing: 'Progresja podaniami',
    BallProgressionDribbling: 'Progresja prowadzeniem',
    TacklesWasDribbled: 'Wygrane pojedynki defensywne 1 na 1',
    TacklesSuccessful: 'Udane wślizgi',
    Interceptions: 'Przechwyty',
    Clearances: 'Wybitki',
    Fouls: 'Faule',
    Recoveries: 'Odbiory',
    Shots: 'Strzały',
    ShotsPerGoal: 'Strzały na gola',
    ShortPassesSuccessful: 'Udane krótkie podania',
    PassingSuccessForwardPct: '% skut. podań do przodu',
    PassingSuccessBackwardPct: '% skut. podań do tyłu',
    PassingForwardBackwardPct: '% podań do przodu/tyłu',
    LongBallPerPassesPct: '% długich podań',
    LongBallReceived: 'Otrzymane długie piłki',
    LongBallReceivedOppHalf: 'Długie piłki otrz. na poł. rywala',
    OffensiveActions: 'Akcje ofensywne',
    DribblesAttempted: 'Próby dryblingu',
    SuccessfulDribblesPct: '% udanych dryblingów',
    OffensiveTouchesOutBoxPct: '% kontaktów ofens. poza polem',
    BallRetention: '% utrzymania piłki',
    PassingPct: '% podań',
    PassingOwnHalfPct: '% podań własna połowa',
    PassingOppHalfPct: '% podań połowa rywala',
    PassingFinalThird: 'Podania w ⅓',
    PassesFinalThirdTotal: 'Całkowita liczba podań w finale ⅓',
    PassingFinalThirdPct: '% podań w ⅓',
    LongBallSuccessful: 'Udane długie podania',
    LongBallPct: '% długich podań',
    LongBallTotal: 'Całkowite długie piłki',
    SavesPct: '% obron',
    SavesInBoxPct: '% obron w polu',
    SavesOutOfBoxPct: '% obron spoza pola',
    xGSavedPerXGFacedOnTarget: 'xG Saved/xG On Target',
    xGFacedOnTargetPerGoalReceived: 'xG na straconego gola',
    xGFacedOnTargetEfficiency: 'Zapobiegnięte gole',
    xGFacedOnTarget: 'xG On Target przeciw',
    IndividualPressure: 'Presja indywidualna',
    AerialEfficiency: 'Efektywność w powietrzu',
    AerialWins: 'Wygrane pojedynki powietrzne',
    AerialWinsPct: '% wygranych w powietrzu',
    xG: 'Gole oczekiwane',
    xGDiff: 'Różnica xG',
    xGOpenPlay: 'xG z akcji',
    xGSetPiece: 'xG SFG',
    xGPerShot: 'xG na strzał',
    ChancesCreated: 'Stworzone okazje',
    CompletedCrosses: 'Udane dośrodkowania',
    Crossing: '% dośrodkowań',
    OpenPlayKeyPasses: 'Kluczowe podania z akcji',
    OpenPlayKeyPassesInTeam: '% klucz. podań z akcji w zespole',
    OpenPlayPassesIntoOpponentBox: 'Łącznie podania z akcji w pole',
    OpenPlayPassesIntoOpponentBoxSuccessful: 'Podania z akcji w pole',
    xAssists: 'Asysty oczekiwane',
    xGChain: 'xG Chain',
    xGBuildup: 'xG Build Up',
    xGBuildupInTeam: 'xG Build Up w zespole',
    BallProgression: 'Progresja piłki',
    SuccessfulDribbles: 'Udane dryblingi',
    Dispossessed: 'Straty',
    TouchesInOpponentBox: 'Kontakty w polu karnym',
    xGSavedPerShot: 'xG Saved na strzał',
    BallRetentionOppHalf: '% utrzymania na poł. rywala',
    DeepProgression: 'Głęboka progresja',
    DeepProgressionFinalThird: 'Głęboka progresja do ⅓',
    FoulsTaken: 'Faule na zawodniku',
    PenaltiesTaken: 'Wywalczone karne',
    BlockedCrosses: 'Zablokowane dośrodkowania',
    BlockedShots: 'Zablokowane strzały',
    Blocks: 'Bloki',
    NonPenaltyGoalsAgainst: 'Stracone gole bez karnych',
    Headers: 'Główki',
    AveragePassDistance: 'Śr. dystans podań',
    ProgressiveRuns: 'Progresywne prowadzenia',
    xT: 'Expected Threat (xT)',
    xTOpenPlay: 'xT z akcji',
    xTSetPiece: 'xT SFG',
    xGOT: 'Expected Goals On Target',
    BadActions: 'Złe zagrania',
    BadActionsOwnHalf: 'Złe zagrania własna połowa',
    AerialsWonOwnBox: 'Wygrane powietrzne własne pole',
    AerialsWonOppBox: 'Wygrane powietrzne pole rywala',
    AerialsTotalOppBox: 'Powietrzne łącznie pole rywala',
    AerialsTotalOwnBox: 'Powietrzne łącznie własne pole',
    FoulsOwnHalfPct: '% fauli własna połowa',
    RecoveriesOppHalf: 'Odbiory na poł. rywala',
    DuelsPct: '% wygranych pojedynków',
    TacklesUnsuccessful: 'Nieudane wślizgi',
    TacklesWasDribbledFirstThird: 'Wygrane pojedynki defensywne 1 na 1 ⅓',
    TacklesWasDribbledSecondThird: 'Wygrane pojedynki defensywne 1 na 1 ⅔',
    TacklesWasDribbledFinalThird: 'Wygrane pojedynki defensywne 1 na 1 ⅓ finałowa',
    BallProgressionFinalThird: 'Progresja do ⅓',
    DuelsTotal: 'Pojedynki',
    QuickRecoveries: 'Szybkie odbiory',
    ShotsPerNPG: 'Strzały na NPG',
    ShotsOutBox: 'Strzały spoza pola karnego',
    GoalsOutBox: 'Gole spoza pola karnego',
    ShootingOutBox: '% strzałów celnych spoza pola',
    HandPassing: '% podań ręką',
    Catching: '% chwytów',
    Caught: 'Złapany, ratuje',
    ClaimAccuracy: 'Skuteczność chwytów',
    HighTurnovers: 'Wysokie straty',
    ShotEndingHighTurnovers: 'Strzał po wysokiej stracie',
    GoalEndingHighTurnovers: 'Gol po wysokiej stracie',
    AverageCarriesProgress: 'Śr. progresja prowadzeń',
    ChanceEndingCarries: 'Prowadzenia kończące się okazją',
    AssistEndingCarries: 'Prowadzenia kończące się asystą',
    ShotEndingCarries: 'Prowadzenia kończące się strzałem',
    GoalEndingCarries: 'Prowadzenia kończące się golem',
    ShotEndingSequence: 'Sekwencja zakończona strzałem',
    GoalEndingSequence: 'Sekwencja zakończona golem',
    xGPerNPG: 'xG na NPG',
    AerialWonOffensive: 'Wygrane powietrzne ofensywne',
    AerialWonDefensive: 'Wygrane powietrzne defensywne',
    xGAgainst: 'xG przeciw',
    xGDiffAgainst: 'Różnica xG przeciw',
    xGPerNPGAgainst: 'xG na NPG przeciw',
    xGSetPieceAgainst: 'xG SFG przeciw',
    xGOpenPlayAgainst: 'xG z akcji przeciw',
    xGPerShotAgainst: 'xG na strzał przeciw',
    ShotsAgainst: 'Strzały przeciw',
    ShotsOnTargetAgainst: 'Strzały celne przeciw',
    ShotsOnTargetInBoxAgainst: 'Niecelne strzały w pole karne',
    ShotsOnTargetOutBoxAgainst: 'Stracone strzały celne po wyjęciu z pola karnego',
    RivalPossession: 'Posiadanie przeciwnika',
    AerialDefensivePct: '% powietrznych w obronie',
    HighRecoveries: 'Wysokie odbiory',
    HighDefensiveActions: 'Wysokie akcje defensywne',
    HighDefensiveActionPct: '% wysokich akcji defensywnych',
    HighDefensiveDistance: 'Wysokość działań defensywnych',
    PassesPerPossession: 'Podania na posiadanie',
    LengthPerPossession: 'Dystans na posiadanie',
    xTNet: 'xT netto',
    AvgCarriesDistance: 'Śr. dystans prowadzeń',
    PassesForwardPct: '% podań do przodu',
    PassesForwardSuccessful: 'Skuteczne podania w przód',
    PassesForwardTotal: 'Całkowita liczba podań w przód',
    TacklesAttempted: 'Próby wślizgów',
    DuelsLost: 'Przegrane pojedynki',
    Carries: 'Prowadzenia',
    CarriesPct: '% prowadzeń',
    Aerials: 'Pojedynki powietrzne',
    ProgressivePassesReceivedIntoBox: 'Otrzymane progresywne podania w pole karne',
    PassesOppHalf: 'Podania na poł. rywala',
    ShotsOnTarget: 'Strzały celne',
    AggressiveActions: 'Akcje agresywne',
    Crosses: 'Dośrodkowania',
    xGBuildup5pass: 'xGBuildup 5 podań',
    SpeedSequence: 'Szybkość sekwencji',
    Touches: 'Kontakty',
    AerialsTotalOppHalf: 'Pojedynki powietrzne łącznie na poł. rywala',
    AerialsWonOppHalf: 'Loty wygrały przeciw. Połowa',
    AerialsWonOppHalfPct: '% wygranych powietrznych na poł. rywala',
    AerialsPctOppBox: '% wygranych powietrznych w polu rywala',
    AerialsPctOwnBox: '% wygranych powietrznych we własnym polu',
    AerialDefensive: 'Powietrzne w defensywie',
    AerialOffensive: 'Powietrzne w ofensywie',
    AerialOffensivePct: '% powietrznych w ofensywie',
    IndividualPressureOppHalf: 'Presja indywidualna na poł. rywala',
    ChancesCreatedOP: 'Stworzone okazje z akcji',
    TouchesPerShot: 'Kontakty na strzał',
    PassesFinalThirdTotalPct: '% podań w ⅓',
    xACrosses: 'xA z dośrodkowań',
    Passes: 'Podania',
    PassesSuccessful: 'Udane podania',
    TacklesWasDribbledFouls: '% pojedynków na ziemi',
    OffsidesCaught: 'Złapane spalone',
    ProgressivePassesReceivedFinalThird: 'Otrzymane progresywne podania do ⅓',
    ProgressivePassesReceived: 'Otrzymane progresywne podania',
    Breadth: 'Szerokość',
    DuelsDefTotal: 'Pojedynki defensywne',
    DefensiveActions: 'Akcje defensywne',
    ProgressivePassesReceivedOppHalf: 'Otrzym. progresywne podania na poł. rywala',
    CompletedCrossesOP: 'Udane dośrodkowania z akcji',
    CrossingOP: '% dośrodkowań z akcji',
    CrossesOP: 'Całkowita liczba dośrodkowań Gra otwarta',
    PassingContribution: '% wkładu podań',
    BallProgressionOppHalfInTeam: '% progresji na poł. rywala w zespole',
    PassesOPIntoBoxInTeam: '% podań z akcji w pole w zespole',
    TouchesOppBoxInTeam: '% kontaktów w polu w zespole',
    xGOPInTeam: '% xG z akcji w zespole',
    DeepPasses: 'Głębokie podania',
    DeepPassesTotal: 'Głębokie podania',
    DefensiveDuelsPct: '% pojedynków defensywnych',
    DefensiveDistance: 'Dystans defensywny',
    QuickRecoveriesPct: '% szybkich odbiorów',
    DiffDefensiveDistanceTeam: 'Różn. dystansu defens. vs zespół',
    xTPassing: 'xT z podań',
    xTPassing100Passes: 'xT z podań na 100 podań',
    ProgressivePassesAccurate: 'Dokładne progresywne podania',
    PassAbility: 'Zdolność podań',
    OPPassesIntoOppBoxPct: '% podań z akcji w pole rywala',
    EntriesOppBox: 'Wejścia w pole karne',
    Crosses6yardBox: 'Dośrodkowania na 5. metr',
    Cutbacks: 'Wycofania',
    xTDribbling: 'xT z dryblingu',
    AvgShotDistance: 'Śr. dystans strzału',
    xGOnTarget: 'xG On Target',
    FinishingxGOT: 'Wykończenie xGOT',
    DribblesWonOwnHalf: 'Udane dryblingi na własnej połowie',
    DribblesOwnHalf: 'Dryblingi na własnej połowie',
    DribblesOwnHalfPct: '% dryblingów na własnej połowie',
    DribblesWonOppHalf: 'Udane dryblingi na poł. rywala',
    DribblesOppHalf: 'Dryblingi na poł. rywala',
    DribblesOppHalfPct: '% dryblingów na poł. rywala',
    DribblesWonFinalThird: 'Udane dryblingi w ⅓',
    DribblesFinalThird: 'Dryblingi w ⅓',
    DribblesFinalThirdPct: '% dryblingów w ⅓',
    ShotEndingHighRecoveries: 'Shot Ending High Recoveries',
    PassingFinalThirdAgainst: 'Podania w ⅓ – dopuszczone',
    OpenPlayPassesIntoOpponentBoxAgainst: 'Łącznie podania z akcji w nasze pole – dopuszczone',
    EntriesOppBoxAgainst: 'Wejścia w nasze pole karne – dopuszczone',
    DeepProgressionAgainst: 'Głęboka progresja – dopuszczone',
    TouchesInOpponentBoxAgainst: 'Kontakty w naszym polu karnym – dopuszczone',
    Score: 'Wynik',
    PDScore: 'Wynik fizyczny',
    OrlegiScore: 'Wynik Orlegi',
    SirScore: 'Wynik Sirius',
    ExcScore: 'Wynik Excelsior',
    xTOPInTeam: 'xT z akcji w zespole',
    YellowCards: 'Żółte kartki',
    RedCards: 'Czerwone kartki',
    xTOpenPlayAgainst: 'xT z akcji – dopuszczone',
    xTSetPieceAgainst: 'xT SFG – dopuszczone',
    NPGOpenPlayAgainst: 'NPG z akcji – dopuszczone',
    NPGSetPieceAgainst: 'NPG ze stałych frag. – dopuszczone',
    PassesOppHalfPerPossession: 'Podania na poł. rywala na posiadanie',
    AverageTimeRecovery: 'Śr. czas odzyskania',
    ExpectedPassing: '% oczekiwanych podań',
    NumPossession10Passes: 'Posiadania ≥10 podań',
    PassesReceived: 'Otrzymane podania',
    PassesReceivedFinalThird: 'Otrzym. podania do ⅓',
    ProgressivePassesTotalPct: '% progresywnych podań',
    ShortPassesPct: '% krótkich podań',
    TouchesOppBoxOppTeam: 'Kontakty przeciwnika w naszym polu',
    ShotsOnTargetOppTeam: 'Strzały celne przeciwnika',
    NPGOppTeam: 'NPG przeciwnika',
    ShotsOpenPlay: 'Strzały z akcji',
    xGSetPiecePerxG: 'xG SFG na xG',
    ShotsOpenPlayAgainst: 'Strzały z akcji – przeciw',
    ShotsFromDribble: 'Strzały po Dryblingu',
    GoalsFromDribble: 'Gole po Dryblingu',
    PassesIntoFinalThird: 'Podania do Ostatniej Trzeciej',
    PassesIntoFinalThirdTotal: 'Total Passs do finałowej trzeciej pozycji',
    PassesInsideFinalThird: 'Podania w Ostatniej Trzeciej',
    PassesInsideFinalThirdTotal: 'Całkowita liczba podań w finale ⅓',
    PassesFinalThirdNoArea: 'Przechodzi finałową trzecią część (bez pudełka)',
    PassesIntoOppBox: 'Podania do Pola Karnego Rywala',
    CarriesFinalThird: 'Prowadzenia do Ostatniej Trzeciej',
    CarriesInsideFinalThird: 'Prowadzenia w Ostatniej Trzeciej',
    CarriesFinalThirdNoBox: 'Zawiera ostatnią trzecią część (bez pudełka)',
    CarriesIntoOppBox: 'Prowadzenia do Pola Karnego Rywala',
    TimePossessionAgainst: 'Posiadanie Piłki Przeciwnika',
    TimePossessionTotal: 'Całkowite Posiadanie Piłki',
    PassesInBox: 'Podania w Własnym Polu Karnym',
    LongThrowInSuccessful: 'Udane Długie Wrzuty',
    LongThrowInTotal: 'Łączna Liczba Długich Wrzutów',
    LongThrowInPct: '% Udanych Długich Wrzutów',
    Games: 'Rozegrane gry',
    PointsPerGame: 'Punkty na mecz',
    ExpectedPointsDiff: 'Oczekiwana różnica punktów',
    PassesTotalOwnHalf: 'Suma podań Własna połowa',
    PassesOwnHalf: 'Podaje własną połowę',
    PassesTotalOppHalf: 'Przechodzi całkowitą połowę przeciwnika',
    ProgressivePassesTotal: 'Całkowita liczba przejść progresywnych',
    DuelsWon: 'Wygrane pojedynki',
    NonPenaltySaves: 'Obrony bez kary',
    BadActionsOppHalf: 'Złe działania przeciwnej połowy',
    CarriesSuccessful: 'Niesie sukces',
    ShotsOnTargetOutBox: 'Strzały celne po wyjęciu z pudełka',
    TotalDistance: 'Dystans całkowity',
    DistanceIP: 'Dystans TIP',
    DistanceOOP: 'Dystans OTIP',
    SprintsNumber: 'Liczba sprintów',
    SprintsDistance: 'Dystans sprintów',
    WalkingDistance: 'Dystans chodu',
    JoggingDistance: 'Dystans truchtu',
    RunningDistance: 'Dystans biegu',
    ExtremeAccelerations: 'Ekstremalne przyspieszenia',
    NumberOfRuns: 'Liczba biegów',
    HsrNumber: 'Liczba HSR',
    HsrDistance: 'Dystans HSR',
    SprintNumberDeclinePct: '% spadku liczby sprintów',
    SprintDistanceDeclinePct: '% spadku dystansu sprintów',
    SprintNumberDecline: 'Spadek liczby sprintów',
    SprintDistanceDecline: 'Spadek dystansu sprintów',
    HsrDistancePct: '% dystansu HSR',
    SprintDistancePct: '% dystansu sprintów',
    Accelerations: 'Przyspieszenia',
    ExplosiveDistance: 'Dystans eksplozywny',
    MaxSpeed: 'Prędkość maks.',
    AvgMaxSpeed: 'Śr. prędkość maks.',
    MaxAccelerations: 'Maks. przyspieszenia',
    BypassedPlayersByPasses: 'Minięci zawodnicy podaniami',
    BypassedDefendersByPasses: 'Minięci obrońcy podaniami',
    PassesBypassingPlayers: 'Podania omijające zawodników',
    PassesBypassingDefenders: 'Podania omijające obrońców',
    BypassedPlayersPerPass: 'Minięci zawodnicy na podanie',
    BypassedDefendersPerPass: 'Minięci obrońcy na podanie',
    LineBreakingPasses: 'Podania przełamujące linie',
    LineBreakingPassesMD: 'Podania przełamujące linie MD',
    LineBreakingPassesM: 'Podania przełamujące linie M',
    LineBreakingThroughBalls: 'Prostopadłe podania przełamujące linie',
    LineBreakingPassesPerPass: '% podań przełamujących linie na podania',
    TotalPassesUnderStrongPressure: 'Łącznie podań pod silną presją',
    TotalPassesUnderLightPressure: 'Łącznie podań pod presją',
    SuccessfulPassesUnderStrongPressure: 'Udane podania pod silną presją',
    SuccessfulPassesUnderLightPressure: 'Udane podania pod presją',
    PassingUnderStrongPressure: '% podań pod silną presją',
    PassingUnderLightPressure: '% podań pod presją',
    PassReceiptsInSpaceCompleted: 'Udane przyjęcia w przestrzeni',
    PassReceiptsInSpace: 'Przyjęcia w przestrzeni',
    PassReceiptsInSpaceCompletedFirstThird: 'Odbiory w Przestrzeni w 1/3 Boiska',
    PassReceiptsInSpaceCompletedSecondThird: 'Odbiory w Przestrzeni w 2/3 Boiska',
    PassReceiptsInSpaceCompletedFinalThird: 'Odbiory w Przestrzeni w Ostatniej 1/3',
    PassReceiptsInSpaceCompletedOppHalfRight: 'Odbiory w Przestrzeni (Prawa Strona, Połowa Rywala)',
    PassReceiptsInSpaceCompletedOppHalfCenter: 'Odbiory w Przestrzeni (Środek, Połowa Rywala)',
    PassReceiptsInSpaceCompletedOppHalfLeft: 'Odbiory w Przestrzeni (Lewa Strona, Połowa Rywala)',
    PassReceiptsInSpaceFirstThird: 'Odbiory w Przestrzeni w 1/3 Boiska',
    PassReceiptsInSpaceSecondThird: 'Odbiory w Przestrzeni w 2/3 Boiska',
    PassReceiptsInSpaceFinalThird: 'Odbiory w Przestrzeni w Ostatniej 1/3',
    PassReceiptsInSpaceOppHalfRight: 'Odbiory w Przestrzeni (Prawa Strona Rywala)',
    PassReceiptsInSpaceOppHalfCenter: 'Odbiory w Przestrzeni (Środek Rywala)',
    PassReceiptsInSpaceOppHalfLeft: 'Odbiory w Przestrzeni (Lewa Strona Rywala)',
    TotalStrongOnBallPressures: 'Łącznie silnych presji na piłkę',
    TotalLightOnBallPressures: 'Łącznie presji na piłkę',
    SuccessfulStrongOnBallPressures: 'Udane silne presje na piłkę',
    SuccessfulLightOnBallPressures: 'Udane presje na piłkę',
    StrongOnBallPressuresPct: '% silnych presji na piłkę',
    LightOnBallPressuresPct: '% presji na piłkę',
    TimesBypassedByPasses: 'Ile razy minięty podaniami',
    TimesBypassedByCarries: 'Ile razy minięty prowadzeniem',
    TimesBypassedByActions: 'Ile razy minięty akcjami',
    BypassedPlayersByCarries: 'Minięci zawodnicy prowadzeniem',
    BypassedDefendersByCarries: 'Minięci obrońcy prowadzeniem',
    BypassedPlayersByActions: 'Minięci zawodnicy akcjami',
    BypassedDefendersByActions: 'Minięci obrońcy akcjami',
    CarriesBypassingPlayers: 'Prowadzenia omijające zawodników',
    CarriesBypassingDefenders: 'Prowadzenia omijające obrońców',
    BypassedPlayersPerCarry: 'Minięci zawodnicy na prowadzenie',
    BypassedDefendersPerCarry: 'Minięci obrońcy na prowadzenie',
    LineBreakingCarries: 'Prowadzenia przełamujące linie',
    LineBreakingCarriesMD: 'Prowadzenia przełamujące linie MD',
    LineBreakingCarriesM: 'Prowadzenia przełamujące linie M',
    LineBreakingCarriesD: 'Prowadzenia przełamujące linie D',
    LineBreakingCarriesPerCarry: '% prowadzeń przełamujących linie na prowadzenia',
    LineBreakingActions: 'Akcje przełamujące linie',
    LineBreakingActionsMD: 'Akcje przełamujące linie MD',
    LineBreakingActionsM: 'Akcje przełamujące linie M',
    LineBreakingActionsD: 'Akcje przełamujące linie D',
    PassesPerLineBreakingPass: 'Podania na podanie przełamujące',
    CarriesPerLineBreakingCarry: 'Prowadzenia na prowadzenie przełamujące',
    LinesBrokenByPasses: 'Linie przełamane podaniami',
    LinesBrokenByCarries: 'Linie przełamane prowadzeniem',
    LinesBrokenByActions: 'Linie przełamane akcjami',
    LinesBrokenPerPass: 'Linie przełamane na podanie',
    LinesBrokenPerCarry: 'Linie przełamane na prowadzenie',
    AvgLastDefenderDistanceIP: 'Dystans ostatniego obrońcy IP',
    AvgLastDefenderDistanceOOP: 'Dystans ostatniego obrońcy OOP',
    AvgDefensiveLineDistanceIP: 'Dystans linii obrony IP',
    AvgDefensiveLineDistanceOOP: 'Dystans linii obrony OOP',
    AvgRBDistanceIP: 'Dystans prawego obrońcy IP',
    AvgRBDistanceOOP: 'Dystans prawego obrońcy OOP',
    AvgLBDistanceIP: 'Dystans lewego obrońcy IP',
    AvgLBDistanceOOP: 'Dystans lewego obrońcy OOP',
    AvgBlockDistanceIP: 'Dystans bloku IP',
    AvgBlockDistanceOOP: 'Dystans bloku OOP',
    AvgBlockAreaIP: 'Pole bloku IP',
    AvgBlockAreaOOP: 'Pole bloku OOP',
    AvgDefensiveLineWidthOOP: 'Szer. linii obrony OOP',
    AvgOffensiveLineLastThirdWidthIP: 'Szer. linii ofens. w ⅓ IP',
    AvgLByIP: 'Pozycja lewego obrońcy IP',
    AvgRByIP: 'Pozycja prawego obrońcy IP',
    AvgOffensiveLineDistanceIP: 'Dystans linii ofens. IP',
    AvgOffensiveLineLastThirdDistanceIP: 'Dystans linii ofens. w ⅓ IP',
    AvgOffensiveLineWidthIP: 'Szer. linii ofens. IP',
    OffBallRuns: 'Łącznie biegów bez piłki',
    OffBallRunsOverlap: 'Nadłożenia bez piłki',
    OffBallRunsUnderlap: 'Zejścia do środka bez piłki',
    OffBallRunsRunAhead: 'Biegi wyprzedzające',
    OffBallRunsRunBehind: 'Biegi za plecy',
    OffBallRunsCrossReceiver: 'Wejścia na dośrodkowania',
    OffBallRunsSupport: 'Biegi wspierające',
    OffBallRunsComingShort: 'Zejścia po piłkę',
    description: {
      Possession: 'Procent posiadania piłki przez zespół',
      TimePossession: 'Czas posiadania piłki przez zespół',
      PassesPerShots: 'Średnia liczba podań na jeden strzał',
      PPDA: 'Podania dopuszczone na akcję obronną. PPDA mierzy presję zespołu na rywalu w posiadaniu. Wartość to średnia liczba kolejnych podań przeciwnika przed przerwaniem akcji. Im wyższa, tym więcej podań dopuszczono',
      Directness: 'Mierzy bezpośredniość gry zespołu. Wysoka wartość oznacza większy udział podań do przodu względem podań wszerz',
      ExpectedPoints: 'Liczba oczekiwanych punktów wyliczana na podstawie wygenerowanego i straconego xG. Pozwala lepiej ocenić występ w meczu (lub serii meczów) względem faktycznych punktów',
      PassesPerLongBall: 'Odsetek udanych długich podań względem wszystkich udanych podań',
      CrossingPerXG: 'Odsetek xG pochodzący z dośrodkowań',
      PenaltySavedPenaltyFaced: 'Procent obronionych rzutów karnych względem karnych przeciw',
      Goals: 'Liczba goli',
      PenaltyShots: 'Liczba strzałów z rzutów karnych',
      PenaltyGoals: 'Liczba goli z rzutów karnych',
      NonPenaltyGoals: 'Liczba goli z wyłączeniem karnych',
      NPGOpenPlay: 'Liczba goli z akcji (bez karnych)',
      NPGSetPiece: 'Liczba goli ze stałych fragmentów (bez karnych)',
      Shooting: 'Odsetek strzałów w światło bramki',
      Finishing: 'Odsetek strzałów zakończonych golem',
      xGEfficiency: 'Ilość xG potrzebna do zdobycia jednej bramki',
      HeaderPerShot: 'Liczba strzałów głową',
      HeaderPerCross: 'Odsetek dośrodkowań drużyny zakończonych strzałem głową danego gracza',
      Assists: 'Liczba asyst',
      ThroughBalls: 'Liczba prostopadłych podań',
      CrossEfficiency: 'Wskaźnik łączący skuteczność i wolumen dośrodkowań',
      ScoringContribution: 'Asysty + gole',
      xAssistsOpenPlay: 'Liczba oczekiwanych asyst z akcji',
      xAssistsSetPiece: 'Liczba oczekiwanych asyst ze stałych fragmentów',
      xAssistsOpenPlayInTeam: 'Oczekiwane asysty z akcji w zespole',
      xAssistsSetPieceInTeam: 'Oczekiwane asysty SFG w zespole',
      xGChainFinalThird: 'Suma xG z udziałem zawodnika w ostatniej ⅓',
      xGBuildupFinalThird: 'Suma xG z udziałem w ostatniej ⅓ (bez strzałów i kluczowych podań)',
      BallProgressionPassing: 'Ile razy zawodnik progresuje piłkę podaniem o ≥10 m',
      BallProgressionDribbling: 'Ile razy zawodnik progresuje piłkę prowadzeniem o ≥10 m',
      TacklesWasDribbled: 'Wskaźnik odzysków wślizgiem względem przypadków minięcia/oddania piłki. Im wyższy, tym lepiej',
      TacklesSuccessful: 'Number of successful tackles made by the player',
      Interceptions: 'Liczba przechwytów',
      Clearances: 'Liczba wybić z pola obrony',
      Fouls: 'Liczba fauli',
      Recoveries: 'Liczba odbiorów piłki',
      Shots: 'Liczba strzałów',
      ShotsPerGoal: 'Liczba strzałów celnych potrzebna do NPG',
      ShortPassesSuccessful: 'Udane krótkie podania (<12 m)',
      PassingSuccessForwardPct: 'Odsetek udanych podań do przodu',
      PassingSuccessBackwardPct: 'Odsetek udanych podań do tyłu',
      PassingForwardBackwardPct: 'Relacja podań do przodu do podań do tyłu',
      LongBallPerPassesPct: 'Odsetek udanych długich podań (>32 m) wśród wszystkich udanych podań',
      LongBallReceived: 'Długie podania (>32 m) otrzymane przez gracza',
      LongBallReceivedOppHalf: 'Długie podania (>32 m) otrzymane na połowie rywala',
      OffensiveActions: 'Akcje ofensywne',
      DribblesAttempted: 'Próby dryblingu',
      SuccessfulDribblesPct: 'Udane dryblingi/łączne próby',
      OffensiveTouchesOutBoxPct: '% ofensywnych kontaktów poza polem karnym',
      BallRetention: 'Procent czasu z posiadaniem zakończonym bez straty',
      PassingPct: 'Odsetek udanych podań',
      PassingOwnHalfPct: 'Odsetek udanych podań na własnej połowie',
      PassingOppHalfPct: 'Odsetek udanych podań na połowie rywala',
      PassingFinalThird: 'Udane podania do ostatniej ⅓',
      PassesFinalThirdTotal: 'Całkowita liczba podań, z wyłączeniem dośrodkowań, stałych fragmentów gry, rzutów rożnych i wrzutów z autu, które kończą się w ostatniej tercji',
      PassingFinalThirdPct: 'Odsetek podań do ostatniej ⅓',
      LongBallSuccessful: 'Udane podania >32 m',
      LongBallPct: 'Udane podania >32 m / łączne próby >32 m',
      LongBallTotal: 'Łączna liczba przejść na długości 32 metrów',
      SavesPct: 'Odsetek obron względem strzałów',
      SavesInBoxPct: 'Odsetek obron strzałów z pola karnego',
      SavesOutOfBoxPct: 'Odsetek obron strzałów spoza pola',
      xGSavedPerXGFacedOnTarget: 'Współczynnik wskazujący, jaki procent oczekiwanego xG bramkarz broni. 1 oznacza obronę całego oczekiwanego xG strzałów na bramkę; 0 – że całe xG rywala kończy się golem',
      xGFacedOnTargetPerGoalReceived: 'Ile xG On Target potrzeba, by strzelić bramkarzowi jednego gola. Wyższa wartość = trudniej strzelić',
      xGFacedOnTargetEfficiency: 'Liczba bramek bez karnych zapobiegniętych przez bramkarza: xG On Target przeciw minus stracone NPG',
      xGFacedOnTarget: 'Łączne xG On Target przeciw bramkarzowi (obronione + gole)',
      IndividualPressure: 'Liczba skutecznych wysiłków (odzysków) przy pressingu',
      AerialEfficiency: 'Wskaźnik łączący skuteczność i liczbę wygranych pojedynków powietrznych',
      AerialWins: 'Wygrane pojedynki powietrzne',
      AerialWinsPct: 'Odsetek wygranych pojedynków powietrznych',
      xG: 'Gole oczekiwane. Mierzy prawdopodobieństwo, że strzał zakończy się golem w zależności od dystansu, kąta, typu akcji, części ciała itd.',
      xGDiff: 'Różnica między xG a golami',
      xGOpenPlay: 'Gole oczekiwane z akcji',
      xGSetPiece: 'Gole oczekiwane ze stałych fragmentów',
      xGPerShot: 'Średnie xG oddanych strzałów. Mierzy przeciętną groźność strzałów – im wyżej, tym lepsza selekcja',
      ChancesCreated: 'Liczba podań prowadzących do strzału',
      CompletedCrosses: 'Liczba udanych dośrodkowań',
      Crossing: 'Odsetek udanych dośrodkowań',
      OpenPlayKeyPasses: 'Liczba kluczowych podań z akcji',
      OpenPlayKeyPassesInTeam: 'Odsetek kluczowych podań z akcji w zespole',
      OpenPlayPassesIntoOpponentBox: 'Łączna liczba podań z akcji w pole karne',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Udane podania z akcji w pole karne',
      xAssists: 'Metryka jakości tworzonych sytuacji. Każda asysta strzelecka ma wartość wg prawdopodobieństwa gola (miejsce podania, typ – dośrodkowanie/prostopadłe/SFG – kontekst gry itd.). W odróżnieniu od xG, xA bywa wyższe niż faktyczne asysty, bo zależy od jakości podań, a nie skuteczności wykończenia',
      xGChain: 'Suma xG sekwencji z udziałem zawodnika',
      xGBuildup: 'Jak xG Chain, ale bez dwóch ostatnich udziałów w sekwencji (bez strzałów i kluczowych podań)',
      xGBuildupInTeam: 'Jak xG Chain, ale bez dwóch ostatnich udziałów – na poziomie zespołu',
      BallProgression: 'Ile razy zawodnik przesunął piłkę o ≥10 m (podaniem, prowadzeniem lub łącznie)',
      SuccessfulDribbles: 'Udane dryblingi',
      Dispossessed: 'Ile razy zawodnik traci piłkę po odbiorze rywala',
      TouchesInOpponentBox: 'Liczba kontaktów z piłką w polu karnym rywala',
      xGSavedPerShot: 'Średnie prawdopodobieństwo gola strzałów celnych przeciw',
      BallRetentionOppHalf: 'Odsetek posiadania zakończonego bez straty na połowie rywala',
      DeepProgression: 'Ile razy zespół/drużyna dociera prowadzeniem do ostatniej 1/5 boiska + posiadania w tej strefie',
      DeepProgressionFinalThird: 'Ile razy prowadzeniem osiągnięto ostatnią tercję + posiadania w tej tercji',
      FoulsTaken: 'Ile razy zawodnik był faulowany',
      PenaltiesTaken: 'Ile fauli na zawodniku w polu karnym',
      BlockedCrosses: 'Zablokowane dośrodkowania',
      BlockedShots: 'Zablokowane strzały',
      NonPenaltyGoalsAgainst: 'Stracone bramki bez karnych',
      GoalsConceded: 'Liczba bramek straconych',
      Headers: 'Liczba strzałów głową',
      HeadedGoals: 'Liczba bramek zdobytych głową',
      Points: 'Liczba punktów zdobytych przez zespół',
      SavesInBox: 'Liczba obron po strzałach w pole karne gry',
      SavesOutBox: 'Liczba obron po strzałach zza pola karnego',
      ShotsOnTargetInBoxAgainst: 'Liczba celnych strzałów oddanych z pola karnego',
      ShotsOnTargetOutBoxAgainst: 'Liczba celnych strzałów zza pola karnego oddanych',
      AveragePassDistance: 'Średni dystans podań (m)',
      ProgressiveRuns: 'Udane prowadzenia przybliżające posiadanie o 20% do bramki rywala',
      xT: 'Expected Threat (xT) mierzy zagrożenie tworzone podaniami lub prowadzeniem do stref o wyższym prawdopodobieństwie gola',
      xTOpenPlay: 'xT z akcji',
      xTSetPiece: 'xT ze stałych fragmentów',
      xGOT: 'Expected Goals On Target – xG strzałów celnych przeciw bramkarzowi (bez niecelnych i w słupek)',
      BadActions: 'Suma złych akcji (nieudane podanie, nieudany drybling, strata, spalony, nieudany kontakt)',
      BadActionsOwnHalf: 'Suma złych akcji na własnej połowie',
      AerialsWonOwnBox: 'Wygrane pojedynki w powietrzu – własne pole karne',
      AerialsWonOppBox: 'Wygrane pojedynki w powietrzu – pole karne rywala',
      AerialsTotalOppBox: 'Łącznie pojedynków powietrznych – pole karne rywala',
      AerialsTotalOwnBox: 'Łącznie pojedynków powietrznych – własne pole karne',
      FoulsOwnHalfPct: 'Odsetek fauli na własnej połowie',
      RecoveriesOppHalf: 'Odbiory/odzyski na połowie rywala',
      DuelsPct: 'Odsetek wygranych pojedynków',
      TacklesUnsuccessful: 'Próby odbioru zakończone minięciem przez rywala',
      TacklesWasDribbledFirstThird: 'Odsetek odzysków, gdy atakowany w pierwszej tercji',
      TacklesWasDribbledSecondThird: 'Wygrane pojedynki defensywne 1 na 1 – druga tercja',
      TacklesWasDribbledFinalThird: 'Wygrane pojedynki defensywne 1 na 1 – ostatnia tercja',
      BallProgressionFinalThird: 'Progresja piłki do ostatniej tercji',
      DuelsTotal: 'Łącznie: odbiory, pojedynki powietrzne, kontakty, dryblingi, faule',
      QuickRecoveries: 'Odzyski ≥40 m od własnej bramki w 8 s po stracie',
      ShotsPerNPG: 'Średnia liczba strzałów na bramkę bez karnego',
      ShotsOutBox: 'Strzały spoza pola karnego',
      GoalsOutBox: 'Gole spoza pola karnego',
      ShootingOutBox: 'Odsetek strzałów celnych spoza pola karnego',
      HandPassing: 'Celność podań ręką',
      Catching: 'Odsetek interwencji z chwytaniem piłki',
      Caught: 'Ratuje miejsce, w którym bramkarz łapie i przytrzymuje piłkę, uniemożliwiając jakąkolwiek drugą grę',
      ClaimAccuracy: 'Skuteczność w powietrzu; >1 oznacza lepsze niż oczekiwane łapanie/blokowanie dośrodkowań',
      HighTurnovers: 'Straty bliżej niż 40 m od własnej bramki',
      ShotEndingHighTurnovers: 'Straty <40 m od własnej bramki kończące się strzałem rywala',
      GoalEndingHighTurnovers: 'Straty <40 m od własnej bramki kończące się golem rywala',
      AverageCarriesProgress: 'Średni pionowy zysk na jedno prowadzenie (m)',
      ChanceEndingCarries: 'Prowadzenia ≥7 m zakończone podaniem po którym jest strzał',
      AssistEndingCarries: 'Prowadzenia ≥7 m zakończone podaniem po którym jest gol',
      ShotEndingCarries: 'Prowadzenia ≥7 m zakończone strzałem',
      GoalEndingCarries: 'Prowadzenia ≥7 m zakończone golem',
      ShotEndingSequence: 'Sekwencje zakończone strzałem z udziałem zawodnika',
      GoalEndingSequence: 'Sekwencje zakończone golem z udziałem zawodnika',
      xGPerNPG: 'xG potrzebne do zdobycia gola bez karnego',
      AerialWonOffensive: 'Wygrane pojedynki powietrzne w ataku',
      AerialWonDefensive: 'Wygrane pojedynki powietrzne w obronie',
      xGAgainst: 'xG przeciw',
      xGDiffAgainst: 'Różnica xG przeciw – gole stracone',
      xGPerNPGAgainst: 'xG przeciw na jednego straconego gola bez karnego',
      xGSetPieceAgainst: 'xG przeciw ze stałych fragmentów',
      xGOpenPlayAgainst: 'xG przeciw z akcji',
      xGPerShotAgainst: 'xG przeciw na strzał',
      ShotsAgainst: 'Strzały przeciw',
      ShotsOnTargetAgainst: 'Strzały celne przeciw',
      RivalPossession: 'Posiadanie rywala',
      AerialDefensivePct: 'Odsetek wygranych pojedynków powietrznych bez piłki',
      HighRecoveries: 'Odzyski piłki 40 m lub bliżej bramki rywala',
      HighDefensiveActions: 'Akcje defensywne ≥40 m od własnej linii końcowej (odb., przechwyty, bloki, faule, 1v1)',
      HighDefensiveActionPct: 'Odsetek akcji defensywnych ≥40 m od własnej linii końcowej',
      HighDefensiveDistance: 'Średnia odległość od własnej bramki dla akcji defensywnych',
      PassesPerPossession: 'Podań na posiadanie',
      LengthPerPossession: 'Dystans na posiadanie',
      xTNet: 'xT netto',
      AvgCarriesDistance: 'Średni dystans prowadzeń',
      PassesForwardPct: '% podań do przodu',
      PassesForwardSuccessful: 'Skuteczne podania w przód',
      PassesForwardTotal: 'Całkowita liczba podań w przód',
      TacklesAttempted: 'Próby odbioru',
      DuelsLost: 'Pojedynki przegrane',
      Carries: 'Prowadzenia',
      CarriesPct: '% prowadzeń',
      Aerials: 'Łącznie pojedynków powietrznych',
      ProgressivePassesReceivedIntoBox: 'Otrzymane progresywne podania w pole karne',
      PassesOppHalf: 'Udane podania kończące się na połowie rywala',
      ShotsOnTarget: 'Strzały celne',
      AggressiveActions: 'Próby odbioru w ciągu 2 s po stracie',
      Crosses: 'Łącznie dośrodkowań',
      xGBuildup5pass: 'Suma xG z ostatnich 5 podań w sekwencji (bez strzału i podania do strzału)',
      DefensiveDistance: 'Średnia odległość od własnej bramki dla pojedynków defensywnych',
      SpeedSequence: 'Średnia prędkość posiadania (metry/czas)',
      Touches: 'Kontakty z piłką',
      AerialsTotalOppHalf: 'Łącznie pojedynków powietrznych na połowie rywala',
      AerialsWonOppHalf: 'Pojedynki powietrzne zakończone sukcesem na połowę przeciwnika',
      AerialsWonOppHalfPct: 'Odsetek wygranych pojedynków powietrznych na połowie rywala',
      AerialsPctOppBox: 'Odsetek wygranych pojedynków powietrznych w polu karnym rywala',
      AerialsPctOwnBox: 'Odsetek wygranych pojedynków powietrznych we własnym polu',
      AerialDefensive: 'Łącznie pojedynków powietrznych przy posiadaniu rywala',
      AerialOffensive: 'Łącznie pojedynków powietrznych przy posiadaniu własnym',
      AerialOffensivePct: 'Odsetek wygranych w powietrzu przy posiadaniu własnym',
      IndividualPressureOppHalf: 'Skuteczne odzyski przy pressingu na połowie rywala',
      ChancesCreatedOP: 'Podań do strzału z akcji',
      TouchesPerShot: 'Kontakty z piłką na strzał',
      PassesFinalThirdTotalPct: 'Odsetek wszystkich podań do ostatniej tercji',
      xACrosses: 'Oczekiwane asysty z dośrodkowań',
      Passes: 'Łącznie podań',
      PassesSuccessful: 'Udane podania',
      TacklesWasDribbledFouls: 'Odsetek wygranych odbiorów względem sumy odbiorów i fauli',
      OffsidesCaught: 'Spalone złapane',
      ProgressivePassesReceivedFinalThird: 'Otrzymane progresywne podania – ostatnia tercja',
      ProgressivePassesReceived: 'Otrzymane progresywne podania',
      Breadth: 'Suma odbiorów, wyzwań, przechwytów i fauli przy linii bocznej',
      DuelsDefTotal: 'Suma odbiorów, defensywnych pojedynków powietrznych i fauli',
      DefensiveActions: 'Akcje defensywne przeciw próbom dryblingu (odb., wyzwania, faule)',
      ProgressivePassesReceivedOppHalf: 'Otrzymane progresywne podania – połowa rywala',
      CompletedCrossesOP: 'Udane dośrodkowania z akcji',
      CrossingOP: 'Odsetek udanych dośrodkowań z akcji',
      CrossesOP: 'Całkowita liczba dośrodkowań w grze otwartej',
      PassingContribution: 'Udział w tworzeniu zagrożenia podaniami z uwzględnieniem pozycji odbiorcy',
      BallProgressionOppHalfInTeam: '% progresji piłki na połowie rywala w zespole',
      PassesOPIntoBoxInTeam: '% podań z akcji w pole karne w zespole',
      TouchesOppBoxInTeam: '% kontaktów w polu karnym rywala w zespole',
      xGOPInTeam: '% xG z akcji w zespole',
      DeepPasses: 'Podania z poza promienia 20 m od bramki rywala kończące się w tej strefie',
      DeepPassesTotal: 'Łączna liczba podań wykonanych spoza promienia 20 metrów od bramki przeciwnika, które zakończyły się w tym obszarze',
      DefensiveDuelsPct: 'Odsetek wygranych pojedynków defensywnych',
      QuickRecoveriesPct: 'Odsetek szybkich odzysków względem przechwytów i prób odbioru',
      DiffDefensiveDistanceTeam: 'Różnica dystansu defensywnego zawodnika względem drużyny',
      xTPassing: 'xT generowane wyłącznie podaniami',
      xTPassing100Passes: 'xT generowane podaniami na 100 podań',
      ProgressivePassesAccurate: 'Udane podania progresywne (≥10 m w osi X)',
      PassAbility: 'Relacja udanych podań do oczekiwanych (xP)',
      OPPassesIntoOppBoxPct: 'Odsetek podań z akcji w pole karne (udane/łączne próby)',
      EntriesOppBox: 'Wejścia w pole karne podaniami i prowadzeniami',
      Crosses6yardBox: 'Dośrodkowania kończące się w polu bramkowym',
      Cutbacks: 'Wycofania z linii końcowej w pole karne',
      xTDribbling: 'xT generowane wyłącznie dryblingami',
      AvgShotDistance: 'Średni dystans strzałów',
      xGOnTarget: 'xG strzałów celnych – prawdopodobieństwo gola wg miejsca zakończenia',
      FinishingxGOT: 'Nadwyżka goli ze strzałów celnych vs średnia – jakość uderzeń',
      DribblesWonOwnHalf: 'Udane dryblingi na własnej połowie',
      DribblesOwnHalf: 'Próby dryblingu na własnej połowie',
      DribblesOwnHalfPct: 'Odsetek udanych prób dryblingu na własnej połowie',
      DribblesWonOppHalf: 'Udane dryblingi na połowie rywala',
      DribblesOppHalf: 'Próby dryblingu na połowie rywala',
      DribblesOppHalfPct: 'Odsetek udanych prób dryblingu na połowie rywala',
      DribblesWonFinalThird: 'Udane dryblingi w ostatniej tercji',
      DribblesFinalThird: 'Próby dryblingu w ostatniej tercji',
      DribblesFinalThirdPct: 'Odsetek udanych prób dryblingu w ostatniej tercji',
      ShotEndingHighRecoveries: 'Wysokie odzyski kończące się strzałem',
      PassingFinalThirdAgainst: 'Udane podania rywala do ostatniej tercji',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Łącznie podań rywala z akcji w nasze pole karne',
      EntriesOppBoxAgainst: 'Wejścia rywala w nasze pole karne podaniami i prowadzeniami',
      DeepProgressionAgainst: 'Ile razy rywal dociera prowadzeniem do naszej ostatniej 1/5 + posiadania w pierwszej 1/5',
      TouchesInOpponentBoxAgainst: 'Kontakty rywala z piłką w naszym polu karnym',
      Score: 'Ocena zawodnika na podstawie wybranych metryk',
      PDScore: 'Wydolność fizyczna na podstawie metryk fizycznych',
      OrlegiScore: 'Ocena zawodnika na podstawie wybranych metryk',
      SirScore: 'Ocena zawodnika na podstawie wybranych metryk',
      ExcScore: 'Ocena zawodnika na podstawie wybranych metryk',
      xTOPInTeam: 'xT z akcji w zespole',
      YellowCards: 'Żółte kartki',
      RedCards: 'Czerwone kartki',
      xTOpenPlayAgainst: 'xT przeciw z akcji',
      xTSetPieceAgainst: 'xT przeciw ze stałych fragmentów',
      NPGOpenPlayAgainst: 'Stracone gole z akcji (bez karnych)',
      NPGSetPieceAgainst: 'Stracone gole ze stałych fragmentów (bez karnych)',
      PassesOppHalfPerPossession: 'Podań na posiadanie kończących się na połowie rywala',
      AverageTimeRecovery: 'Śr. czas odzysku',
      ExpectedPassing: 'Odsetek podań, które powinny być celne (xP)',
      NumPossession10Passes: 'Posiadania z ≥10 podaniami',
      PassesReceived: 'Otrzymane podania',
      PassesReceivedFinalThird: 'Otrzymane podania – ostatnia tercja',
      ProgressivePassesTotalPct: 'Odsetek podań progresywnych',
      ShortPassesPct: 'Odsetek krótkich podań',
      TouchesOppBoxOppTeam: 'Działania rywala w naszym polu karnym, gdy zawodnik jest na boisku',
      ShotsOnTargetOppTeam: 'Strzały celne rywala, gdy zawodnik jest na boisku',
      NPGOppTeam: 'Stracone bramki bez karnych, gdy zawodnik jest na boisku',
      xGSetPiecePerxG: 'xG ze stałych fragmentów potrzebne do wygenerowania 1 xG',
      ShotsOpenPlay: 'Strzały z akcji',
      ShotsOpenPlayAgainst: 'Strzały rywala z akcji',
      ShotsFromDribble: 'Strzały oddane po przedryblowaniu przeciwnika',
      GoalsFromDribble: 'Gole zdobyte po przedryblowaniu przeciwnika',
      PassesIntoFinalThird: 'Udane podania z ostatniej trzeciej części boiska',
      PassesIntoFinalThirdTotal: 'Całkowita liczba podań rozpoczynała się na zewnątrz i kończyła w ostatniej tercji',
      PassesInsideFinalThird: 'Udane podania wewnątrz ostatniej trzeciej (początek i koniec w tej strefie)',
      PassesInsideFinalThirdTotal: 'Suma podań w ostatniej tercji (rozpoczęcie i zakończenie w ostatniej tercji)',
      PassesFinalThirdNoArea: 'Przechodzi finałową trzecią część (bez pudełka)',
      PassesIntoOppBox: 'Udane podania zakończone w polu karnym przeciwnika',
      CarriesFinalThird: 'Prowadzenia piłki na co najmniej 7 metrów kończące się w ostatniej trzeciej',
      CarriesInsideFinalThird: 'Prowadzenia piłki na co najmniej 7 metrów wewnątrz ostatniej trzeciej (start i koniec w tej samej strefie)',
      CarriesFinalThirdNoBox: 'Zawiera ostatnią trzecią część (bez pudełka)',
      CarriesIntoOppBox: 'Prowadzenia piłki na co najmniej 7 metrów kończące się w polu karnym przeciwnika',
      TimePossessionAgainst: 'Czas posiadania piłki przez drużynę przeciwną',
      TimePossessionTotal: 'Całkowity czas posiadania piłki przez obie drużyny',
      PassesInBox: 'Udane podania w polu karnym własnej drużyny',
      LongThrowInSuccessful: 'Udany długi wrzut z autu wykonany z zamiarem osiągnięcia ponad 20 metrów',
      LongThrowInTotal: 'Łączna liczba długich wrzutów z autu (ponad 20 metrów)',
      LongThrowInPct: 'Procent udanych długich wrzutów (powyżej 20 metrów)',
      Games: 'Rozegrane gry',
      PointsPerGame: 'Punkty na mecz',
      ExpectedPointsDiff: 'Oczekiwana różnica punktów',
      PassesTotalOwnHalf: 'Całkowita liczba podań wykonanych z własnej połowy',
      PassesOwnHalf: 'Liczba udanych podań wykonanych z własnej połowy',
      PassesTotalOppHalf: 'Całkowita liczba podań wykonanych z połowy przeciwnika',
      ProgressivePassesTotal: 'Całkowita liczba przejść o długości 10 metrów lub więcej w osi X',
      DuelsWon: 'Udane pojedynki (odbiory, podania w powietrzu, dotknięcia piłki, dryblingi i faule)',
      NonPenaltySaves: 'Obrony z wyłączeniem rzutów karnych',
      BadActionsOppHalf: 'Suma wszystkich popełnionych złych działań (nieudane podanie, nieudane przyjęcie, wywłaszczenie, podanie spalone, nieudane dotknięcie piłki) na połowie przeciwnika',
      CarriesSuccessful: 'Liczba przeniesień co najmniej 7 metrów zakończonych sukcesem',
      ShotsOnTargetOutBox: 'Strzały celne zza pola karnego',
      TotalDistance: 'Łączny dystans przebiegnięty w meczu',
      WalkingDistance: 'Dystans przy prędkości < 2 m/s (7,2 km/h)',
      JoggingDistance: 'Dystans 2–4 m/s (7,2–14,4 km/h)',
      RunningDistance: 'Dystans 4–5,5 m/s (14,4–19,8 km/h)',
      ExtremeAccelerations: 'Liczba przyspieszeń > 3 m/s<sup>2</sup>',
      NumberOfRuns: 'Liczba biegów 4–5,5 m/s (14,4–19,8 km/h)',
      DistanceIP: 'Dystans TIP (Team In Possession) – z posiadaniem',
      DistanceOOP: 'Dystans OTIP (Opponent Team In Possession) – bez posiadania',
      HsrNumber: 'Liczba odcinków ≥5,5 m/s i <7 m/s trwających ≥1 s',
      HsrDistance: 'Dystans przy ≥5,5 m/s i <7 m/s',
      HsrDistancePct: 'Odsetek dystansu HSR względem całego dystansu',
      SprintsNumber: 'Liczba sprintów ≥7 m/s trwających ≥1 s',
      SprintsDistance: 'Dystans przy prędkości ≥7 m/s',
      SprintNumberDeclinePct: 'Spadek % liczby sprintów względem II połowy',
      SprintDistanceDeclinePct: 'Spadek % dystansu sprintów względem II połowy',
      SprintNumberDecline: 'Spadek liczby sprintów względem II połowy',
      SprintDistanceDecline: 'Spadek dystansu sprintów względem II połowy',
      SprintDistancePct: 'Odsetek dystansu sprintów względem całego dystansu',
      Accelerations: 'Liczba przyspieszeń 1,5–3 m/s<sup>2</sup>',
      ExplosiveDistance: 'Dystans eksplozywny',
      MaxSpeed: 'Maksymalna prędkość zawodnika',
      AvgMaxSpeed: 'Średnia maksymalna prędkość zawodnika',
      MaxAccelerations: 'Maksymalne m/s<sup>2</sup> zawodnika',
      BypassedPlayersByPasses: 'Łączna liczba rywali (obrońców i pomocników) ominiętych podaniami',
      BypassedDefendersByPasses: 'Łączna liczba obrońców ominiętych podaniami',
      PassesBypassingPlayers: 'Liczba podań, które ominęły rywali',
      PassesBypassingDefenders: 'Liczba podań, które ominęły obrońców',
      BypassedPlayersPerPass: 'Średnia liczba ominiętych rywali na podanie',
      BypassedDefendersPerPass: 'Średnia liczba ominiętych obrońców na podanie',
      LineBreakingPasses: 'Udane podania przełamujące jedną lub więcej linii obrony',
      LineBreakingPassesMD: 'Udane podania przełamujące linię pomocy i obrony',
      LineBreakingPassesM: 'Udane podania przełamujące linię pomocy',
      LineBreakingThroughBalls: 'Udane podania przełamujące linię obrony',
      LineBreakingPassesPerPass: 'Odsetek podań przełamujących linie na podanie',
      TotalPassesUnderStrongPressure: 'Łącznie podań pod silną presją (0–2 m do najbliższego rywala)',
      TotalPassesUnderLightPressure: 'Łącznie podań pod lekką presją (2–4 m do najbliższego rywala)',
      SuccessfulPassesUnderStrongPressure: 'Udane podania pod silną presją (0–2 m)',
      SuccessfulPassesUnderLightPressure: 'Udane podania pod lekką presją (2–4 m)',
      PassingUnderStrongPressure: 'Odsetek udanych i wszystkich podań pod silną presją (0–2 m)',
      PassingUnderLightPressure: 'Odsetek udanych i wszystkich podań pod lekką presją (2–4 m)',
      PassReceiptsInSpaceCompleted: 'Podania, gdy odbierający jest na połowie ataku i nie ma obrońcy w promieniu 5 m w kierunku bramki',
      PassReceiptsInSpace: 'Przyjęcia podań na połowie ataku bez obrońcy w promieniu 5 m w kierunku bramki',
      PassReceiptsInSpaceCompletedFirstThird: 'Podania, w których odbierający znajduje się w pierwszej trzeciej boiska bez obrońcy w promieniu 5 metrów w kierunku bramki',
      PassReceiptsInSpaceCompletedSecondThird: 'Podania, w których odbierający znajduje się w drugiej trzeciej boiska bez obrońcy w promieniu 5 metrów w kierunku bramki',
      PassReceiptsInSpaceCompletedFinalThird: 'Podania, w których odbierający znajduje się w ostatniej trzeciej boiska bez obrońcy w promieniu 5 metrów w kierunku bramki',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Podania, w których odbierający znajduje się na prawej stronie połowy przeciwnika bez obrońcy w promieniu 5 metrów',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Podania, w których odbierający znajduje się w środkowej części połowy przeciwnika bez obrońcy w promieniu 5 metrów',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Podania, w których odbierający znajduje się na lewej stronie połowy przeciwnika bez obrońcy w promieniu 5 metrów',
      PassReceiptsInSpaceFirstThird: 'Odbiory w pierwszej trzeciej boiska bez obrońcy w promieniu 5 metrów w kierunku bramki',
      PassReceiptsInSpaceSecondThird: 'Odbiory w drugiej trzeciej boiska bez obrońcy w promieniu 5 metrów w kierunku bramki',
      PassReceiptsInSpaceFinalThird: 'Odbiory w ostatniej trzeciej boiska bez obrońcy w promieniu 5 metrów w kierunku bramki',
      PassReceiptsInSpaceOppHalfRight: 'Odbiory na prawej stronie połowy przeciwnika bez obrońcy w promieniu 5 metrów w kierunku bramki',
      PassReceiptsInSpaceOppHalfCenter: 'Odbiory w środkowej części połowy przeciwnika bez obrońcy w promieniu 5 metrów w kierunku bramki',
      PassReceiptsInSpaceOppHalfLeft: 'Odbiory na lewej stronie połowy przeciwnika bez obrońcy w promieniu 5 metrów w kierunku bramki',
      TotalStrongOnBallPressures: 'Liczba silnych presji na piłkę (0–2 m od prowadzącego)',
      TotalLightOnBallPressures: 'Liczba presji na piłkę (2–4 m od prowadzącego)',
      SuccessfulStrongOnBallPressures: 'Udane silne presje na piłkę (0–2 m)',
      SuccessfulLightOnBallPressures: 'Udane presje na piłkę (2–4 m)',
      StrongOnBallPressuresPct: 'Odsetek udanych i wszystkich silnych presji na piłkę (0–2 m)',
      LightOnBallPressuresPct: 'Odsetek udanych i wszystkich presji na piłkę (2–4 m)',
      TimesBypassedByPasses: 'Ile razy został ominięty podaniem',
      TimesBypassedByCarries: 'Ile razy został ominięty prowadzeniem',
      TimesBypassedByActions: 'Ile razy został ominięty podaniem lub prowadzeniem łącznie',
      BypassedPlayersByCarries: 'Łączna liczba rywali ominiętych prowadzeniem',
      BypassedDefendersByCarries: 'Łączna liczba obrońców ominiętych prowadzeniem',
      BypassedPlayersByActions: 'Łączna liczba rywali ominiętych podaniami i prowadzeniem',
      BypassedDefendersByActions: 'Łączna liczba obrońców ominiętych podaniami i prowadzeniem',
      CarriesBypassingPlayers: 'Liczba prowadzeń omijających rywali',
      CarriesBypassingDefenders: 'Liczba prowadzeń omijających obrońców',
      BypassedPlayersPerCarry: 'Średnia liczba ominiętych rywali na prowadzenie',
      BypassedDefendersPerCarry: 'Średnia liczba ominiętych obrońców na prowadzenie',
      LineBreakingCarries: 'Prowadzenia przełamujące jedną lub więcej linii obrony',
      LineBreakingCarriesMD: 'Prowadzenia przełamujące linię pomocy i obrony',
      LineBreakingCarriesM: 'Prowadzenia przełamujące linię pomocy',
      LineBreakingCarriesD: 'Prowadzenia przełamujące linię obrony',
      LineBreakingCarriesPerCarry: 'Odsetek prowadzeń przełamujących linie na prowadzenie',
      LineBreakingActions: 'Podania i prowadzenia przełamujące jedną lub więcej linii obrony',
      LineBreakingActionsMD: 'Podania i prowadzenia przełamujące linię pomocy i obrony',
      LineBreakingActionsM: 'Podania i prowadzenia przełamujące linię pomocy',
      LineBreakingActionsD: 'Podania i prowadzenia przełamujące linię obrony',
      PassesPerLineBreakingPass: 'Liczba podań na jedno podanie przełamujące linię',
      CarriesPerLineBreakingCarry: 'Liczba prowadzeń na jedno prowadzenie przełamujące linię',
      LinesBrokenByPasses: 'Łącznie linii przełamanych podaniami',
      LinesBrokenByCarries: 'Łącznie linii przełamanych prowadzeniami',
      LinesBrokenByActions: 'Łącznie linii przełamanych podaniami i prowadzeniami',
      LinesBrokenPerPass: 'Liczba przełamanych linii na podanie',
      LinesBrokenPerCarry: 'Liczba przełamanych linii na prowadzenie',
      AvgLastDefenderDistanceIP: 'Odległość ostatniego obrońcy od linii bramkowej przy posiadaniu',
      AvgLastDefenderDistanceOOP: 'Odległość ostatniego obrońcy od linii bramkowej bez posiadania',
      AvgDefensiveLineDistanceIP: 'Odległość najgłębszej linii obrony od bramki przy posiadaniu',
      AvgDefensiveLineDistanceOOP: 'Odległość najgłębszej linii obrony od bramki bez posiadania',
      AvgRBDistanceIP: 'Odległość prawego obrońcy od własnej bramki przy posiadaniu',
      AvgRBDistanceOOP: 'Odległość prawego obrońcy od własnej bramki bez posiadania',
      AvgLBDistanceIP: 'Odległość lewego obrońcy od własnej bramki przy posiadaniu',
      AvgLBDistanceOOP: 'Odległość lewego obrońcy od własnej bramki bez posiadania',
      AvgBlockDistanceIP: 'Odległość między najgłębszym a najwyżej ustawionym zawodnikiem w polu gry przy posiadaniu',
      AvgBlockDistanceOOP: 'Odległość między najgłębszym a najwyżej ustawionym zawodnikiem bez posiadania',
      AvgBlockAreaIP: 'Pole powierzchni otoczki wszystkich graczy z pola – zajmowana przestrzeń – przy posiadaniu',
      AvgBlockAreaOOP: 'Pole powierzchni otoczki wszystkich graczy z pola – bez posiadania',
      AvgDefensiveLineWidthOOP: 'Szerokość ostatniej linii w obronie bez posiadania',
      AvgOffensiveLineLastThirdWidthIP: 'Szerokość linii ataku w ostatniej tercji przy posiadaniu',
      AvgLByIP: 'Pozycja lewego obrońcy przy posiadaniu',
      AvgRByIP: 'Pozycja prawego obrońcy przy posiadaniu',
      AvgOffensiveLineDistanceIP: 'Odległość linii ataku od własnej bramki przy posiadaniu',
      AvgOffensiveLineLastThirdDistanceIP: 'Odległość linii ataku od własnej bramki w ostatniej tercji przy posiadaniu',
      AvgOffensiveLineWidthIP: 'Szerokość linii ataku przy posiadaniu',
      OffBallRuns: 'Intencjonalne biegi bez piłki wspierające fazę ataku',
      OffBallRunsOverlap: 'Biegi na obieg – po zewnętrznej bliżej linii bocznej, gdy partner ma piłkę',
      OffBallRunsUnderlap: 'Biegi na zejście – wewnętrzną ścieżką bliżej środka boiska',
      OffBallRunsRunAhead: 'Bieg do przodu wyprzedzający prowadzącego piłkę, przed ostatnim obrońcą',
      OffBallRunsRunBehind: 'Bieg za linię obrony w przestrzeń między obrońcami a bramkarzem',
      OffBallRunsCrossReceiver: 'Wejście w pole karne do przyjęcia dośrodkowania',
      OffBallRunsSupport: 'Bieg równoległy do prowadzącego – oferuje bliską opcję podania',
      OffBallRunsComingShort: 'Zejście do piłki, by zaoferować krótkie wsparcie',
      AerialsOppHalf: 'Wygrane pojedynki powietrzne na połowie rywala',
      CarriesIntoFinalThird: 'Rurociągi o długości co najmniej 7 metrów od zewnątrz do wewnątrz ostatniej jednej trzeciej',
      SpeedScore: 'Wydajność fizyczna gracza w oparciu o różne wskaźniki prędkości',
      EnduranceScore: 'Wytrzymałość fizyczna zawodnika na podstawie różnych wskaźników',
      SwitchPlaySuccessful: 'Liczba ukończonych podań na odległość powyżej 32 metrów, w przypadku których przemieszczenie boczne piłki jest większe niż jej przemieszczenie w kierunku bramki przeciwnika',
      SwitchPlayTotal: 'Całkowita liczba prób podań na odległość ponad 32 metrów, podczas których przemieszczenie boczne piłki jest większe niż jej przemieszczenie w kierunku bramki przeciwnika',
      PassesInsideOppHalf: 'Łączna liczba podań rozpoczynających się i kończących na połowie przeciwnika',
      PassesInsideOppHalfSuccessful: 'Liczba wykonanych podań, które zaczynają się i kończą na połowie przeciwnika',
      TacklesAttemptedFirstThird: 'Całkowita liczba prób wślizgu w pierwszej trzeciej części boiska',
      TacklesAttemptedSecondThird: 'Całkowita liczba prób wślizgu w drugiej trzeciej części boiska',
      TacklesFirstThird: 'Liczba udanych odbiorów wykonanych w pierwszej trzeciej części boiska',
      TacklesSecondThird: 'Liczba udanych odbiorów wykonanych w drugiej trzeciej części boiska',
      FoulsOwnHalf: 'Liczba fauli popełnionych na własnej połowie zawodnika',
      TouchesOppHalf: 'Liczba dotknięć piłki na połowie przeciwnika',
      TacklesAttemptedNotAdjusted: 'Całkowita liczba prób odbiorów, bez korekty posiadania',
      TacklesSuccessfulNotAdjusted: 'Całkowita liczba udanych odbiorów, bez korekty posiadania',
      AvgTop5MaxSpeed: 'Średnia z pięciu najwyższych maksymalnych prędkości gracza',
      LBPReceived: 'Liczba otrzymanych przejść naruszających linię. Są to kompletne podania, które przesuwają piłkę co najmniej 10% bliżej bramki przeciwnika i przecinają parę obrońców znajdujących się w bliskiej odległości lub wykraczają poza linię obrony',
      LBPMReceived: 'Liczba otrzymanych podań, które przedarły się przez linię pomocy przeciwnika',
      LBPMDReceived: 'Liczba otrzymanych podań, które przedarły się zarówno przez środek pola, jak i linię obrony przeciwnika',
      ThroughBallReceived: 'Liczba podań, które przedarły się przez ostatnią linię obrony przeciwnika',
      HsrDistanceIP: 'Dystans sprintu > 21 km/h w posiadaniu',
      HsrDistanceOOP: 'Dystans sprintu > 21 km/h bez posiadania piłki',
      JoggingDistanceIP: 'Dystans joggingu w posiadaniu',
      JoggingDistanceOOP: 'Dystans joggingu bez posiadania piłki',
      RunningDistanceIP: 'Dystans w posiadaniu',
      RunningDistanceOOP: 'Odległość dobiegu bez posiadania piłki',
      SprintsDistanceIP: 'Dystans sprintu > 24 km/h w posiadaniu',
      SprintsDistanceOOP: 'Dystans sprintu > 24 km/h bez posiadania piłki',
      WalkingDistanceIP: 'W odległości spaceru w posiadaniu',
      WalkingDistanceOOP: 'W niewielkiej odległości od posiadania',
      RunningNumberIP: 'Number of times that the Player is moving at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h) for a time period of at least 1 second with possession',
      RunningNumberOOP: 'Number of times that the Player is moving at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h) for a time period of at least 1 second without possession',
      RunningDistancePctIP: 'Percentage of Running Distance with respect to total distance travelled with possession',
      RunningDistancePctOOP: 'Percentage of Running Distance with respect to total distance travelled without possession',
      RunningDistancePct: 'Percentage of Running Distance with respect to total distance travelled',
      HsrNumberIP: 'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second with possession',
      HsrNumberOOP: 'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second without possession',
      SprintsNumberIP: 'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second with possession',
      SprintsNumberOOP: 'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second without possession',
      SprintsDistancePctIP: 'Percentage of Sprint Distance with respect to total distance travelled with possession',
      SprintsDistancePctOOP: 'Percentage of Sprint Distance with respect to total distance travelled without possession',
      SprintsDistancePct: 'Percentage of Sprint Distance with respect to total distance travelled',
      PossessionRegain: 'Liczba przypadków, w których zmuszasz przeciwnika do utraty posiadania',
      HandPassesSuccessful: 'Skuteczne podania wykonane rękami (bramkarze lub rzuty po stałych fragmentach gry)',
      HandPassesTotal: 'Całkowita liczba podań wykonanych rękami (bramkarze lub rzuty po stałych fragmentach gry)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player'
    },
    subtitles: {
      Possession: 'Procent posiadania piłki',
      TimePossession: 'Czas posiadania piłki',
      PassesPerShots: 'Średnia podań na strzał',
      PPDA: 'Presja na rywalu w posiadaniu (PPDA)',
      Directness: 'Więcej podań do przodu niż wszerz',
      ExpectedPoints: 'Oczekiwane punkty na podstawie xG',
      PassesPerLongBall: 'Odsetek udanych długich podań',
      CrossingPerXG: 'Odsetek xG z dośrodkowań',
      PenaltySavedPenaltyFaced: 'Procent obronionych karnych',
      Goals: 'Gole',
      PenaltyShots: 'Strzały z karnych',
      PenaltyGoals: 'Gole z karnych',
      NonPenaltyGoals: 'Gole bez karnych',
      AerialWins: 'Wygrane pojedynki w powietrzu',
      AerialEfficiency: 'Skuteczność pojedynków powietrznych',
      AerialWinsPct: 'Odsetek wygranych w powietrzu',
      Assists: 'Asysty',
      Catching: 'Odsetek interwencji z chwytem',
      Caught: 'Ratuje miejsce, w którym bramkarz łapie i przytrzymuje piłkę, uniemożliwiając jakąkolwiek drugą grę',
      ChancesCreated: 'Podań do strzału',
      ClaimAccuracy: 'Piłki przejęte ponad średnią',
      CompletedCrosses: 'Udane dośrodkowania',
      Crossing: 'Odsetek udanych dośrodkowań',
      Dispossessed: 'Straty',
      Finishing: 'Odsetek strzałów zakończonych golem',
      xGEfficiency: 'xG potrzebne do zdobycia gola',
      Fouls: 'Faule',
      DeepProgression: 'Wejścia prowadzeniem do ostatniej 1/5 + posiadania tam',
      DeepProgressionFinalThird: 'Posiadania w ostatniej tercji',
      FoulsTaken: 'Faule na zawodniku',
      IndividualPressure: 'Skuteczne presje/odzyski',
      Interceptions: 'Przechwyty',
      LongBallPct: 'Odsetek podań ≥ 32 m udanych',
      LongBallTotal: 'Łączna liczba przejść na długości 32 metrów',
      LongBallSuccessful: 'Udane podania ≥ 32 m',
      NPGOpenPlay: 'Gole bez karnych z akcji',
      NPGSetPiece: 'Gole bez karnych ze SFG',
      OpenPlayKeyPasses: 'Kluczowe podania z akcji',
      OpenPlayKeyPassesInTeam: 'Odsetek kluczowych podań z akcji w zespole',
      PassingFinalThird: 'Udane podania do ostatniej tercji',
      PassesFinalThirdTotal: 'Całkowita liczba podań, z wyłączeniem dośrodkowań, stałych fragmentów gry, rzutów rożnych i wrzutów z autu, które kończą się w ostatniej tercji',
      PassingFinalThirdPct: 'Odsetek udanych podań w ostatniej tercji',
      PassingOppHalfPct: 'Odsetek udanych podań na połowę rywala',
      PassingOwnHalfPct: 'Odsetek udanych podań na własną połowę',
      PassingPct: 'Odsetek udanych podań',
      Recoveries: 'Odzyski piłki',
      SavesInBoxPct: 'Odsetek obron strzałów z pola karnego',
      SavesOutOfBoxPct: 'Odsetek obron strzałów spoza pola',
      SavesPct: 'Odsetek obron',
      ScoringContribution: 'Asysty + gole',
      xAssistsOpenPlay: 'xA z akcji',
      xAssistsSetPiece: 'xA ze SFG',
      xAssistsOpenPlayInTeam: 'xA z akcji w zespole',
      xAssistsSetPieceInTeam: 'xA ze SFG w zespole',
      xGChainFinalThird: 'xG z udziałem w ostatniej tercji',
      xGBuildupFinalThird: 'xG z udziałem w ostatniej tercji (bez strzałów i KP)',
      BallProgressionPassing: 'Progresje podaniem ≥10 m',
      BallProgressionDribbling: 'Progresje prowadzeniem ≥10 m',
      Shooting: 'Odsetek strzałów celnych (bez karnych)',
      Shots: 'Strzały',
      ShotsPerGoal: 'Średnia strzałów na gola',
      SuccessfulDribbles: 'Udane dryblingi',
      TacklesSuccessful: 'Udane odbiory',
      TacklesWasDribbled: 'Odsetek wygranych wślizgów',
      ThroughBalls: 'Podania przełamujące linię obrony',
      TouchesInOpponentBox: 'Kontakty w polu karnym rywala',
      xAssists: 'Oczekiwane asysty',
      xG: 'Gole oczekiwane',
      xGDiff: 'Różnica xG – gole',
      xGOpenPlay: 'xG z akcji',
      xGSetPiece: 'xG ze SFG',
      xGBuildup: 'Udział w xG buildup',
      xGBuildupInTeam: 'Udział w xG buildup w zespole',
      BallProgression: 'Progresje ≥10 m podaniem lub prowadzeniem',
      xGChain: 'Udział w xG chain',
      xGPerNPG: 'xG potrzebne na gola bez karnego',
      xGPerShot: 'Średnie xG na strzał',
      xGSavedPerShot: 'Średnie xG strzałów celnych przeciw',
      xGSavedPerXGFacedOnTarget: 'Średnie xG obronione na xG On Target',
      xGFacedOnTargetPerGoalReceived: 'xG On Target na jednego straconego gola',
      xGFacedOnTargetEfficiency: 'Zapobiegnięte bramki bez karnych',
      xGFacedOnTarget: 'Łączne xG On Target przeciw',
      HighTurnovers: 'Straty <40 m od własnej bramki',
      OpenPlayPassesIntoOpponentBox: 'Podań z akcji w pole karne',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Udane podania z akcji w pole karne',
      ChancesCreatedOP: 'Podań do strzału z akcji',
      PenaltiesTaken: 'Faule na zawodniku w polu karnym',
      BlockedCrosses: 'Zablokowane dośrodkowania',
      BlockedShots: 'Zablokowane strzały',
      NonPenaltyGoalsAgainst: 'Stracone bramki bez karnych',
      Headers: 'Strzały głową',
      AveragePassDistance: 'Średni dystans podań (m)',
      ProgressiveRuns: 'Prowadzenia przybliżające o 20% do bramki',
      xT: 'Zagrożenie z przenoszenia piłki do groźnych stref',
      xTOpenPlay: 'xT z akcji',
      xTSetPiece: 'xT ze SFG',
      xGOT: 'xG strzałów celnych przeciw',
      BadActions: 'Suma złych akcji',
      BadActionsOwnHalf: 'Suma złych akcji na własnej połowie',
      AerialsWonOwnBox: 'Wygrane w powietrzu – własne pole',
      AerialsWonOppBox: 'Wygrane w powietrzu – pole rywala',
      AerialsTotalOppBox: 'Łącznie pojedynków – pole rywala',
      AerialsTotalOwnBox: 'Łącznie pojedynków – własne pole',
      FoulsOwnHalfPct: 'Odsetek fauli na własnej połowie',
      RecoveriesOppHalf: 'Odzyski na połowie rywala',
      DuelsPct: 'Odsetek wygranych pojedynków',
      TacklesUnsuccessful: 'Minięcia przy próbie odbioru',
      TacklesWasDribbledFirstThird: 'Odsetek odzysków w ostatniej tercji',
      TacklesWasDribbledSecondThird: 'Wygrane pojedynki defensywne 1 na 1 – druga tercja',
      TacklesWasDribbledFinalThird: 'Wygrane pojedynki defensywne 1 na 1 – ostatnia tercja',
      BallProgressionFinalThird: 'Progresje w ostatniej tercji',
      DuelsTotal: 'Łącznie: odbiory, powietrzne, kontakty, dryblingi, faule',
      QuickRecoveries: 'Odzyski ≥40 m w 8 s po stracie',
      ShotsPerNPG: 'Średnia strzałów na gola bez karnego',
      ShotsOutBox: 'Strzały spoza pola karnego',
      GoalsOutBox: 'Gole spoza pola karnego',
      ShootingOutBox: 'Odsetek celnych strzałów spoza pola',
      HandPassing: 'Celność podań ręką',
      ShotEndingHighTurnovers: 'Straty <40 m kończące się strzałem rywala',
      GoalEndingHighTurnovers: 'Straty <40 m kończące się golem rywala',
      AverageCarriesProgress: 'Średni pionowy zysk na prowadzenie (m)',
      ChanceEndingCarries: 'Prowadzenia ≥7 m zakończone podaniem do strzału',
      AssistEndingCarries: 'Prowadzenia ≥7 m zakończone asystą',
      ShotEndingCarries: 'Prowadzenia ≥7 m zakończone strzałem',
      GoalEndingCarries: 'Prowadzenia ≥7 m zakończone golem',
      ShotEndingSequence: 'Sekwencje zakończone strzałem z udziałem',
      GoalEndingSequence: 'Sekwencje zakończone golem z udziałem',
      AerialWonOffensive: 'Wygrane w powietrzu w ataku',
      AerialWonDefensive: 'Wygrane w powietrzu w obronie',
      xGAgainst: 'xG przeciw',
      xGDiffAgainst: 'Różnica xG przeciw – gole stracone',
      xGPerNPGAgainst: 'xG przeciw na straconego gola bez karnego',
      xGOpenPlayAgainst: 'xG przeciw z akcji',
      xGSetPieceAgainst: 'xG przeciw ze SFG',
      xGPerShotAgainst: 'xG przeciw na strzał',
      ShotsAgainst: 'Strzały przeciw',
      ShotsOnTargetAgainst: 'Strzały celne przeciw',
      RivalPossession: 'Posiadanie rywala',
      AerialDefensivePct: 'Odsetek wygranych w powietrzu bez posiadania',
      HighRecoveries: 'Odzyski 40 m od bramki rywala lub bliżej',
      HighDefensiveActions: 'Akcje defensywne ≥40 m od własnej linii',
      HighDefensiveActionPct: 'Odsetek akcji defensywnych ≥40 m',
      HighDefensiveDistance: 'Średnia odległość akcji defensywnych od własnej bramki',
      PassesPerPossession: 'Podań na posiadanie',
      LengthPerPossession: 'Dystans na posiadanie',
      xTNet: 'xT netto',
      AvgCarriesDistance: 'Średni dystans prowadzeń',
      PassesForwardPct: '% podań do przodu',
      PassesForwardSuccessful: 'Skuteczne podania w przód',
      PassesForwardTotal: 'Całkowita liczba podań w przód',
      TacklesAttempted: 'Próby odbioru',
      DuelsLost: 'Pojedynki przegrane',
      Carries: 'Prowadzenia',
      CarriesPct: '% prowadzeń',
      Aerials: 'Łącznie pojedynków powietrznych',
      ProgressivePassesReceivedIntoBox: 'Otrzymane progresywne podania w pole karne',
      PassesOppHalf: 'Udane podania kończące się na połowie rywala',
      LongBallReceived: 'Odebrane długie podania (>32 m)',
      ShotsOnTarget: 'Strzały celne',
      AggressiveActions: 'Próby odbioru w 2 s po stracie',
      Crosses: 'Łącznie dośrodkowań',
      xGBuildup5pass: 'xG z ostatnich 5 podań w sekwencji',
      DefensiveDistance: 'Średnia odległość pojedynków defensywnych od własnej bramki',
      SpeedSequence: 'Średnia prędkość posiadania (m/czas)',
      Touches: 'Kontakty z piłką',
      AerialsTotalOppHalf: 'Łącznie pojedynków powietrznych na połowie rywala',
      AerialsWonOppHalf: 'Pojedynki powietrzne zakończone sukcesem na połowę przeciwnika',
      AerialsWonOppHalfPct: 'Odsetek wygranych w powietrzu na połowie rywala',
      AerialsPctOppBox: 'Odsetek wygranych w powietrzu w polu rywala',
      AerialsPctOwnBox: 'Odsetek wygranych w powietrzu we własnym polu',
      AerialDefensive: 'Łącznie pojedynków powietrznych przy posiadaniu rywala',
      AerialOffensive: 'Łącznie pojedynków powietrznych przy własnym posiadaniu',
      AerialOffensivePct: 'Odsetek wygranych w powietrzu przy własnym posiadaniu',
      IndividualPressureOppHalf: 'Odzyski przy pressingu na połowie rywala',
      TouchesPerShot: 'Kontakty z piłką na strzał',
      PassesFinalThirdTotalPct: 'Odsetek wszystkich podań do ostatniej tercji',
      xACrosses: 'xA z dośrodkowań',
      Passes: 'Podań',
      PassesSuccessful: 'Udane podania',
      TacklesWasDribbledFouls: 'Odsetek wygranych odbiorów względem odbiorów+fauli',
      OffsidesCaught: 'Spalone złapane',
      ProgressivePassesReceivedFinalThird: 'Otrzymane progresywne podania – ostatnia tercja',
      ProgressivePassesReceived: 'Otrzymane progresywne podania',
      Breadth: 'Suma odbiorów, wyzwań, przechwytów i fauli na bokach',
      DuelsDefTotal: 'Suma odbiorów, defens. powietrznych i fauli',
      DefensiveActions: 'Akcje defensywne przeciw próbom dryblingu',
      ProgressivePassesReceivedOppHalf: 'Otrzymane progresywne podania – połowa rywala',
      CompletedCrossesOP: 'Udane dośrodkowania z akcji',
      CrossingOP: 'Odsetek udanych dośrodkowań z akcji',
      CrossesOP: 'Całkowita liczba dośrodkowań w grze otwartej',
      PassingContribution: 'Udział w zagrożeniu z podań z uwzględnieniem pozycji odbiorcy',
      BallProgressionOppHalfInTeam: '% progresji na połowie rywala w zespole',
      PassesOPIntoBoxInTeam: '% podań z akcji w pole karne w zespole',
      TouchesOppBoxInTeam: '% kontaktów w polu karnym rywala w zespole',
      xGOPInTeam: '% xG z akcji w zespole',
      DeepPasses: 'Podania z poza 20 m od bramki rywala kończące się w tej strefie',
      DeepPassesTotal: 'Łączna liczba podań wykonanych spoza promienia 20 metrów od bramki przeciwnika, które zakończyły się w tym obszarze',
      DefensiveDuelsPct: 'Odsetek wygranych pojedynków defensywnych',
      QuickRecoveriesPct: 'Odsetek szybkich odzysków do przechwytów i odbiorów',
      DiffDefensiveDistanceTeam: 'Różnica dystansu defensywnego zawodnika vs zespół',
      xTPassing: 'xT generowane podaniami',
      xTPassing100Passes: 'xT z podań na 100 podań',
      ProgressivePassesAccurate: 'Udane podania progresywne (≥10 m w osi X)',
      PassAbility: 'Relacja udanych do oczekiwanych podań (xP)',
      OPPassesIntoOppBoxPct: 'Odsetek podań z akcji w pole karne (udane/próby)',
      EntriesOppBox: 'Wejścia w pole karne (podania+prowadzenia)',
      Crosses6yardBox: 'Dośrodkowania w pole bramkowe',
      Cutbacks: 'Wycofania z linii końcowej w pole karne',
      xTDribbling: 'xT generowane dryblingami',
      AvgShotDistance: 'Średni dystans strzałów',
      xGOnTarget: 'xG strzałów celnych',
      FinishingxGOT: 'Nadwyżka goli ze strzałów celnych ponad średnią',
      DribblesWonOwnHalf: 'Udane dryblingi na własnej połowie',
      DribblesOwnHalf: 'Próby dryblingu na własnej połowie',
      DribblesOwnHalfPct: 'Odsetek udanych dryblingów na własnej połowie',
      DribblesWonOppHalf: 'Udane dryblingi na połowie rywala',
      DribblesOppHalf: 'Próby dryblingu na połowie rywala',
      DribblesOppHalfPct: 'Odsetek udanych dryblingów na połowie rywala',
      DribblesWonFinalThird: 'Udane dryblingi w ostatniej tercji',
      DribblesFinalThird: 'Próby dryblingu w ostatniej tercji',
      DribblesFinalThirdPct: 'Odsetek udanych dryblingów w ostatniej tercji',
      ShotEndingHighRecoveries: 'Wysokie odzyski kończące się strzałem',
      PassingFinalThirdAgainst: 'Udane podania rywala do ostatniej tercji',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Łącznie podań rywala z akcji w nasze pole karne',
      EntriesOppBoxAgainst: 'Wejścia rywala w nasze pole karne',
      DeepProgressionAgainst: 'Wejścia rywala prowadzeniem do naszej ostatniej 1/5 + posiadania',
      TouchesInOpponentBoxAgainst: 'Kontakty rywala z piłką w naszym polu karnym',
      Score: 'Ocena zawodnika na podstawie metryk',
      PDScore: 'Wydolność fizyczna na podstawie metryk',
      OrlegiScore: 'Ocena zawodnika na podstawie wybranych metryk',
      SirScore: 'Ocena zawodnika na podstawie wybranych metryk',
      ExcScore: 'Ocena zawodnika na podstawie wybranych metryk',
      xTOPInTeam: 'xT z akcji w zespole',
      YellowCards: 'Żółte kartki',
      RedCards: 'Czerwone kartki',
      xTOpenPlayAgainst: 'xT przeciw z akcji',
      xTSetPieceAgainst: 'xT przeciw ze SFG',
      NPGOpenPlayAgainst: 'Stracone gole bez karnych z akcji',
      NPGSetPieceAgainst: 'Stracone gole bez karnych ze SFG',
      PassesOppHalfPerPossession: 'Podań na posiadanie kończących na połowie rywala',
      AverageTimeRecovery: 'Śr. czas odzysku',
      ExpectedPassing: 'Odsetek podań, które powinny być celne (xP)',
      NumPossession10Passes: 'Posiadania z ≥10 podaniami',
      PassesReceived: 'Otrzymane podania',
      PassesReceivedFinalThird: 'Otrzymane podania – ostatnia tercja',
      ProgressivePassesTotalPct: 'Odsetek podań progresywnych',
      ShortPassesPct: 'Odsetek krótkich podań',
      TouchesOppBoxOppTeam: 'Działania rywala w naszym polu, gdy zawodnik na boisku',
      ShotsOnTargetOppTeam: 'Strzały celne rywala, gdy zawodnik na boisku',
      NPGOppTeam: 'Stracone bramki bez karnych, gdy zawodnik na boisku',
      xGSetPiecePerxG: 'xG ze stałych fragmentów potrzebne do wygenerowania 1 xG',
      ShotsOpenPlay: 'Strzały z akcji',
      ShotsOpenPlayAgainst: 'Strzały rywala z akcji',
      ShotsFromDribble: 'Strzały oddane po przedryblowaniu przeciwnika',
      GoalsFromDribble: 'Gole zdobyte po przedryblowaniu przeciwnika',
      PassesIntoFinalThird: 'Udane podania z ostatniej trzeciej części boiska',
      PassesIntoFinalThirdTotal: 'Całkowita liczba podań rozpoczynała się na zewnątrz i kończyła w ostatniej tercji',
      PassesInsideFinalThird: 'Udane podania wewnątrz ostatniej trzeciej (początek i koniec w tej strefie)',
      PassesInsideFinalThirdTotal: 'Suma podań w ostatniej tercji (rozpoczęcie i zakończenie w ostatniej tercji)',
      PassesFinalThirdNoArea: 'Przechodzi finałową trzecią część (bez pudełka)',
      PassesIntoOppBox: 'Udane podania zakończone w polu karnym przeciwnika',
      CarriesFinalThird: 'Prowadzenia piłki na co najmniej 7 metrów kończące się w ostatniej trzeciej',
      CarriesInsideFinalThird: 'Prowadzenia piłki na co najmniej 7 metrów wewnątrz ostatniej trzeciej (start i koniec w tej samej strefie)',
      CarriesFinalThirdNoBox: 'Zawiera ostatnią trzecią część (bez pudełka)',
      CarriesIntoOppBox: 'Prowadzenia piłki na co najmniej 7 metrów kończące się w polu karnym przeciwnika',
      TimePossessionAgainst: 'Czas posiadania piłki przez drużynę przeciwną',
      TimePossessionTotal: 'Całkowity czas posiadania piłki przez obie drużyny',
      PassesInBox: 'Udane podania w polu karnym własnej drużyny',
      LongThrowInSuccessful: 'Udany długi wrzut z autu wykonany z zamiarem osiągnięcia ponad 20 metrów',
      LongThrowInTotal: 'Łączna liczba długich wrzutów z autu (ponad 20 metrów)',
      LongThrowInPct: 'Procent udanych długich wrzutów (powyżej 20 metrów)',
      Games: 'Rozegrane gry',
      PointsPerGame: 'Punkty na mecz',
      ExpectedPointsDiff: 'Oczekiwana różnica punktów',
      PassesTotalOwnHalf: 'Całkowita liczba podań wykonanych z własnej połowy',
      PassesOwnHalf: 'Liczba udanych podań wykonanych z własnej połowy',
      PassesTotalOppHalf: 'Całkowita liczba podań wykonanych z połowy przeciwnika',
      ProgressivePassesTotal: 'Całkowita liczba przejść o długości 10 metrów lub więcej w osi X',
      DuelsWon: 'Udane pojedynki (odbiory, podania w powietrzu, dotknięcia piłki, dryblingi i faule)',
      NonPenaltySaves: 'Obrony z wyłączeniem rzutów karnych',
      BadActionsOppHalf: 'Suma wszystkich złych zachowań popełnionych na połowie przeciwnika',
      CarriesSuccessful: 'Liczba przeniesień co najmniej 7 metrów zakończonych sukcesem',
      ShotsOnTargetOutBox: 'Strzały celne zza pola karnego',
      TotalDistance: 'Dystans całkowity',
      WalkingDistance: 'Dystans przy < 2 m/s (7,2 km/h)',
      JoggingDistance: 'Dystans 2–4 m/s (7,2–14,4 km/h)',
      RunningDistance: 'Dystans 4–5,5 m/s (14,4–19,8 km/h)',
      ExtremeAccelerations: 'Przyspieszenia > 3 m/s²',
      NumberOfRuns: 'Biegi 14,4–19,8 km/h',
      HsrDistance: 'Dystans HSR > 19,8 km/h',
      HsrNumber: 'Liczba HSR > 19,8 km/h',
      HsrDistancePct: '% dystansu HSR',
      SprintsNumber: 'Liczba sprintów > 25,2 km/h',
      SprintsDistance: 'Dystans sprintów > 25,2 km/h',
      SprintNumberDeclinePct: '% spadku liczby sprintów',
      SprintDistanceDeclinePct: '% spadku dystansu sprintów',
      SprintNumberDecline: 'Spadek liczby sprintów vs II połowa',
      SprintDistanceDecline: 'Spadek dystansu sprintów vs II połowa',
      SprintDistancePct: '% dystansu sprintów',
      Accelerations: 'Liczba przyspieszeń',
      MaxSpeed: 'Prędkość maksymalna',
      AvgMaxSpeed: 'Średnia prędkość maksymalna',
      MaxAccelerations: 'Maksymalne m/s² zawodnika',
      BypassedPlayersByPasses: 'Łączna liczba rywali (obrońców i pomocników) ominiętych podaniami',
      BypassedDefendersByPasses: 'Łączna liczba obrońców ominiętych podaniami',
      PassesBypassingPlayers: 'Liczba podań, które ominęły rywali',
      PassesBypassingDefenders: 'Liczba podań, które ominęły obrońców',
      BypassedPlayersPerPass: 'Średnia liczba ominiętych rywali na podanie',
      BypassedDefendersPerPass: 'Średnia liczba ominiętych obrońców na podanie',
      LineBreakingPasses: 'Podania przełamujące jedną lub więcej linii obrony',
      LineBreakingPassesMD: 'Podania przełamujące linię pomocy i obrony',
      LineBreakingPassesM: 'Podania przełamujące linię pomocy',
      LineBreakingThroughBalls: 'Podania przełamujące linię obrony',
      LineBreakingPassesPerPass: 'Odsetek podań przełamujących linie na podanie',
      TotalPassesUnderStrongPressure: 'Łącznie podań pod silną presją (0–2 m do rywala)',
      TotalPassesUnderLightPressure: 'Łącznie podań pod lekką presją (2–4 m do rywala)',
      SuccessfulPassesUnderStrongPressure: 'Udane podania pod silną presją (0–2 m)',
      SuccessfulPassesUnderLightPressure: 'Udane podania pod lekką presją (2–4 m)',
      PassingUnderStrongPressure: 'Odsetek udanych i wszystkich podań pod silną presją (0–2 m)',
      PassingUnderLightPressure: 'Odsetek udanych i wszystkich podań pod lekką presją (2–4 m)',
      PassReceiptsInSpaceCompleted: 'Podania, gdy odbierający jest na połowie ataku i brak obrońcy w promieniu 5 m w kierunku bramki',
      PassReceiptsInSpace: 'Przyjęcia na połowie ataku bez obrońcy w promieniu 5 m w kierunku bramki',
      PassReceiptsInSpaceCompletedFirstThird: 'Podania, w których odbierający znajduje się w pierwszej trzeciej boiska bez obrońcy w promieniu 5 metrów w kierunku bramki',
      PassReceiptsInSpaceCompletedSecondThird: 'Podania, w których odbierający znajduje się w drugiej trzeciej boiska bez obrońcy w promieniu 5 metrów w kierunku bramki',
      PassReceiptsInSpaceCompletedFinalThird: 'Podania, w których odbierający znajduje się w ostatniej trzeciej boiska bez obrońcy w promieniu 5 metrów w kierunku bramki',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Podania, w których odbierający znajduje się na prawej stronie połowy przeciwnika bez obrońcy w promieniu 5 metrów',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Podania, w których odbierający znajduje się w środkowej części połowy przeciwnika bez obrońcy w promieniu 5 metrów',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Podania, w których odbierający znajduje się na lewej stronie połowy przeciwnika bez obrońcy w promieniu 5 metrów',
      PassReceiptsInSpaceFirstThird: 'Odbiory w pierwszej trzeciej boiska bez obrońcy w promieniu 5 metrów w kierunku bramki',
      PassReceiptsInSpaceSecondThird: 'Odbiory w drugiej trzeciej boiska bez obrońcy w promieniu 5 metrów w kierunku bramki',
      PassReceiptsInSpaceFinalThird: 'Odbiory w ostatniej trzeciej boiska bez obrońcy w promieniu 5 metrów w kierunku bramki',
      PassReceiptsInSpaceOppHalfRight: 'Odbiory na prawej stronie połowy przeciwnika bez obrońcy w promieniu 5 metrów w kierunku bramki',
      PassReceiptsInSpaceOppHalfCenter: 'Odbiory w środkowej części połowy przeciwnika bez obrońcy w promieniu 5 metrów w kierunku bramki',
      PassReceiptsInSpaceOppHalfLeft: 'Odbiory na lewej stronie połowy przeciwnika bez obrońcy w promieniu 5 metrów w kierunku bramki',
      TotalStrongOnBallPressures: 'Silne presje na piłkę (0–2 m od prowadzącego)',
      TotalLightOnBallPressures: 'Presje na piłkę (2–4 m od prowadzącego)',
      SuccessfulStrongOnBallPressures: 'Udane silne presje na piłkę (0–2 m)',
      SuccessfulLightOnBallPressures: 'Udane presje na piłkę (2–4 m)',
      StrongOnBallPressuresPct: 'Odsetek udanych i wszystkich silnych presji na piłkę (0–2 m)',
      LightOnBallPressuresPct: 'Odsetek udanych i wszystkich presji na piłkę (2–4 m)',
      TimesBypassedByPasses: 'Ile razy ominięty podaniem',
      TimesBypassedByCarries: 'Ile razy ominięty prowadzeniem',
      TimesBypassedByActions: 'Ile razy ominięty podaniem lub prowadzeniem łącznie',
      BypassedPlayersByCarries: 'Łączna liczba rywali ominiętych prowadzeniem',
      BypassedDefendersByCarries: 'Łączna liczba obrońców ominiętych prowadzeniem',
      BypassedPlayersByActions: 'Łączna liczba rywali ominiętych podaniami i prowadzeniem',
      BypassedDefendersByActions: 'Łączna liczba obrońców ominiętych podaniami i prowadzeniem',
      CarriesBypassingPlayers: 'Prowadzenia omijające rywali',
      CarriesBypassingDefenders: 'Prowadzenia omijające obrońców',
      BypassedPlayersPerCarry: 'Średnia liczba ominiętych rywali na prowadzenie (≥7 m)',
      BypassedDefendersPerCarry: 'Średnia liczba ominiętych obrońców na prowadzenie (≥7 m)',
      LineBreakingCarries: 'Prowadzenia przełamujące jedną lub więcej linii obrony',
      LineBreakingCarriesMD: 'Prowadzenia przełamujące linię pomocy i obrony',
      LineBreakingCarriesM: 'Prowadzenia przełamujące linię pomocy',
      LineBreakingCarriesD: 'Prowadzenia przełamujące linię obrony',
      LineBreakingCarriesPerCarry: 'Odsetek prowadzeń przełamujących linie na prowadzenie',
      LineBreakingActions: 'Podania i prowadzenia przełamujące linie obrony',
      LineBreakingActionsMD: 'Podania i prowadzenia przełamujące linię pomocy i obrony',
      LineBreakingActionsM: 'Podania i prowadzenia przełamujące linię pomocy',
      LineBreakingActionsD: 'Podania i prowadzenia przełamujące linię obrony',
      PassesPerLineBreakingPass: 'Podań na jedno podanie przełamujące linię',
      CarriesPerLineBreakingCarry: 'Prowadzeń na jedno prowadzenie przełamujące linię',
      LinesBrokenByPasses: 'Liczba linii przełamanych podaniami',
      LinesBrokenByCarries: 'Liczba linii przełamanych prowadzeniami',
      LinesBrokenByActions: 'Liczba linii przełamanych podaniami i prowadzeniami',
      LinesBrokenPerPass: 'Przełamane linie na podanie',
      LinesBrokenPerCarry: 'Przełamane linie na prowadzenie',
      AvgLastDefenderDistanceIP: 'Odległość ostatniego obrońcy od linii bramkowej przy posiadaniu',
      AvgLastDefenderDistanceOOP: 'Odległość ostatniego obrońcy od linii bramkowej bez posiadania',
      AvgDefensiveLineDistanceIP: 'Odległość najgłębszej linii obrony od bramki przy posiadaniu',
      AvgDefensiveLineDistanceOOP: 'Odległość najgłębszej linii obrony od bramki bez posiadania',
      AvgRBDistanceIP: 'Odległość prawego obrońcy od własnej bramki przy posiadaniu',
      AvgRBDistanceOOP: 'Odległość prawego obrońcy od własnej bramki bez posiadania',
      AvgLBDistanceIP: 'Odległość lewego obrońcy od własnej bramki przy posiadaniu',
      AvgLBDistanceOOP: 'Odległość lewego obrońcy od własnej bramki bez posiadania',
      AvgBlockDistanceIP: 'Odległość między najgłębszym a najwyżej ustawionym zawodnikiem przy posiadaniu',
      AvgBlockDistanceOOP: 'Odległość między najgłębszym a najwyżej ustawionym zawodnikiem bez posiadania',
      AvgBlockAreaIP: 'Pole otoczki wszystkich graczy z pola – przy posiadaniu',
      AvgBlockAreaOOP: 'Pole otoczki wszystkich graczy z pola – bez posiadania',
      AvgDefensiveLineWidthOOP: 'Szerokość ostatniej linii w obronie bez posiadania',
      AvgOffensiveLineLastThirdWidthIP: 'Szerokość linii ataku w ostatniej tercji przy posiadaniu',
      AvgLByIP: 'Pozycja lewego obrońcy przy posiadaniu',
      AvgRByIP: 'Pozycja prawego obrońcy przy posiadaniu',
      AvgOffensiveLineDistanceIP: 'Odległość linii ataku od własnej bramki przy posiadaniu',
      AvgOffensiveLineLastThirdDistanceIP: 'Odległość linii ataku od bramki w ostatniej tercji przy posiadaniu',
      AvgOffensiveLineWidthIP: 'Szerokość linii ataku przy posiadaniu',
      OffBallRuns: 'Intencjonalne biegi bez piłki wspierające atak',
      OffBallRunsOverlap: 'Biegi na obieg – po zewnętrznej przy piłce u partnera',
      OffBallRunsUnderlap: 'Biegi na zejście – wewnętrzną ścieżką',
      OffBallRunsRunAhead: 'Bieg do przodu wyprzedzający prowadzącego, przed ostatnim obrońcą',
      OffBallRunsRunBehind: 'Bieg za linię obrony między obrońców a bramkarza',
      OffBallRunsCrossReceiver: 'Wejście w pole karne pod dośrodkowanie',
      OffBallRunsSupport: 'Bieg równoległy, oferujący bliską opcję podania',
      OffBallRunsComingShort: 'Zejście do piłki, by dać krótką opcję',
      AerialsOppHalf: 'Wygrane pojedynki powietrzne na połowie rywala',
      CarriesIntoFinalThird: 'Rurociągi o długości co najmniej 7 metrów od zewnątrz do wewnątrz ostatniej jednej trzeciej',
      DribblesAttempted: 'Liczba prób dryblingu',
      SpeedScore: 'Wydajność fizyczna gracza w oparciu o różne wskaźniki prędkości',
      EnduranceScore: 'Wytrzymałość fizyczna zawodnika na podstawie różnych wskaźników',
      GoalsConceded: 'Liczba straconych bramek',
      HeadedGoals: 'Liczba bramek zdobytych głową',
      SavesInBox: 'Liczba obron po strzałach w polu karnym',
      SavesOutBox: 'Liczba obron po strzałach poza polem karnym',
      ShotsOnTargetInBoxAgainst: 'Liczba oddanych celnych strzałów z pola karnego',
      ShotsOnTargetOutBoxAgainst: 'Liczba oddanych celnych strzałów zza pola karnego',
      SwitchPlaySuccessful: 'Liczba ukończonych podań na odległość powyżej 32 metrów, w przypadku których przemieszczenie boczne piłki jest większe niż jej przemieszczenie w kierunku bramki przeciwnika',
      SwitchPlayTotal: 'Całkowita liczba prób podań na odległość ponad 32 metrów, podczas których przemieszczenie boczne piłki jest większe niż jej przemieszczenie w kierunku bramki przeciwnika',
      PassesInsideOppHalf: 'Łączna liczba podań rozpoczynających się i kończących na połowie przeciwnika',
      PassesInsideOppHalfSuccessful: 'Liczba wykonanych podań, które zaczynają się i kończą na połowie przeciwnika',
      TacklesAttemptedFirstThird: 'Całkowita liczba prób wślizgu w pierwszej trzeciej części boiska',
      TacklesAttemptedSecondThird: 'Całkowita liczba prób wślizgu w drugiej trzeciej części boiska',
      TacklesFirstThird: 'Liczba udanych odbiorów wykonanych w pierwszej trzeciej części boiska',
      TacklesSecondThird: 'Liczba udanych odbiorów wykonanych w drugiej trzeciej części boiska',
      FoulsOwnHalf: 'Liczba fauli popełnionych na własnej połowie zawodnika',
      TouchesOppHalf: 'Liczba dotknięć piłki na połowie przeciwnika',
      TacklesAttemptedNotAdjusted: 'Całkowita liczba prób odbiorów, bez korekty posiadania',
      TacklesSuccessfulNotAdjusted: 'Całkowita liczba udanych odbiorów, bez korekty posiadania',
      AvgTop5MaxSpeed: 'Średnia z pięciu najwyższych maksymalnych prędkości gracza',
      LBPReceived: 'Liczba otrzymanych przejść naruszających linię',
      LBPMReceived: 'Liczba otrzymanych podań, które przedarły się przez linię pomocy przeciwnika',
      LBPMDReceived: 'Liczba otrzymanych podań, które przedarły się zarówno przez środek pola, jak i linię obrony przeciwnika',
      ThroughBallReceived: 'Liczba podań, które przedarły się przez ostatnią linię obrony przeciwnika',
      ShortPassesSuccessful: 'Liczba wykonanych krótkich podań (poniżej 12 metrów).',
      PassingSuccessForwardPct: 'Procent udanych podań do przodu',
      PassingSuccessBackwardPct: 'Procent udanych podań do tyłu',
      PassingForwardBackwardPct: 'Stosunek podań do przodu do podań do tyłu',
      LongBallPerPassesPct: 'Procent długich piłek w stosunku do całkowitej liczby podań',
      LongBallReceivedOppHalf: 'Liczba długich piłek otrzymanych na boisku rywala',
      OffensiveActions: 'Działania ofensywne',
      SuccessfulDribblesPct: 'Wykonano udane dryblingi/całkowitą liczbę prób dryblingu',
      OffensiveTouchesOutBoxPct: '% ofensywnych dotknięć poza polem karnym',
      HsrDistanceIP: 'Dystans sprintu > 21 km/h w posiadaniu',
      HsrDistanceOOP: 'Dystans sprintu > 21 km/h bez posiadania piłki',
      JoggingDistanceIP: 'Dystans joggingu w posiadaniu',
      JoggingDistanceOOP: 'Dystans joggingu bez posiadania piłki',
      RunningDistanceIP: 'Dystans w posiadaniu',
      RunningDistanceOOP: 'Odległość dobiegu bez posiadania piłki',
      SprintsDistanceIP: 'Dystans sprintu > 24 km/h w posiadaniu',
      SprintsDistanceOOP: 'Dystans sprintu > 24 km/h bez posiadania piłki',
      WalkingDistanceIP: 'W odległości spaceru w posiadaniu',
      WalkingDistanceOOP: 'W niewielkiej odległości od posiadania',
      PossessionRegain: 'Liczba przypadków, w których zmuszasz przeciwnika do utraty posiadania',
      HandPassesSuccessful: 'Skuteczne podania wykonane rękami (bramkarze lub rzuty po stałych fragmentach gry)',
      HandPassesTotal: 'Całkowita liczba podań wykonanych rękami (bramkarze lub rzuty po stałych fragmentach gry)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      Clearances: 'Number of times the player hits the ball clear of the defensive zone',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player (via Tackles or Interceptions)'
    },
    abbr: {
      Possession: 'POS%',
      TimePossession: 'TP',
      PassesPerShots: 'PPS',
      PPDA: 'PPDA',
      ExpectedPoints: 'XP',
      Points: 'P',
      Directness: 'DIR',
      PassesPerLongBall: 'PPLB',
      CrossingPerXG: 'CPxG',
      PenaltySavedPenaltyFaced: 'PSPF',
      Goals: 'GOA',
      PenaltyShots: 'PS',
      PenaltyGoals: 'PG',
      NonPenaltyGoals: 'NPG',
      NPGOpenPlay: 'NPGOP',
      NPGSetPiece: 'NPGSP',
      Shooting: 'SHO%',
      Finishing: 'FIN%',
      xGEfficiency: 'xGE',
      HeaderPerShot: 'HPS',
      HeaderPerCross: 'HPC',
      Assists: 'ASS',
      ThroughBalls: 'TB',
      CrossEfficiency: 'CE',
      ScoringContribution: 'SC',
      xAssistsOpenPlay: 'xAOP',
      xAssistsSetPiece: 'xASP',
      xAssistsOpenPlayInTeam: 'xAOPiT',
      xAssistsSetPieceInTeam: 'xASPiT',
      xGBuildupFinalThird: 'xGBUPFT',
      xGChainFinalThird: 'xGCFT',
      BallProgressionPassing: 'BPP',
      BallProgressionDribbling: 'BPD',
      TacklesWasDribbled: 'TWD%',
      TacklesSuccessful: 'STA',
      Interceptions: 'INT',
      Clearances: 'CLE',
      Fouls: 'FOU',
      Recoveries: 'REC',
      Shots: 'SHO',
      ShotsPerGoal: 'SPG',
      ShortPassesSuccessful: 'SPS',
      PassingSuccessForwardPct: 'PSF%',
      PassingSuccessBackwardPct: 'PSB%',
      PassingForwardBackwardPct: 'PFB%',
      LongBallPerPassesPct: 'LBP%',
      LongBallReceived: 'LBR',
      LongBallReceivedOppHalf: 'LBROH',
      OffensiveActions: 'OA',
      DribblesAttempted: 'DAT',
      SuccessfulDribblesPct: 'SD%',
      OffensiveTouchesOutBoxPct: 'OTOB%',
      BallRetention: 'BR',
      PassingPct: 'PA%',
      PassingOwnHalfPct: 'POH%',
      PassingOppHalfPct: 'POPH%',
      PassingFinalThird: 'PFT',
      PassesFinalThirdTotal: 'PFTT',
      PassingFinalThirdPct: 'PT%',
      LongBallSuccessful: 'SLB',
      LongBallPct: 'LB%',
      LongBallTotal: 'TLB',
      SavesPct: 'S%',
      SavesInBoxPct: 'SIB%',
      SavesOutOfBoxPct: 'SOOB%',
      xGSavedPerXGFacedOnTarget: 'xGSPFOT',
      xGFacedOnTargetPerGoalReceived: 'xGFOTPGR',
      xGFacedOnTargetEfficiency: 'xGFOTE',
      xGFacedOnTarget: 'xGFOT',
      IndividualPressure: 'IP',
      AerialEfficiency: 'AE',
      AerialWins: 'AEW',
      AerialWinsPct: 'AE%',
      xG: 'xG',
      xGDiff: 'xGD',
      xGOpenPlay: 'xGOP',
      xGSetPiece: 'xGSP',
      xGPerShot: 'xGPS',
      ChancesCreated: 'CC',
      CompletedCrosses: 'SCR',
      Crossing: 'CR%',
      OpenPlayKeyPasses: 'OPKP',
      OpenPlayKeyPassesInTeam: 'OPKPiT%',
      OpenPlayPassesIntoOpponentBox: 'OPPOPPB',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'OPPOPPBS',
      xAssists: 'xA',
      xGChain: 'xGC',
      xGBuildup: 'xGBUP',
      xGBuildupInTeam: 'xGBUPiT',
      BallProgression: 'BP',
      SuccessfulDribbles: 'SDR',
      Dispossessed: 'TOV',
      TouchesInOpponentBox: 'TOB',
      xGSavedPerShot: 'xGSS',
      BallRetentionOppHalf: 'BROPPH',
      DeepProgression: 'DP',
      DeepProgressionFinalThird: 'DPFT',
      FoulsTaken: 'FOUR',
      PenaltiesTaken: 'PT',
      BlockedCrosses: 'BC',
      BlockedShots: 'BS',
      Blocks: 'BLO',
      NonPenaltyGoalsAgainst: 'NPGC',
      Headers: 'HEA',
      AveragePassDistance: 'APD',
      ProgressiveRuns: 'PRC',
      xT: 'xT',
      xTOpenPlay: 'xTOP',
      xTSetPiece: 'xTSP',
      xGOT: 'xGOT',
      BadActions: 'BA',
      BadActionsOwnHalf: 'BAOH',
      AerialsWonOwnBox: 'AWOB',
      AerialsWonOppBox: 'AWOPPB',
      AerialsTotalOppBox: 'ATOPPB',
      AerialsTotalOwnBox: 'ATOB',
      FoulsOwnHalfPct: 'FOH%',
      RecoveriesOppHalf: 'ROH',
      DuelsPct: 'D%',
      TacklesUnsuccessful: 'UTA',
      TacklesWasDribbledFirstThird: 'TWDFT',
      TacklesWasDribbledSecondThird: 'TWDST',
      TacklesWasDribbledFinalThird: 'TWDFT',
      BallProgressionFinalThird: 'BPFT',
      DuelsTotal: 'DT',
      QuickRecoveries: 'QR',
      ShotsPerNPG: 'SPNPG',
      ShotsOutBox: 'SOB',
      GoalsOutBox: 'GOB',
      ShootingOutBox: 'SOB%',
      HandPassing: 'HP',
      Catching: 'CAT',
      Caught: 'CAU',
      ClaimAccuracy: 'CA',
      HighTurnovers: 'HTOV',
      ShotEndingHighTurnovers: 'SEHT',
      GoalEndingHighTurnovers: 'GEHT',
      AverageCarriesProgress: 'ACP',
      ChanceEndingCarries: 'CEC',
      AssistEndingCarries: 'AEC',
      ShotEndingCarries: 'SEC',
      GoalEndingCarries: 'GEC',
      ShotEndingSequence: 'SES',
      GoalEndingSequence: 'GES',
      xGPerNPG: 'xGPNPG',
      AerialWonOffensive: 'AWO',
      AerialWonDefensive: 'AWD',
      xGAgainst: 'xGC',
      xGDiffAgainst: 'xGDC',
      xGPerNPGAgainst: 'xGPNPGA',
      xGOpenPlayAgainst: 'xGOPC',
      xGSetPieceAgainst: 'xGSPC',
      xGPerShotAgainst: 'xGSC',
      ShotsAgainst: 'STC',
      ShotsOnTargetAgainst: 'SOTC',
      RivalPossession: 'RP',
      AerialDefensivePct: 'AD%',
      HighRecoveries: 'HR',
      HighDefensiveActions: 'HDA',
      HighDefensiveActionPct: 'HDA%',
      HighDefensiveDistance: 'HDD',
      PassesPerPossession: 'PPP',
      LengthPerPossession: 'LPP',
      xTNet: 'xTN',
      AvgCarriesDistance: 'ACD',
      PassesForwardPct: 'PF%',
      PassesForwardSuccessful: 'SFP',
      PassesForwardTotal: 'TFP',
      TacklesAttempted: 'ATA',
      DuelsLost: 'DL',
      Carries: 'CARR',
      CarriesPct: 'CARR%',
      Aerials: 'AER',
      ProgressivePassesReceivedIntoBox: 'PPRIB',
      PassesOppHalf: 'POPH',
      ShotsOnTarget: 'SOT',
      AggressiveActions: 'AA',
      Crosses: 'CRO',
      xGBuildup5pass: 'xGBUP5',
      DefensiveDistance: 'DD',
      SpeedSequence: 'SS',
      Touches: 'TOU',
      AerialsTotalOppHalf: 'ATOPPH',
      AerialsWonOppHalf: 'AWOPPH',
      AerialsWonOppHalfPct: 'AWOH%',
      AerialsPctOppBox: 'AOPPB%',
      AerialsPctOwnBox: 'AOB%',
      AerialDefensive: 'AD',
      AerialOffensive: 'AO',
      AerialOffensivePct: 'AO%',
      IndividualPressureOppHalf: 'IPOPPH',
      ChancesCreatedOP: 'CCOP',
      TouchesPerShot: 'TPS',
      PassesFinalThirdTotalPct: 'PFT%',
      xACrosses: 'xAC',
      Passes: 'PAS',
      PassesSuccessful: 'SPA',
      TacklesWasDribbledFouls: 'TWDF',
      OffsidesCaught: 'OC',
      ProgressivePassesReceivedFinalThird: 'PPRFT',
      ProgressivePassesReceived: 'PPR',
      Breadth: 'BRD',
      DuelsDefTotal: 'DDT',
      DefensiveActions: 'DA',
      ProgressivePassesReceivedOppHalf: 'PPROH',
      CompletedCrossesOP: 'CCOP',
      CrossingOP: 'COP',
      CrossesOP: 'COP',
      PassingContribution: 'PC',
      BallProgressionOppHalfInTeam: 'BPOPPHiT',
      PassesOPIntoBoxInTeam: 'POBIT',
      TouchesOppBoxInTeam: 'TOBIT',
      xGOPInTeam: 'xGOPiT',
      DeepPasses: 'DP',
      DeepPassesTotal: 'DPCT',
      DefensiveDuelsPct: 'DD%',
      QuickRecoveriesPct: 'QR%',
      DiffDefensiveDistanceTeam: 'DDDT',
      xTPassing: 'xTP',
      xTPassing100Passes: 'xTP100',
      ProgressivePassesAccurate: 'APP',
      xP: 'xP',
      PassAbility: 'PA',
      OPPassesIntoOppBoxPct: 'OPPIOB%',
      EntriesOppBox: 'EOPPB',
      Crosses6yardBox: 'C6YB',
      Cutbacks: 'CUT',
      xTDribbling: 'xTD',
      AvgShotDistance: 'ASD',
      xGOnTarget: 'xGOT',
      FinishingxGOT: 'FxGOT',
      DribblesWonOwnHalf: 'DWOH',
      DribblesOwnHalf: 'DOH',
      DribblesOwnHalfPct: 'DOH%',
      DribblesWonOppHalf: 'DWOPH',
      DribblesOppHalf: 'DOPH',
      DribblesOppHalfPct: 'DOPH%',
      DribblesWonFinalThird: 'DWFT',
      DribblesFinalThird: 'DFT',
      DribblesFinalThirdPct: 'DFT%',
      ShotEndingHighRecoveries: 'SEHR',
      PassingFinalThirdAgainst: 'PFTC',
      OpenPlayPassesIntoOpponentBoxAgainst: 'OPPOBC',
      EntriesOppBoxAgainst: 'EOBC',
      DeepProgressionAgainst: 'DPC',
      TouchesInOpponentBoxAgainst: 'TOBC',
      Score: 'SCO',
      PDScore: 'SCO',
      OrlegiScore: 'SCO',
      SirScore: 'SCO',
      ExcScore: 'SCO',
      xTOPInTeam: 'xTOPiT',
      YellowCards: 'YC',
      RedCards: 'RC',
      xTOpenPlayAgainst: 'xTOPC',
      xTSetPieceAgainst: 'xTSPC',
      NPGOpenPlayAgainst: 'NPG OPC',
      NPGSetPieceAgainst: 'NPG SPC',
      PassesOppHalfPerPossession: 'POHP',
      AverageTimeRecovery: 'ATR',
      ExpectedPassing: 'xP%',
      NumPossession10Passes: 'P10P',
      PassesReceived: 'PR',
      PassesReceivedFinalThird: 'PRLFT',
      ProgressivePassesTotalPct: 'PP%',
      ShortPassesPct: 'SP%',
      TouchesOppBoxOppTeam: 'TOBOT',
      ShotsOnTargetOppTeam: 'SOTOT',
      NPGOppTeam: 'NPGOT',
      xGSetPiecePerxG: 'xGSPPxG',
      ShotsOpenPlay: 'SOP',
      ShotsOpenPlayAgainst: 'SOPA',
      ShotsFromDribble: 'SFD',
      GoalsFromDribble: 'GFD',
      PassesIntoFinalThird: 'PIFT',
      PassesIntoFinalThirdTotal: 'PIFTT',
      PassesInsideFinalThird: 'PINSFT',
      PassesInsideFinalThirdTotal: 'PINSFTT',
      PassesFinalThirdNoArea: 'PFTNA',
      PassesIntoOppBox: 'PIOB',
      CarriesFinalThird: 'CFT',
      CarriesInsideFinalThird: 'CINSFT',
      CarriesFinalThirdNoBox: 'CFTNB',
      CarriesIntoOppBox: 'CIOB',
      TimePossessionAgainst: 'TPA',
      TimePossessionTotal: 'TPT',
      PassesInBox: 'PIB',
      LongThrowInSuccessful: 'LTInS',
      LongThrowInTotal: 'LTInT',
      LongThrowInPct: 'LTIn%',
      Games: 'GAM',
      PointsPerGame: 'PPG',
      ExpectedPointsDiff: 'XPD',
      PassesTotalOwnHalf: 'PTOH',
      PassesOwnHalf: 'PO',
      PassesTotalOppHalf: 'PTOPPH',
      ProgressivePassesTotal: 'TPP',
      DuelsWon: 'DW',
      NonPenaltySaves: 'NPS',
      BadActionsOppHalf: 'BAOPPH',
      CarriesSuccessful: 'CS',
      ShotsOnTargetOutBox: 'SOTOB',
      TotalDistance: 'DST',
      WalkingDistance: 'WLKD',
      JoggingDistance: 'JOGD',
      RunningDistance: 'RUND',
      ExtremeAccelerations: 'XACC',
      NumberOfRuns: 'RUNQ',
      HsrDistance: 'HSRD',
      HsrNumber: 'HSRQ',
      HsrDistancePct: 'HSRD%',
      SprintsNumber: 'SPRQ',
      SprintsDistance: 'SPRD',
      SprintNumberDeclinePct: 'SQD%',
      SprintDistanceDeclinePct: 'SDD%',
      SprintNumberDecline: 'SQD',
      SprintDistanceDecline: 'SDD',
      SprintDistancePct: 'SPRD%',
      Accelerations: 'ACC',
      MaxSpeed: 'MS',
      AvgMaxSpeed: 'AvgMS',
      MaxAccelerations: 'MACC',
      HeadedGoals: 'HG',
      GoalsConceded: 'GC',
      SavesInBox: 'SIB',
      SavesOutBox: 'SZLOCH',
      BypassedPlayersByPasses: 'ByPP',
      BypassedDefendersByPasses: 'ByPD',
      PassesBypassingPlayers: 'PByPP',
      PassesBypassingDefenders: 'PByPD',
      BypassedPlayersPerPass: 'ByPPPP',
      BypassedDefendersPerPass: 'ByPDPP',
      LineBreakingPasses: 'LBP',
      LineBreakingPassesMD: 'LBPMD',
      LineBreakingPassesM: 'LBPM',
      LineBreakingThroughBalls: 'LBTB',
      LineBreakingPassesPerPass: 'LBPP%',
      TotalPassesUnderStrongPressure: 'TPUSP',
      TotalPassesUnderLightPressure: 'TPUP',
      SuccessfulPassesUnderStrongPressure: 'SPUSP',
      SuccessfulPassesUnderLightPressure: 'SPULP',
      PassingUnderStrongPressure: 'PUSP%',
      PassingUnderLightPressure: 'PULP%',
      PassReceiptsInSpaceCompleted: 'PRSC',
      PassReceiptsInSpace: 'PRS',
      PassReceiptsInSpaceCompletedFirstThird: 'PRSC1T',
      PassReceiptsInSpaceCompletedSecondThird: 'PRSC2T',
      PassReceiptsInSpaceCompletedFinalThird: 'PRSC3T',
      PassReceiptsInSpaceCompletedOppHalfRight: 'PRSCOHR',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'PRSCOHC',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'PRSCOHL',
      PassReceiptsInSpaceFirstThird: 'PRS1T',
      PassReceiptsInSpaceSecondThird: 'PRS2T',
      PassReceiptsInSpaceFinalThird: 'PRS3T',
      PassReceiptsInSpaceOppHalfRight: 'PRSOHR',
      PassReceiptsInSpaceOppHalfCenter: 'PRSOHC',
      PassReceiptsInSpaceOppHalfLeft: 'PRSOHL',
      TotalStrongOnBallPressures: 'TSBP',
      TotalLightOnBallPressures: 'TBP',
      SuccessfulStrongOnBallPressures: 'SSBP',
      SuccessfulLightOnBallPressures: 'SLBP',
      StrongOnBallPressuresPct: 'SBP%',
      LightOnBallPressuresPct: 'BP%',
      TimesBypassedByPasses: 'ByPPAS',
      TimesBypassedByCarries: 'ByPC',
      TimesBypassedByActions: 'ByPA',
      BypassedPlayersByCarries: 'ByPPC',
      BypassedDefendersByCarries: 'ByPDC',
      BypassedPlayersByActions: 'ByPPA',
      BypassedDefendersByActions: 'ByPDA',
      CarriesBypassingPlayers: 'CByPP',
      CarriesBypassingDefenders: 'CByPD',
      BypassedPlayersPerCarry: 'ByPPPC',
      BypassedDefendersPerCarry: 'ByPDPC',
      LineBreakingCarries: 'LBC',
      LineBreakingCarriesMD: 'LBCMD',
      LineBreakingCarriesM: 'LBCM',
      LineBreakingCarriesD: 'LBCD',
      LineBreakingCarriesPerCarry: 'LBCC%',
      LineBreakingActions: 'LBA',
      LineBreakingActionsMD: 'LBAMD',
      LineBreakingActionsM: 'LBAM',
      LineBreakingActionsD: 'LBAD',
      PassesPerLineBreakingPass: 'PPLBP',
      CarriesPerLineBreakingCarry: 'CPLBC',
      LinesBrokenByPasses: 'LBByP',
      LinesBrokenByCarries: 'LBByC',
      LinesBrokenByActions: 'LBByA',
      LinesBrokenPerPass: 'LBPP',
      LinesBrokenPerCarry: 'LBPC',
      AvgLastDefenderDistanceIP: 'ALDDIP',
      AvgLastDefenderDistanceOOP: 'ALDDIP',
      AvgDefensiveLineDistanceIP: 'ALDDIP',
      AvgDefensiveLineDistanceOOP: 'ALDDIP',
      AvgRBDistanceIP: 'ARBDIP',
      AvgRBDistanceOOP: 'ARBDOOP',
      AvgLBDistanceIP: 'ALBDIP',
      AvgLBDistanceOOP: 'ALBDOOP',
      AvgBlockDistanceIP: 'ABDIP',
      AvgBlockDistanceOOP: 'ABDOOP',
      AvgBlockAreaIP: 'ABAIP',
      AvgBlockAreaOOP: 'ABAOOP',
      AvgDefensiveLineWidthOOP: 'ADLWOOP',
      AvgOffensiveLineLastThirdWidthIP: 'AOLLTWIP',
      AvgLByIP: 'ALBIP',
      AvgRByIP: 'ARBIP',
      AvgOffensiveLineDistanceIP: 'AOLDIP',
      AvgOffensiveLineLastThirdDistanceIP: 'AOLTDIP',
      AvgOffensiveLineWidthIP: 'AOLWIP',
      OffBallRuns: 'OBR',
      OffBallRunsOverlap: 'OBRO',
      OffBallRunsUnderlap: 'OBRU',
      OffBallRunsRunAhead: 'OBRA',
      OffBallRunsRunBehind: 'OBRB',
      OffBallRunsCrossReceiver: 'OBRCR',
      OffBallRunsSupport: 'OBRS',
      OffBallRunsComingShort: 'OBRCS',
      AerialsOppHalf: 'AOPPH',
      SpeedScore: 'SSCO',
      EnduranceScore: 'ESCO',
      HeadedShots: 'HS',
      CarriesIntoFinalThird: 'CIF⅓',
      SwitchPlaySuccessful: 'SPS',
      SwitchPlayTotal: 'SPT',
      PassesInsideOppHalf: 'PiOH',
      PassesInsideOppHalfSuccessful: 'PiOHS',
      TacklesAttemptedFirstThird: 'TAF⅓',
      TacklesAttemptedSecondThird: 'TAS⅓',
      TacklesFirstThird: 'TF⅓',
      TacklesSecondThird: 'TS⅓',
      FoulsOwnHalf: 'FOH',
      TouchesOppHalf: 'TOPPH',
      TacklesAttemptedNotAdjusted: 'TANA',
      TacklesSuccessfulNotAdjusted: 'TSNA',
      AvgTop5MaxSpeed: 'AT5MS',
      LBPReceived: 'LBPR',
      LBPMReceived: 'LBPMR',
      LBPMDReceived: 'LBPMDR',
      ThroughBallReceived: 'TBR',
      DistanceIP: 'DST IP',
      WalkingDistanceIP: 'WLKD IP',
      JoggingDistanceIP: 'JOGD IP',
      RunningDistanceIP: 'RUND IP',
      HsrDistanceIP: 'HSRD IP',
      SprintsDistanceIP: 'SPRD IP',
      RunningNumberIP: 'RUNQ IP',
      HsrNumberIP: 'HSRQ IP',
      SprintsNumberIP: 'SPRQ IP',
      DistanceOOP: 'DST OOP',
      WalkingDistanceOOP: 'WLKD OOP',
      JoggingDistanceOOP: 'JOGD OOP',
      RunningDistanceOOP: 'RUND OOP',
      HsrDistanceOOP: 'HSRD OOP',
      SprintsDistanceOOP: 'SPRD OOP',
      RunningNumberOOP: 'RUNQ OOP',
      HsrNumberOOP: 'HSRQ OOP',
      SprintsNumberOOP: 'SPRQ OOP',
      PossessionRegain: 'PR',
      HandPassesSuccessful: 'SHP',
      HandPassesTotal: 'THP',
      InterceptionsNotAdjusted: 'INT',
      ClearancesNotAdjusted: 'CLE',
      RecoveriesNotAdjusted: 'REC'
    },
    AerialsOppHalf: 'Pojedynki powietrzne na poł. rywala',
    CarriesIntoFinalThird: 'Jedzie do ostatniego ⅓',
    scoreDifference: 'Różnica wyników: Pokazuje, czy wyniki tej gry były powyżej, czy poniżej średniej sezonu',
    SpeedScore: 'Wynik prędkości i mocy',
    EnduranceScore: 'Wynik wytrzymałości',
    HeadedShots: 'Strzały głową',
    HeadedXG: 'Kierował się xG',
    HeadedSetPieceTooltip: 'Wyświetlanie tylko zawodników, którzy wykonują główki po stałych fragmentach gry',
    SwitchPlaySuccessful: 'Przełącz grę pomyślnie',
    SwitchPlayTotal: 'Przełącz Odtwórz razem',
    PassesInsideOppHalf: 'Podania w połowie przeciwnika',
    PassesInsideOppHalfSuccessful: 'Podania do Opp w połowie udane',
    TacklesAttemptedFirstThird: 'Pierwsza próba odbioru ⅓',
    TacklesAttemptedSecondThird: 'Próba odbioru druga ⅓',
    TacklesFirstThird: 'Najpierw pomyślnie radzi sobie z ⅓',
    TacklesSecondThird: 'Zajmuje udaną drugą część ⅓',
    FoulsOwnHalf: 'Fauluje własną połowę',
    TouchesOppHalf: 'Dotyka połowy przeciwnika',
    TacklesAttemptedNotAdjusted: 'Próba odbioru nie została skorygowana',
    TacklesSuccessfulNotAdjusted: 'Walka skuteczna, nieskorygowana',
    AvgTop5MaxSpeed: 'Średnia maksymalna prędkość Top5',
    LBPReceived: 'Otrzymano przepustki na przełamanie linii',
    LBPMReceived: 'Otrzymano przepustki na łamanie linii (linia M).',
    LBPMDReceived: 'Otrzymano przepustki na łamanie linii (linia MD).',
    ThroughBallReceived: 'Otrzymane piłki',
    recoveriesRate: 'Współczynnik odzyskiwania',
    turnoversRate: 'Współczynnik strat',
    HsrDistanceIP: 'HSR Odległość IP',
    HsrDistanceOOP: 'Odległość HSR OOP',
    JoggingDistanceIP: 'Jogging Odległość IP',
    JoggingDistanceOOP: 'Dystans joggingu OOP',
    RunningDistanceIP: 'Bieganie dystansu IP',
    RunningDistanceOOP: 'Dystans biegu OOP',
    SprintsDistanceIP: 'Sprinty Odległość IP',
    SprintsDistanceOOP: 'Sprinty Dystans OOP',
    WalkingDistanceIP: 'Odległość IP',
    WalkingDistanceOOP: 'Odległość piesza OOP',
    PossessionRegain: 'Odzyskanie posiadania',
    HandPassesSuccessful: 'Udane podania ręczne',
    HandPassesTotal: 'Podania ręczne',
    SprintsNumberIP: 'Sprinty Ilość IP',
    SprintsNumberOOP: 'Ilość sprintów OOP',
    RunningNumberIP: 'Bieżąca ilość IP',
    RunningNumberOOP: 'Bieżąca ilość OOP',
    HsrNumberIP: 'HSR Ilość IP',
    HsrNumberOOP: 'Ilość HSR OOP',
    InterceptionsNotAdjusted: 'Interceptions',
    ClearancesNotAdjusted: '',
    RecoveriesNotAdjusted: 'Recoveries'
  },
  team: {
    title: 'Zestawienie drużyny',
    subtitle: 'Wejdź głębiej w charakterystykę i statystyki zespołu',
    averageAge: 'Śr. wiek',
    transferBalance: 'Bilans transferów',
    roster: 'Kadra',
    stadium: 'Stadion',
    coach: 'Trener',
    transfers: 'Transfery',
    trends: 'Trendy',
    loans: 'Wypożyczenia',
    loanFrom: 'Wypożyczony z',
    loanTo: 'Wypożyczony do',
    latestGames: 'Ostatnie mecze',
    latestXGames: 'Ostatnie {0} mecze',
    playingFor: 'Gra dla',
    overview: 'Przegląd',
    visualization: 'Wizualizacja',
    location: 'Strefa',
    outcome: 'Efekt',
    beeswarm: 'Ranking',
    parentTeam: 'Pierwszy zespół',
    childTeam: 'Zespół młodzieżowy',
    preferredFormation: 'Ulubiona formacja',
    mostFrecuentFormations: 'Najczęstsze formacje',
    viewType: 'Typ widoku',
    overviewTab: {
      axisXTotal: 'Łącznie',
      axisXper90: 'Na 90\'',
      dataPerGameText: 'Dane na mecz',
      season: 'Sezon',
      last: 'Ostatni',
      current: 'Bieżący',
      TeamStyle: 'Styl',
      TeamDefensive: 'Defensywa',
      TeamOffensive: 'Ofensywa',
      TeamCustom1: 'Własny 1',
      TeamCustom2: 'Własny 2',
      TeamCustom3: 'Własny 3',
      TeamCustom4: 'Własny 4',
      coach: 'Trener',
      groups: {
        Goals: {
          name: 'Gole',
          desc: 'Pokazuje gole z karnych i bez karnych (z akcji i SFG).'
        },
        Assists: {
          name: 'Asysty',
          desc: 'Zawodnicy z największą liczbą asyst (z akcji i SFG) w sezonie.'
        },
        xG: {
          name: 'Gole oczekiwane',
          desc: 'xG z akcji i stałych fragmentów'
        },
        xA: {
          name: 'Oczekiwane asysty',
          desc: 'xA z akcji i stałych fragmentów.'
        },
        Finishing: {
          name: 'Wykończenie',
          desc: 'Odsetek strzałów zakończonych golem.'
        },
        ScoringContribution: {
          name: 'Udział bramkowy',
          desc: 'Liczba asyst i goli zespołu.'
        },
        xT: {
          name: 'Zagrożenie oczekiwane',
          desc: 'xT z akcji, SFG i ujemne xT.'
        }
      },
      stats: {
        openPlay: 'Z akcji',
        setPiece: 'Stałe fragm.',
        negative: 'Ujemne',
        npg: 'Gole bez karnych',
        goalsPenalty: 'Gole z karnych',
        npgOpenPlay: 'NPG z akcji',
        npgSetPiece: 'NPG ze SFG',
        assists: 'Asysty',
        assistsConceded: 'Asysty przeciw',
        assistsOpenPlay: 'Asysty z akcji',
        assistsSetPiece: 'Asysty ze SFG',
        xGOpenPlay: 'xG z akcji',
        xGSetPiece: 'xG ze SFG',
        xAOpenPlay: 'xA z akcji',
        xASetPiece: 'xA ze SFG',
        xAConceded: 'xA przeciw',
        nonPenaltyShots: 'Strzały bez karnych',
        penaltyShots: 'Strzały z karnych',
        xT: 'Zagrożenie oczekiwane',
        xTOpenPlay: 'xT z akcji',
        xTSetPiece: 'xT ze SFG',
        xTNeg: 'Ujemne xT',
        totalFinishing: 'Wykończenie',
        nonPenaltyFinishing: 'Wykończenie bez karnych',
        goalsPenaltyFinishing: 'Wykończenie z karnych',
        goal: 'Gol',
        notGoal: 'Bez gola',
        chance: 'Sytuacja',
        finished: 'Zakończone',
        notFinished: 'Niezakończone',
        walkingDistance: 'Chód',
        joggingDistance: 'Trucht ',
        runningDistance: 'Bieg ',
        hsrDistance: 'HSR',
        sprintsDistance: 'Sprinty',
        runningNumber: 'Biegi',
        hsrNumber: 'Biegi HSR',
        sprintsNumber: 'Sprinty',
        maxSpeed: 'Prędkość maks.',
        accelerations: 'Przyspieszenia',
        extremeAccelerations: 'Ekstremalne przyspieszenia',
        maxAcceleration: 'Maks. przyspieszenie'
      }
    },
    teamAnalysis: 'Analiza zespołu',
    agentView: {
      positions: {
        gk: 'BR',
        leftFullback: 'Lewy OB',
        centralDefender: 'Środk. OB',
        rightFullback: 'Prawy OB',
        midfielder: 'Pomocnik',
        attackingMidfielder: 'Ofens. pom.',
        leftWinger: 'Lewy skrz.',
        rightWinger: 'Prawy skrz.',
        fw: 'NAP'
      },
      groups: {
        contractEnd: 'Miesiące',
        age: 'Lata',
        availability: 'Dostępność'
      },
      placer: {
        legend: 'Siła oparta na wieku, kontrakcie, dostępności i formie'
      }
    },
    transfersTab: {
      valueMovements: 'Wartość ruchów',
      valueTransfers: 'Wartość transferów',
      valueLoans: 'Wartość wypożyczeń',
      avgAgeMovements: 'Śr. wiek ruchów',
      avgAgeTransfers: 'Śr. wiek transferów',
      avgAgeLoans: 'Śr. wiek wypożyczeń',
      operations: {
        buys: {
          buy: 'Zakup',
          loan: 'Wypożyczenie',
          'end of loan': 'Koniec wypożyczenia',
          'free transfer': 'Wolny transfer',
          free: 'Wolny',
          'loan transfer': 'Wypożyczenie',
          other: 'Inne'
        },
        sells: {
          buy: 'Sprzedaż',
          loan: 'Wypożyczenie',
          'end of loan': 'Koniec wypożyczenia',
          'free transfer': 'Wolny transfer',
          free: 'Wolny',
          'loan transfer': 'Wypożyczenie',
          other: 'Inne',
          retired: 'Zakończenie kariery'
        }
      }
    },
    trendsTab: {
      streaks: 'Serie',
      wins: 'Zwycięstwa',
      cleanSheets: 'Czyste konta',
      goalPeriods: 'Okresy strzelonych goli',
      concededGoalPeriods: 'Okresy straconych goli',
      comebacks: 'Powroty',
      avgTime: 'Średni czas',
      kindOfGoals: 'Rodzaje goli',
      percentWinning: '% wygranych',
      percentDrawing: '% remisów',
      percentLosing: '% porażek',
      totalOf: 'Łącznie',
      minutes: 'minuty',
      before: 'Przed',
      after: 'Po',
      playedOn: 'Grano',
      scored: 'Strzelone',
      conceded: 'Stracone',
      ownGoals: 'Samobóje',
      phasesOfGame: 'Fazy gry',
      intensityLabel: 'Intensywność strefy',
      intensityByTeam: 'Według drużyny %',
      intensityByLeagueAvg: 'Według średniej ligi %',
      buildup: 'Budowa akcji',
      midfieldProgression: 'Progresja w środku',
      attackOpposition: 'Atak na rywala',
      attackingTransition: 'Przejście do ataku',
      highPress: 'Wysoki pressing',
      midBlock: 'Średni blok',
      lowBlock: 'Niski blok',
      defensiveTransition: 'Przejście do obrony',
      draws: 'Remisy',
      losts: 'Przegrane',
      chokes: 'Dławią się',
      zoneTooltip: 'Określa kryteria stosowane dla gradientu koloru każdego bloku:',
      teamPctTooltip: 'Na podstawie procentu całkowitego czasu spędzonego przez drużynę w każdej strefie.',
      leagueAvgPctTooltip: 'Porównuje procent drużyny ze średnią ligową dla każdej strefy.',
      leagueAvgMinsTooltip: 'Stosuje te same kryteria porównania z ligą, ale ocenia całkowity czas w minutach, a nie w procentach.',
      losses: 'Straty',
      results: 'Wyniki',
      kindOfConcededGoals: 'Typy straconych bramek',
      showMinutes: 'Pokaż minuty'
    },
    onOff: 'On/Off',
    dragUpToXPlayers: 'Przeciągnij do {x} graczy',
    selectUpToXPlayers: 'Wybierz do {x} graczy',
    onOffTab: {
      G90: 'Gole 90',
      GA90: 'Gole przeciw 90',
      diffG90: 'Różnica goli 90',
      XG90: 'xG 90',
      XGA90: 'xG przeciw 90',
      diffXG90: 'Różnica xG 90',
      playersOn: 'Kombinacja ON',
      playersOff: 'Kombinacja OFF',
      ground: 'Boisko',
      playersOnThePitch: 'Zawodnicy na boisku',
      playersOffThePitch: 'Zawodnicy poza boiskiem',
      attackTitle: 'Atak',
      attackSubTitle: 'Statystyki ofensywne',
      defenseTitle: 'Obrona',
      defenseSubTitle: 'Statystyki defensywne',
      associationTitle: 'Asocjacja',
      associationSubTitle: 'Statystyki asocjacyjne',
      comboOn: 'Aktywna kombinacja',
      comboOff: 'Inna',
      diffGoals90: 'G Diff 90',
      goals90: 'Gole bez karnych 90',
      goalsAgainst90: 'Gole bez karnych przeciw 90',
      xgAgainstPer90: 'xG przeciw 90',
      xgDiffPer90: 'Różnica xG 90',
      xgPer90: 'xG 90',
      xt90: 'xT 90',
      shotsOnTarget90: 'Strzały celne 90',
      touchesOppBox90: 'Kontakty w polu rywala 90',
      shotsOnTargetAgainst90: 'Strzały celne przeciw 90',
      ppda90: 'PPDA 90',
      xa90: 'xA 90',
      directness90: 'Directness 90',
      possession: 'Posiadanie %',
      pctPasses: 'Podań %',
      pctPassesFinalThird: 'Podań do ostatniej tercji %',
      placeholder: 'Zacznij od wyboru drużyny',
      subtitle: 'Optymalizuj metryki zespołu dodając lub zdejmując graczy ze składu'
    },
    terms: {
      short: 'Krótki termin',
      mid: 'Średni termin',
      long: 'Długi termin'
    },
    report: {
      title: 'Raport zespołu',
      selectedPeriod: 'Wybrany okres',
      stackedCharts: 'Wykresy warstwowe',
      radars: 'Radary',
      generalData: 'Dane ogólne',
      scoringChances: 'Sytuacje bramkowe',
      areasReport: 'Raport stref',
      setPieceReport: 'Raport SFG',
      corners: 'Rzuty rożne',
      cornersAgainst: 'Rożne przeciw',
      indirectFreeKicks: 'Rzuty wolne pośrednie',
      indirectFreeKicksAgainst: 'Wolne pośrednie przeciw',
      freeKicks: 'Rzuty wolne',
      freeKicksAgainst: 'Wolne przeciw',
      penaltys: 'Karne',
      freeKicksContribution: 'Udział z rzutów wolnych',
      shotsContribution: 'Udział strzałów',
      topXPlayersByStats: 'Top {x} zawodników wg statystyk',
      lastShotZone: 'Strefa ostatniego strzału',
      throwSide: 'Strona wrzutu',
      kindOfThrow: 'Rodzaj wrzutu',
      scored: 'Strzelone',
      against: 'Przeciw',
      perGame: 'na mecz',
      total: 'Łącznie',
      efficiency: 'Skuteczność',
      organizedAttack: 'Atak pozycyjny',
      offTransition: 'Przejście do ataku',
      chances: 'Sytuacje',
      chancesScored: 'Sytuacje zakończone golem',
      chancesAgainst: 'Sytuacje przeciw',
      goalsScored: 'Gole strzelone',
      goalsAgainst: 'Gole stracone',
      goalsOrganizedAttack: 'Gole z ataku pozycyjnego',
      goalsOffTransition: 'Gole z przejścia do ataku',
      goalsSetPiece: 'Gole ze SFG',
      goalsOrganizedAttackScored: 'Gole z AP – strzelone',
      goalsOrganizedAttackAgainst: 'Gole z AP – przeciw',
      goalsOffTransitionScored: 'Gole z tran. of. – strzelone',
      goalsOffTransitionAgainst: 'Gole z tran. of. – przeciw',
      goalsSetPieceScored: 'Gole ze SFG – strzelone',
      goalsSetPieceAgainst: 'Gole ze SFG – przeciw',
      crossSide: 'Strona dośrodkowania',
      externalShot: 'Strzał zewnętrzny',
      innerPlay: 'Gra wewnątrz',
      throwIn: 'Wrzut z autu',
      box: 'Pole karne',
      zone2: 'Strefa 2',
      goalsPerPhases: 'Gole wg faz gry'
    },
    minutesAlert: '*Pokazywani tylko gracze z minimum 450 minut',
    minutesException: 'Brak graczy z ≥450 minutami. Pokazano wszystkich',
    analysis: 'Analiza',
    substitutions: 'Zmiany',
    attackZones: 'Strefy ataku',
    formations: 'Formacje',
    shotZones: 'Strefy strzałów',
    crossings: 'Dośrodkowania',
    byTime: 'Według czasu',
    byPosition: 'Według pozycji',
    byPlayer: 'Według gracza',
    W: 'Wygrana',
    D: 'Remis',
    L: 'Porażka',
    substitutionsByGame: 'Zmiany na mecz',
    substitutionsShort: 'Zm.',
    avgSeasonShort: 'Śr. sezon',
    startingAt: 'Początek w',
    endingAt: 'Koniec w',
    startingAtInfo: 'Udział posiadania wg lokalizacji pierwszego zdarzenia',
    endingAtInfo: 'Udział posiadania wg lokalizacji ostatniego zdarzenia',
    endingWithShot: 'Zakończone strzałem',
    endingInBox: 'Zakończone w polu',
    pfX: 'PF {x}',
    bySide: 'Według strony',
    cornerKicks: 'Rzuty rożne',
    included: 'Uwzględnione',
    excluded: 'Wykluczone',
    onlyCorner: 'Tylko rzut rożny',
    sizeByMarketValue: 'Rozmiar wg wartości rynkowej',
    timeInTeam: 'Sezony w drużynie',
    newSignings: 'Nowe transfery',
    sizeBy: 'Rozmiar wg',
    connections: 'Połączenia',
    assistant: 'Podający',
    finisher: 'Wykańczający',
    playersMinutesAlert: 'Pokazywani tylko gracze z minutami w wybranym sezonie',
    strategyFilterTooltip: 'Wyświetlaj zdarzenia, które miały miejsce podczas stałych fragmentów gry lub podczas otwartej gry',
    sideFilterTooltip: 'Wyświetl tylko stałe fragmenty, które zaczynają się po wybranej stronie (lewej lub prawej)',
    teamMinutesAlert: '*Pokazuje tylko drużyny, które rozegrały 450 lub więcej minut',
    homeCoach: 'Trener domowy',
    awayCoach: 'Trener wyjazdowy'
  },
  leagueTable: {
    subtitle: 'Sprawdź, jak wyglądają rozgrywki'
  },
  leagueMatchdays: {
    byRound: 'Według kolejki',
    byDate: 'Według daty',
    byTeam: 'Według drużyny'
  },
  teamStats: {
    subtitle: 'Porównaj formę drużyn',
    xGDiffPerGame: 'xGD',
    xGDiffPerGameExplicit: 'Różnica między xG a golami',
    expectedPointsDiff: 'xPD',
    expectedPointsDiffExplicit: 'Różnica między xP a punktami',
    games: 'MEC',
    gamesExplicit: 'Rozegrane mecze',
    pointsPerGame: 'PPM',
    pointsPerGameExplicit: 'Punkty na mecz'
  },
  roles: {
    ROLE_USER: 'Użytkownik',
    ROLE_ADMIN: 'Admin',
    ROLE_REPORTS: 'Raporty Driblab',
    ROLE_API: 'Driblab API',
    ROLE_PHYSICAL_DATA: 'Dane fizyczne Driblab',
    ROLE_VIDEO: 'Wideo',
    ROLE_EVENTING_DATA: 'Driblab XY',
    ROLE_DRIBLAB_HUB: 'Driblab Hub',
    ROLE_TRACKING: 'Tracking',
    ROLE_ARRIGO: 'Arrigo',
    ROLE_API_description: 'Pobieraj dane o zawodnikach, drużynach, meczach i ligach w formacie JSON.',
    ROLE_EVENTING_DATA_description: 'Zanurz się w statystyki: radary, rankingi, mapy i ponad 100 metryk wydajności.',
    ROLE_PHYSICAL_DATA_description: 'Dostęp do danych fitness i filtrowanie po metrykach (dystans, prędkość, sprinty, przyspieszenia…).',
    ROLE_VIDEO_description: 'Przekaż wideo i składy, a otrzymasz mecze otagowane zdarzeniami i statystykami do głębokiej analizy.',
    ROLE_DRIBLAB_HUB_description: 'Efektywnie zarządzaj skautingiem: kalendarze, notatki, alerty i współdzielenie dokumentów.',
    ROLE_TRACKING_description: 'Otrzymuj przez API dane pozycyjne wszystkich zawodników w meczu do kompleksowej analizy.',
    ROLE_ARRIGO_description: 'Łącz dane zdarzeń i tracking w innowacyjne metryki wykraczające poza tradycyjne ujęcia.',
    ROLE_REPORTS_description: 'Zamawiaj szczegółowe raporty skautingowe, by znaleźć idealną drużynę lub gracza.',
    ROLE_RAW_EVENTING: 'Surowe wydarzenie'
  },
  administration: {
    pageSubtitle: 'Zarządzaj działaniem aplikacji',
    newClient: 'Nowy klient',
    clientDuplicateName: 'Klient o tej nazwie już istnieje. Wybierz go na liście i użyj „Nowy użytkownik”, aby dodać użytkowników do tego klienta.',
    newUser: 'Nowy użytkownik',
    editClient: 'Edytuj klienta',
    editUser: 'Edytuj użytkownika',
    clientName: 'Nazwa',
    permissions: 'Uprawnienia',
    releaseUser: 'Udostępnij użytkownika',
    connectAsUser: 'Połącz jako użytkownik',
    releaseModalTitle: 'Potwierdzenie udostępnienia użytkownika',
    releaseModalMessage: 'Użytkownik otrzyma e‑mail o nowym koncie. Na pewno powiadomić?',
    clientType: {
      Driblab: 'Driblab',
      Team: 'Klub',
      Brand: 'Marka',
      Federation: 'Federacja',
      Media: 'Media',
      Agency: 'Agencja',
      Individual: 'Indywidualny'
    },
    userType: {
      Ownership: 'Właściciel',
      SportingDirector: 'Dyrektor sportowy',
      Brand: 'Marka',
      Federation: 'Federacja',
      Media: 'Media',
      Agency: 'Agencja',
      Individual: 'Indywidualny',
      Scout: 'Skaut',
      Coach: 'Trener',
      supervision: {
        title: 'Hierarchia nadzoru',
        subtitle: 'Nadzór płynie tylko w dół. Nadzór na tym samym poziomie jest niedopuszczalny.',
        supervisesLowerLevels: 'Nadzoruje wszystkie poniższe role',
        ruleNoSameLevel: 'Role na tym samym poziomie nie mogą się wzajemnie nadzorować.',
        ruleOnlyDownwards: 'Nadzór jest dozwolony tylko na stanowiskach wyższych i niższych.',
        ruleLevel3NoSupervision: 'Najniższy poziom nie ma uprawnień do nadzoru.',
        currentUserType: 'Twój aktualny typ użytkownika'
      }
    },
    visibleYears: 'Widoczne lata',
    areaModalTitle: 'Potwierdź aktywację/dezaktywację lig',
    areaModalMessage: 'Czy na pewno aktywować/dezaktywować wszystkie ligi w wybranym obszarze?',
    countStats: 'Zlicz statystyki',
    userClientModalTitle: 'Użytkownik już istnieje u innego klienta',
    eventing: 'Zdarzenia',
    hub: 'Hub',
    contract: 'Kontrakt',
    contracts: 'Kontrakty',
    invoiceName: 'Nazwa na fakturze',
    contractFee: 'Opłata za kontrakt',
    renewal: 'Odnowienie',
    consultancy: 'Konsulting',
    deleteContract: 'Usuń kontrakt klienta',
    deleteContractMessage: 'Kontrakt zostanie trwale usunięty. Kontynuować?',
    activeVsHired: 'Aktywni vs zatrudnieni',
    requestedVsHired: 'Zapytania vs zatrudnieni',
    activeVsHiredWithPlaceholder: '{0} Aktywny vs {1} Zatrudniony',
    requestedVsHiredWithPlaceholder: '{0} Poproszono vs {1} Zatrudniono',
    salesRepresentative: 'Przedstawiciel handlowy',
    periodicities: {
      periodicity: 'Okresowość',
      annual: 'Rocznie',
      biannual: 'Półrocznie',
      quarterly: 'Kwartalnie',
      monthly: 'Miesięcznie',
      bimonthly: 'Dwumiesięcznie',
      onePayment: 'Jednorazowo',
      fourmonthly: 'Co cztery miesiące'
    },
    paymentMethods: {
      payment: 'Płatność',
      method: 'Metoda',
      transfer: 'Przelew',
      mandate: 'Zgoda SEPA'
    },
    marketingOptions: {
      marketing: 'Marketing',
      socialMediaAdd: 'Reklama w social media',
      videoWithFeedback: 'Wideo z opinią'
    },
    status: {
      status: 'Status',
      pending: 'Oczekujące',
      active: 'Aktywne',
      expiringSoon: 'Wygasa wkrótce',
      expired: 'Wygasło',
      expiringSoonWithDays: 'Umowa wkrótce wygaśnie: pozostało {0} dni'
    },
    updates: {
      roleAdded: '<b>{0}</b> dodał rolę <b>{1}</b> do <b>{2}</b>.',
      roleRemoved: '<b>{0}</b> usunął rolę <b>{1}</b> z <b>{2}</b>.',
      leagueAdded: '<b>{0}</b> dodał <b>{1}</b> do ligi <b>{2}</b>.',
      leagueRemoved: '<b>{0}</b> usunął <b>{1}</b> z ligi <b>{2}</b>.',
      seasonAdded: '<b>{0}</b> dodał <b>{1}</b> do sezonu <b>{2}</b>.',
      seasonRemoved: '<b>{0}</b> usunął <b>{1}</b> z sezonu <b>{2}</b>.',
      updateNotesPlaceholder: 'Dodaj kontekst zmiany lub inne istotne uwagi tutaj...',
      updates: 'Aktualizacje',
      products: 'Produkty'
    },
    clients: 'Klienci',
    trials: 'Próby',
    activeClients: 'Aktywni Klienci',
    activeTrials: 'Aktywne próby',
    activeTrialUsers: 'Aktywni użytkownicy wersji próbnej',
    activeContracts: 'Aktywne kontrakty',
    expiration: 'Wygaśnięcie',
    clientWarnings: {
      activeContractInactiveClient: 'Klienci z aktywnymi umowami, ale bez włączonych użytkowników',
      activeContractTrialUsers: 'Klienci z użytkownikami próbnymi w czasie obowiązywania umowy',
      activeUsersWithoutContract: 'Klienci z aktywnymi użytkownikami innymi niż wersja próbna, ale bez aktywnej umowy',
      upcomingExpirations: 'Nadchodzące wygaśnięcia',
      renewedContracts: 'Klienci w ramach odnowionych umów',
      clientsWithWarnings: 'Klienci wymagający uwagi',
      enabledUsersWithoutContract: '„Włączeni użytkownicy bez wersji próbnej bez aktywnej umowy”',
      trialUsersWithContract: 'Użytkownicy w trybie próbnym pomimo aktywnej umowy',
      activeContractInactiveUsers: 'Klient ma aktywną umowę, a wszyscy użytkownicy są nieaktywni',
      activeContract: 'Ten klient ma aktywną umowę',
      noEnabledUsers: 'Ten klient nie ma włączonych użytkowników',
      ongoingTrialInactiveUsers: 'Klienci z trwającym okresem próbnym, ale bez włączonych użytkowników',
      neverLoggedIn: 'Klienci, którzy nigdy się nie logowali'
    },
    daysLeft: 'Pozostało dni',
    expiringSoon: 'Wkrótce wygaśnie',
    loggedThisWeek: 'Zalogowałem się w tym tygodniu',
    withWarnings: 'Z ostrzeżeniami',
    ofActiveClients: 'aktywnych klientów',
    endingIn30Days: 'kończy się za 30 dni',
    neverLogged: 'nigdy się nie logowałem',
    ofActiveTrials: 'aktywnych prób',
    activeClientsWithoutTrial: 'aktywni klienci (oprócz okresu próbnego)',
    renewals: 'Odnowienia',
    ofActiveContracts: 'aktywnych kontraktów'
  },
  dashboards: {
    lastGame: 'Analiza ostatniego meczu',
    lastGameSimple: 'Ostatni mecz',
    seeAllGameInfo: 'Zobacz wszystkie dane meczu',
    nextGame: 'Zapowiedź następnego meczu',
    myTeam: 'Mój zespół',
    lastMatchdayGames: 'Ostatnia kolejka',
    lastAdded: 'Ostatnio dodane',
    myFavorites: 'Moje ulubione',
    seeAllFavorites: 'Zobacz wszystkie ulubione',
    placeholderFavorites: 'Dodawaj ulubione z widoku zawodnika',
    placeholderTeamFavorites: 'Dodawaj ulubione z widoku drużyny',
    placeholderLeagueFavorites: 'Dodawaj ulubione z widoku ligi',
    myCollections: 'Moje kolekcje',
    placeholderCollections: 'Nie masz jeszcze żadnych kolekcji',
    lastCreated: 'Ostatnio utworzone',
    seeAllCollections: 'Zobacz wszystkie kolekcje',
    seeRival: 'Zobacz rywala',
    seeMyTeam: 'Zobacz mój zespół',
    title: 'Przegląd pulpitu',
    subtitle: 'Witaj ponownie',
    recentPlayers: 'Ostatni zawodnicy',
    lastScouted: 'Ostatnio scoutowani',
    scout: 'Skaut',
    reportsRequested: 'Raporty',
    lastRequested: 'Ostatnio zamówione',
    goInbox: 'Przejdź do skrzynki',
    placeholderLastScouted: 'Szukaj zawodników w lewej kolumnie lub narzędziu skauta',
    placeholderReports: 'Zamawiaj raporty z widoku zawodnika',
    nationalPlayers: 'Najdrożsi krajowi zawodnicy w innych krajach',
    lastGames: 'Ostatnie mecze',
    nationalPlayersShort: 'Krajowi w innych ligach',
    nextMatchdayGames: 'Następna kolejka',
    injuredPlayers: 'Kontuzjowani',
    atPresent: 'Obecnie',
    seeAllPlayers: 'Zobacz wszystkich',
    suspendedPlayers: 'Zawieszeni',
    placeholderInjured: 'Brak kontuzjowanych',
    teamValueImpacted: 'Wpływ na wartość zespołu',
    placeholderSuspended: 'Brak zawieszonych',
    placeholderNextGame: 'Brak dostępnego meczu',
    placeholderNoGames: 'Brak dostępnych meczów',
    placeholderLastMatchDayNotFound: 'Brak danych ostatniej kolejki',
    placeholderNextMatchDayNotFound: 'Brak danych następnej kolejki',
    usersMostSearch: 'Użytkownicy z największą liczbą wyszukiwań',
    lastTwoDays: 'Ostatnie dwa dni',
    searchesHistory: 'Historia wyszukiwań',
    dayByDay: 'Dziennie',
    activeUsersTitle: 'Aktywni użytkownicy',
    activeUsersSubtitle: 'Zalogowani co najmniej raz w ostatnim miesiącu',
    onlineUsersTitle: 'Użytkownicy online',
    onlineUsersSubtitle: 'Wyszukiwali w ostatniej godzinie',
    searchesPerformed: 'Wykonane wyszukiwania',
    onlyClients: 'Tylko klienci',
    activeClientsTitle: 'Aktywni klienci',
    activeClientsSubtitle: 'Mają co najmniej jednego aktywnego użytkownika',
    last24Hours: 'Ostatnie 24 godziny',
    activityHistory: 'Historia aktywności',
    loginHistory: 'Historia logowań',
    failLogins: 'Nieudane logowania',
    successLogins: 'Udane logowania',
    clientStats: 'Statystyki klientów',
    playersMostSearch: 'Zawodnicy z największą liczbą wyszukiwań',
    toolsMoreUsed: 'Najczęściej używane narzędzia',
    hotPlayers: 'Na topie',
    last_month: 'Ostatni miesiąc',
    last_week: 'Ostatni tydzień',
    last_day: 'Ostatni dzień',
    nClients: 'Liczba klientów',
    userDashboard: 'Pulpit użytkownika',
    userDashboardSubtitle: 'Podsumowanie aktywności konta',
    offlineDaysOfClient: 'Dni offline dla klienta',
    hideNoConnected: 'Ukryj niepołączonych',
    onlyTrial: 'Tylko trial',
    daysWithoutLogin: 'Dni bez logowania',
    trialDays: 'Dni trialu'
  },
  faq: {
    subtitle: 'Dowiedz się więcej o Driblab PRO',
    categories: {
      playerMetrics: 'Metryki zawodników',
      teamMetrics: 'Metryki drużyn',
      positions: 'Pozycje w zespole',
      tools: 'Narzędzia',
      api: 'API',
      videos: 'Tutoriale',
      playerPositions: 'Pozycje zawodników',
      userTypes: 'Typy użytkowników'
    },
    positions: {
      GK: 'Bramkarz',
      DR: 'Prawy obrońca / Prawy boczny (RB)',
      DC: 'Środkowy obrońca (CB)',
      DL: 'Lewy obrońca / Lewy boczny (LB)',
      DMR: 'Prawy wahadłowy (RWB)',
      DMC: 'Defensywny pomocnik (CDM)',
      DML: 'Lewy wahadłowy (LWB)',
      MR: 'Prawy pomocnik (RM)',
      MC: 'Środkowy pomocnik (CM)',
      ML: 'Lewy pomocnik (LM)',
      AMR: 'Prawy skrzydłowy / Ofens. prawy (RW)',
      AMC: 'Ofensywny pomocnik (AMC)',
      AML: 'Lewy skrzydłowy / Ofens. lewy (LW)',
      FWR: 'Prawy napastnik (RS)',
      FW: 'Napastnik (ST)',
      FWL: 'Lewy napastnik (LS)'
    },
    metrics: {
      categories: {
        Association: 'Asocjacja',
        Saving: 'Bronienie',
        Shooting: 'Strzały',
        Defending: 'Obrona',
        Passing: 'Podania',
        BallHandling: 'Prowadzenie piłki',
        Aerial: 'Gra w powietrzu',
        Physical: 'Fizyczne',
        Predictive: 'Predykcyjne',
        Arrigo: 'Arrigo',
        Score: 'Ocena',
        Turnovers: 'Straty',
        Carries: 'Prowadzenia',
        SequenceInvolvement: 'Udział w sekwencjach',
        Crosses: 'Dośrodkowania',
        Distance: 'Dystans',
        Sprint: 'Sprint',
        Acceleration: 'Przyspieszenie',
        MaxAcceleration: 'Maks. przyspieszenie',
        Speed: 'Prędkość',
        OutPlay: 'Ogrywanie',
        LineBreakingPasses: 'Podania przełamujące linie',
        LineBreakingCarries: 'Prowadzenia przełamujące linie',
        LineBreakingActions: 'Akcje przełamujące linie',
        PassUnderPressure: 'Podania pod presją',
        BallReceived: 'Przyjęcia piłki',
        PassesUnderPressure: 'Przechodzi Pod Presją',
        OnBallPressureReceived: 'Presja na piłkę – otrzymana',
        OnBallPressure: 'Presja na piłkę',
        BallReceiptsInSpace: 'Odbior Piłki w Przestrzeni',
        SpatialCoverage: 'Pokrycie przestrzeni',
        OffBallPressure: 'Presja bez piłki',
        OffBallRuns: 'Biegi bez piłki',
        NoCategory: 'Inne',
        subcategories: {
          Quality: 'Jakość',
          Quantity: 'Ilość',
          TeamComparison: 'Porównanie drużynowe',
          Receptions: 'Przyjęcia',
          LongBalls: 'Długie piłki',
          Efficiency: 'Skuteczność',
          Ratio: 'Wskaźnik',
          Defensive: 'Defensywne',
          Offensive: 'Ofensywne',
          Foot: 'Noga',
          Progression: 'Progresja',
          TopValue: 'Najwyższa wartość',
          Predictive: 'Predykcyjne',
          Distance: 'Dystans',
          Aerial: 'Powietrzne',
          Crosses: 'Dośrodkowania',
          NoCategory: 'Inne'
        },
        desc: {
          Association: 'Asocjacja',
          Saving: 'Bronienie',
          Shooting: 'Strzały',
          Defending: 'Obrona',
          Passing: 'Podania',
          BallHandling: 'Prowadzenie piłki',
          Aerial: 'Gra w powietrzu',
          Physical: 'Fizyczne',
          Predictive: 'Predykcyjne',
          Arrigo: 'Arrigo',
          Score: 'Ocena',
          Turnovers: 'Straty',
          Carries: 'Prowadzenia',
          SequenceInvolvement: 'Udział w sekwencjach',
          Crosses: 'Dośrodkowania',
          Distance: 'Dystans pokonywany z różnymi prędkościami',
          Sprint: 'Sprint przy różnych prędkościach',
          Acceleration: 'Przyspieszenie',
          Speed: 'Prędkość osiągana w trakcie meczu',
          OutPlay: 'Ogrywanie',
          LineBreakingPasses: 'Podania przełamujące linie',
          LineBreakingCarries: 'Prowadzenia przełamujące linie',
          LineBreakingActions: 'Akcje przełamujące linie',
          PassUnderPressure: 'Podanie pod presją',
          BallReceived: 'Przyjęcia piłki',
          OnBallPressureReceived: 'Presja na piłkę – otrzymana',
          OnBallPressure: 'Presja na piłkę',
          BallReceiptsInSpace: 'Odbior Piłki w Przestrzeni',
          SpatialCoverage: 'Pokrycie przestrzeni',
          OffBallPressure: 'Presja bez piłki',
          OffBallRuns: 'Biegi bez piłki',
          HandPassing: 'Podania wykonywane ręką przez bramkarzy lub wrzuty po stałych fragmentach gry'
        },
        abbr: {
          Association: 'Association',
          Saving: 'Saving',
          Shooting: 'Shooting',
          Defending: 'Defending',
          Passing: 'Passing',
          BallHandling: 'Ball H.',
          Aerial: 'Aerial',
          Physical: 'Physical',
          Predictive: 'Predictive',
          Arrigo: 'Arrigo',
          Score: 'Score',
          Turnovers: 'TOV',
          Carries: 'Carries',
          SequenceInvolvement: 'Seq. Involv.',
          Crosses: 'Crosses',
          Distance: 'Distance',
          Sprint: 'Sprint',
          Acceleration: 'Acceleration',
          MaxAcceleration: 'Max. Acceleration',
          Speed: 'Speed',
          OutPlay: 'Outplay',
          LineBreakingPasses: 'Line Breaking Passes',
          LineBreakingCarries: 'Line Breaking Carries',
          LineBreakingActions: 'Line Breaking Actions',
          PassUnderPressure: 'Pass Under Pressure',
          BallReceived: 'Ball Receipts',
          OnBallPressureReceived: 'On-Ball Pressure Received',
          OnBallPressure: 'On-Ball Pressure',
          BallReceiptsInSpace: 'Ball Receipts in Space',
          SpatialCoverage: 'Spatial Coverage',
          OffBallPressure: 'Off-Ball Pressure',
          OffBallRuns: 'Off-Ball Runs',
          HandPassing: 'Podanie ręką'
        },
        HandPassing: 'Podanie ręką'
      },
      types: {
        1: 'Na 90',
        2: 'Procent',
        3: 'Wskaźnik',
        4: 'Skuteczność',
        5: 'Średnia',
        6: 'Na mecz',
        7: 'Różnica',
        8: 'Maks'
      },
      moreInfo: 'Więcej informacji tutaj'
    },
    api: {
      subtitle: 'Pobieraj dane z różnych endpointów',
      resourcesTitle: 'Zasoby',
      authentication: 'Uwierzytelnianie',
      authText: 'Aby wywołać API, dodaj w nagłówku każdej prośby `Authorization` z wartością `Bearer {API_TOKEN}`',
      generate: 'Generuj',
      tokenPlaceholder: 'Jeśli nie masz tokena lub wygasł, kliknij \'Generuj\'',
      pathParameters: 'Parametry ścieżki',
      queryParameters: 'Parametry zapytania',
      responseModel: 'Model odpowiedzi',
      tokenWarning: '* Wygeneruj token, aby korzystać z API',
      pathParamsWarning: '* Brakujące parametry ścieżki',
      genericDescription: 'API umożliwia dostęp do danych o krajach, rozgrywkach, drużynach, zawodnikach, meczach i innych. Wykorzystaj te dane do analityki, wizualizacji i własnych rozwiązań.',
      methods: {
        getAllCountries: 'Zwraca pełną listę krajów dostępnych w API (id i nazwa). Przydatne do wyboru kraju, filtrowania i analityki.',
        getCountryDetail: 'Szczegóły wybranego kraju (nazwa, kod, metadane) do kontekstu i wglądu geograficznego.',
        getCountryCompetitions: 'Lista rozgrywek w danym kraju – eksploracja turniejów regionalnie.',
        getAllCompetitionTypes: 'Lista typów rozgrywek (liga, puchar, międzynarodowe) – do kategoryzacji i filtrów.',
        getAllCompetitions: 'Pełna lista rozgrywek niezależnie od typu i lokalizacji.',
        getCompetitionAvailable: 'Lista rozgrywek oznaczonych jako dostępne – aktualne i gotowe do użycia.',
        getCompetitionDetail: 'Szczegółowe info o rozgrywkach – do widoków detali i filtrów kontekstowych.',
        getCompetitionSeasons: 'Lista sezonów powiązanych z rozgrywkami – przegląd historii i bieżącego stanu.',
        getSeasonAvailable: 'Sezony oznaczone jako dostępne – do pracy na aktualnych danych.',
        getSeasonDetail: 'Szczegóły sezonu: oś czasu, rozgrywki, metadane – do przeglądu i filtrów.',
        getSeasonTeams: 'Lista drużyn w sezonie – do analizy i filtrów sezonowych.',
        getSeasonPlayer: 'Lista zawodników zarejestrowanych w sezonie – kadry, filtrowanie, analityka.',
        getSeasonPlayerStats: 'Szczegółowe statystyki zawodników w sezonie – porównania i wizualizacje.',
        getSeasonArrigoMetrics: 'Zestawione metryki Arrigo dla zawodników w sezonie – analizy i porównania.',
        getSeasonTeamStats: 'Szczegółowe statystyki drużyn w sezonie – przeglądy i porównania.',
        getSeasonCoaches: 'Lista trenerów w danym sezonie – wgląd i analiza zmian.',
        getSeasonGames: 'Lista wszystkich meczów w sezonie – terminarze i wyniki.',
        getSeasonGamesMatchday: 'Wszystkie mecze kolejki w sezonie – harmonogramy i analizy rund.',
        getSeasonLeagueTable: 'Tabela ligowa sezonu – miejsca, punkty, bilanse, trendy.',
        getTeamDetail: 'Szczegóły drużyny: nazwa, rok zał., stadion i metadane – profile drużyn.',
        getTeamLoans: 'Informacje o wypożyczeniach zespołu – analizy transferowe i kadrowe.',
        getTeamRoster: 'Pełna kadra drużyny – składy, role, zarządzanie listą.',
        getTeamGames: 'Lista meczów drużyny – historia i przegląd wyników.',
        getTeamGameStats: 'Szczegółowe statystyki drużyny w meczu – analityka i raporty pomeczowe.',
        getTeamTransfers: 'Transakcje transferowe drużyny – trendy rynku i zmiany kadr.',
        getGameStatus: 'Lista statusów meczu (zaplanowany, trwa, zakończony, przełożony, odwołany) – śledzenie w czasie rzeczywistym.',
        getPlayerPositions: 'Lista możliwych pozycji zawodników – kategoryzacja i filtry pozycyjne.',
        getGameDetail: 'Szczegóły meczu: zespoły, czas, stadion, wynik, metadane – zapowiedzi i raporty.',
        getGameStats: 'Szczegółowe statystyki meczu: gole, strzały, posiadanie, podania, obrona.',
        getGamePlayerStats: 'Szczegółowe statystyki zawodników w meczu – raporty i porównania.',
        getGamePlayerPhysicalStats: 'Metryki fizyczne zawodników w meczu – fitness i obciążenia.',
        getGameTeamPhysicalStats: 'Metryki fizyczne drużyn w meczu – porównania wysiłku.',
        getGamePlayerArrigoMetrics: 'Metryki Arrigo zawodników w meczu – wgląd taktyczny.',
        getGameTeamArrigoMetrics: 'Metryki Arrigo drużyn w meczu – ocena wydajności.',
        getGameLineup: 'Składy meczowe: wyjściowi, rezerwowi, pozycje – formacje i taktyka.',
        getGameTimeline: 'Chronologiczna lista zdarzeń meczu – live, podsumowania, analizy.',
        getGameTracking: 'Link do pobrania pliku tracking – ruchy i pozycje piłki oraz graczy.',
        getTrackingStatus: 'Lista stanów trackingu (id, nazwy) – wybór, filtrowanie i analiza.',
        getPlayerTransfersTypes: 'Lista typów transferów: definitywny, wypożyczenie, wolny, wymiana.',
        getPlayerDetail: 'Szczegóły zawodnika: dane, statystyki kariery, aktualny klub – profile.',
        getPlayerGames: 'Lista meczów zawodnika – historia występów.',
        getPlayerInjuries: 'Rejestr kontuzji zawodnika – zdrowie i powroty.',
        getPlayerNationalTeam: 'Występy w kadrze narodowej – turnieje i mecze towarzyskie.',
        getPlayerSeasons: 'Lista sezonów w karierze zawodnika – progres i kontekst historyczny.',
        getPlayerTransfers: 'Historia transferów zawodnika – ruchy między klubami.',
        getPlayerSeasonTeamStats: 'Statystyki zawodnika w sezonie – porównania i wkład.',
        getPlayerSeasonPhysicalStats: 'Metryki fizyczne zawodnika w sezonie – obciążenie i forma.',
        getPlayerSeasonGamePhysicalStats: 'Metryki fizyczne zawodnika per mecz – porównania spotkań.',
        getPlayerSeasonGameStats: 'Statystyki zawodnika per mecz w sezonie – trendy i analizy.',
        getCoachDetail: 'Szczegóły trenera: kariera, zespoły, osiągnięcia – profile szkoleniowców.',
        getCoachHistory: 'Historia kariery trenera: zespoły, rozgrywki, okresy pracy – analizy zmian.',
        getGameEventing: 'Ta metoda udostępnia wszystkie zdarzenia',
        getLinkStream: 'Ta metoda pobiera łącze umożliwiające obejrzenie wideo z gry',
        getLinkDownload: 'Ta metoda pobiera łącze umożliwiające pobranie wideo z gry',
        getGameTs: 'Ta metoda zapewnia ostatni znacznik czasu w określonym dopasowaniu',
        getGameFileTypes: 'Ta metoda zapewnia dopasowanie typów plików',
        deletePlayer: 'This method delete a player',
        getGeneralPositions: 'Ta metoda zwraca listę możliwych ogólnych pozycji, takich jak bramkarz, obrońca, pomocnik i napastnik.',
        getPercentiles: 'Ta metoda zapewnia wszystkie dostępne percentyle',
        getPlayerPercentilesEventing: 'Ta metoda zapewnia wszystkie statystyki dla określonego procentu i pozycji'
      },
      responseCodes: 'Kody odpowiedzi',
      furtherInformation: 'Po więcej informacji zajrzyj do dokumentacji API',
      clipboard: 'Skopiowano do schowka!',
      limit50: 'Wyświetlane jest tylko pierwszych 50 wyników'
    }
  },
  globalSearch: {
    subtitle: 'Głębokie filtrowanie'
  },
  global: {
    teamElos: {
      title: 'ELO DRUŻYN',
      subtitle: 'Globalne rankingi i analizy drużyn',
      team: 'Drużyna',
      teams: 'Drużyny',
      dates: 'Daty',
      excludeInternational: 'Wyklucz drużyny międzynarodowe',
      elo: 'ELO',
      selectButton: 'Wybierz opcję Góra',
      selectTeamFromTable: 'Wybierz drużynę z tabeli, aby wyświetlić trend ELO.',
      showingTeamAveragesLastSeason: 'Wyświetlane są średnie drużynowe z ostatniego sezonu',
      showingTeamStatsLastSeason: 'Wyświetlane są tylko statystyki drużynowe z ostatniego aktywnego sezonu',
      searchToolTip: 'Wskazówka: naciśnij Ctrl + B, aby uzyskać bezpośredni dostęp do paska wyszukiwania',
      selectTopTooltip: 'Wyświetl dodatkowe zespoły na wykresie dla porównania',
      loadingPage: 'Przygotowanie danych...'
    },
    leagueElos: {
      title: 'ELO LIG',
      subtitle: 'Globalne rankingi i analizy lig',
      rankings: 'RANKINGI',
      insights: 'WSKAZÓWKI',
      filters: 'FILTRY',
      leagues: 'Ligi',
      from: 'Od',
      to: 'Do',
      elo: 'ELO',
      change: 'Zmiana',
      league: 'Liga',
      excludeContinental: 'Wyklucz rozgrywki międzynarodowe',
      eloTrend: 'Trend ELO',
      eloRanking: 'Ranking ELO',
      currentELOLabel: '(obecne ELO)',
      allTime: 'Cały czas',
      average: 'Średnia',
      noChartData: 'Brak danych na wykresie dla wybranych filtrów.',
      selectLeagueFromTable: 'Wybierz ligę z tabeli, aby wyświetlić trend ELO.',
      noInsightsData: 'Brak danych dla wybranych lig. Upewnij się, że ligi mają dostępne sezony i dane zespołów.',
      showingLeagueAveragesLastSeason: 'Wyświetlane są tylko średnie lig z ich ostatniego aktywnego sezonu',
      selectTopTooltip: 'Wyświetl dodatkowe ligi na wykresie dla porównania',
      confederations: {
        world: 'Świat',
        top5: 'TOP 5',
        uefa: 'UEFA',
        conmebol: 'CONMEBOL',
        concacaf: 'CONCACAF',
        caf: 'CAF',
        afc: 'AFC'
      },
      numberOfLeagues: 'Liczba lig',
      minimumElo: 'Minimalne ELO'
    },
    players: {
      title: 'GPI gracza',
      subtitle: 'Globalne rankingi i statystyki graczy',
      gpiRanking: 'Ranking GPI',
      rankTooltip: 'Najedź kursorem, aby wyświetlić ranking globalny',
      globalRanking: 'Globalny ranking',
      player: 'Odtwarzacz',
      players: 'Gracze',
      gpiTrend: 'Trend GPI',
      currentGPILabel: '(Current GPI)',
      nationality: 'Kraj urodzenia',
      position: 'Pozycja',
      marketValue: 'Wartość rynkowa',
      apply: 'Stosować',
      marketValueAndAgeTooltip: 'Wprowadź zakres i kliknij Zastosuj lub naciśnij Enter.',
      searchPlaceholder: 'Wyszukaj gracza...',
      selectTopTooltip: 'Wyświetl dodatkowych graczy na wykresie dla porównania',
      gpi: 'GPI',
      numberOfPlayers: 'Liczba graczy',
      showingPlayerStatsLastSeason: 'Wyświetlanie tylko średnich statystyk zawodników z ostatniego aktywnego sezonu',
      date: 'DATA',
      showChartLabels: 'Pokaż etykiety',
      marketValueTooltip: 'Wprowadź zakres i kliknij Zastosuj lub naciśnij Enter.',
      freeAgents: 'Wolni agenci',
      selectPlayerFromTable: 'Wybierz gracza z tabeli, aby wyświetlić trend GPI.'
    }
  },
  iso: {
    AF: 'Afghanistan',
    DZ: 'Algeria',
    AO: 'Angola',
    AR: 'Argentina',
    AU: 'Australia',
    AZ: 'Azerbaijan',
    BH: 'Bahrain',
    BB: 'Barbados',
    BE: 'Belgium',
    BJ: 'Benin',
    BO: 'Bolivia',
    BW: 'Botswana',
    BN: 'Brunei',
    BF: 'Burkina Faso',
    KH: 'Cambodia',
    CA: 'Canada',
    CF: 'Central African Rep.',
    CL: 'Chile',
    CO: 'Colombia',
    CD: 'Congo DR',
    CG: 'Congo',
    CI: 'Cote d\'Ivoire',
    CU: 'Cuba',
    CZ: 'Czech Republic',
    DJ: 'Djibouti',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    SV: 'El Salvador',
    ER: 'Eritrea',
    ET: 'Ethiopia',
    FI: 'Finland',
    PF: 'French Polynesia',
    GM: 'Gambia',
    DE: 'Germany',
    GI: 'Gibraltar',
    GL: 'Greenland',
    GP: 'Guadeloupe',
    GN: 'Guinea',
    GY: 'Guyana',
    HN: 'Honduras',
    HU: 'Hungary',
    IN: 'India',
    IR: 'Iran',
    IE: 'Ireland',
    IT: 'Italy',
    JP: 'JapÃ³n',
    KZ: 'Kazakhstan',
    KI: 'Kiribati',
    KR: 'Korea, South',
    KG: 'Kyrgyzstan',
    LV: 'Latvia',
    LS: 'Lesotho',
    LY: 'Libia',
    LT: 'Lithuania',
    MO: 'Macau SAR',
    MG: 'Madagascar',
    MY: 'Malaysia',
    ML: 'Mali',
    MH: 'Marshall Islands',
    MR: 'Mauritania',
    MX: 'Mexico',
    MD: 'Moldova',
    MN: 'Mongolia',
    MA: 'Morocco',
    MM: 'Myanmar',
    NR: 'Nauru',
    NL: 'Netherlands',
    NZ: 'New Zealand',
    NE: 'Niger',
    MP: 'Northern Mariana Islands',
    OM: 'Oman',
    PW: 'Palau',
    PA: 'Panama',
    PY: 'Paraguay',
    PH: 'Philippines',
    PT: 'Portugal',
    QA: 'Qatar',
    RO: 'Romania',
    RW: 'Rwanda',
    LC: 'Saint Lucia',
    SM: 'San Marino',
    SA: 'Saudi Arabia',
    RS: 'Serbia',
    SL: 'Sierra Leone',
    SK: 'Slovakia',
    SB: 'Solomon Islands',
    ZA: 'South Africa',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SZ: 'Swaziland',
    CH: 'Switzerland',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    TG: 'Togo',
    TT: 'Trinidad and Tobago',
    TR: 'Turkey',
    TV: 'Tuvalu',
    UA: 'Ukraine',
    GB: 'United Kingdom',
    UY: 'Uruguay',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VG: 'Virgin Islands, British',
    EH: 'Western Sahara',
    ZM: 'Zambia',
    AL: 'Albania',
    AD: 'Andorra',
    AG: 'Antigua and Barbuda',
    AM: 'Armenia',
    AT: 'Austria',
    BS: 'Bahamas',
    BD: 'Bangladesh',
    BY: 'Belarus',
    BZ: 'Belize',
    BT: 'Bhutan',
    BA: 'Bosnia and Herz.',
    BR: 'Brazil',
    BG: 'Bulgaria',
    BI: 'Burundi',
    CM: 'Cameroon',
    CV: 'Cape Verde',
    TD: 'Chad',
    CN: 'China',
    KM: 'Comoras',
    CR: 'Costa Rica',
    HR: 'Croatia',
    CY: 'Cyprus',
    DK: 'Denmark',
    DM: 'Dominica',
    TL: 'East Timor',
    EG: 'Egypt',
    GQ: 'Equatorial Guinea',
    EE: 'Estonia',
    FJ: 'Fiji',
    FR: 'France',
    GA: 'Gabon',
    GE: 'Georgia',
    GH: 'Ghana',
    GR: 'Greece',
    GD: 'Grenada',
    GT: 'Guatemala',
    GW: 'Guinea-Bissau',
    HT: 'Haiti',
    HK: 'Hong Kong SAR',
    IS: 'Iceland',
    ID: 'Indonesia',
    IQ: 'Iraq',
    IL: 'Israel',
    JM: 'Jamaica',
    JO: 'Jordan',
    KE: 'Kenya',
    KP: 'Korea, North',
    KW: 'Kuwait',
    LA: 'Laos',
    LB: 'Lebanon',
    LR: 'Liberia',
    LI: 'Liechtenstein',
    LU: 'Luxembourg',
    MK: 'Macedonia',
    MW: 'Malawi',
    MV: 'Maldives',
    MT: 'Malta',
    MQ: 'Martinica',
    MU: 'Mauritius',
    FM: 'Micronesia',
    MC: 'Monaco',
    ME: 'Montenegro',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NP: 'Nepal',
    NC: 'New Caledonia',
    NI: 'Nicaragua',
    NG: 'Nigeria',
    NO: 'Norway',
    PK: 'Pakistan',
    PS: 'Palestinian Territories',
    PG: 'Papua New Guinea',
    PE: 'Peru',
    PL: 'Poland',
    PR: 'Puerto Rico',
    RE: 'Reunion',
    RU: 'Russian Federation',
    KN: 'Saint Kitts and Nevis',
    WS: 'Samoa',
    ST: 'Sao Tome and Princ.',
    SN: 'Senegal',
    SC: 'Seychelles',
    SG: 'Singapore',
    SI: 'Slovenia',
    SO: 'Somalia',
    ES: 'Spain',
    VC: 'St Vincent and Gren.',
    SR: 'Suriname',
    SE: 'Sweden',
    SY: 'Syria',
    TJ: 'Tajikistan',
    TH: 'Thailandia',
    TO: 'Tonga',
    TN: 'Tunisia',
    TM: 'Turkmenistan',
    UG: 'Uganda',
    AE: 'United Arab Emirates',
    US: 'United States',
    UZ: 'Uzbekistan',
    VA: 'Vatican City',
    VN: 'Vietnam',
    VI: 'Virgin Islands, U.S.',
    YE: 'Yemen',
    ZW: 'Zimbabue',
    EU: 'Europe',
    INT: 'International',
    CW: 'CuraÃ§ao',
    AFC: 'AFC',
    CONCACAF: 'CONCACAF',
    'GB-ENG': 'England',
    'GB-WLS': 'Wales',
    'GB-SCT': 'Scotland',
    LATAM: 'South America',
    CAF: 'CAF',
    XK: 'Kosovo',
    AI: 'Anguilla',
    AN: 'Netherlands Antilles',
    AS: 'American Samoa',
    AW: 'Aruba',
    BM: 'Bermuda',
    BQ: 'Bonaire, SE and Saba',
    CK: 'The Cook Islands',
    FO: 'The Faroe Islands',
    GF: 'Guyane',
    GG: 'The Bailiwick of Guernsey',
    GU: 'The Territory of Guam',
    IM: 'The Isle of Man',
    JE: 'The Bailiwick of Jersey',
    KY: 'The Cayman Islands',
    MF: 'The Collectivity of Saint-Martin',
    MS: 'Montserrat',
    NU: 'Niue',
    OC: 'Oceania',
    RI: 'Indonesia',
    SS: 'The Republic of South Sudan',
    TC: 'The Turks and Caicos Islands',
    YT: 'The Department of Mayotte',
    SX: 'Sint Maarten'
  },
  loadingMessages: {
    players: 'Przygotowywanie zawodników',
    teams: 'Porządkowanie drużyn',
    games: 'Pobieranie meczów',
    stats: 'Obliczanie metryk',
    graphs: 'Rysowanie wykresów',
    gettingReady: 'Rozgrzewka',
    placeholder: 'Przygotuj się'
  },
  requestReport: {
    subtitle: 'Uzyskaj szczegółowy raport ze wszystkim, czego potrzebujesz',
    categories: {
      scouting: {
        title: 'Skauting',
        subtitle: 'Kto jest najlepszy w danej lidze? A łącząc kilka lig? Zamów raport szyty na miarę z dowolnymi filtrami (wiek, wzrost, koniec kontraktu itd.) i sprawdź, kto pasuje najlepiej'
      },
      coaches: {
        title: 'Trenerzy',
        subtitle: 'Jak trener wpasuje się w system Twojej drużyny? Otrzymaj szczegółowe informacje lub – dla danego profilu – poznaj trenerów, którzy pasują najlepiej'
      },
      'team analysis': {
        title: 'Zespół',
        subtitle: 'Wskaż drużynę i otrzymaj podsumowanie sezonu: styl, gra w ataku i obronie, słabe punkty, najlepsi zawodnicy itd.'
      },
      'game analysis': {
        title: 'Analiza meczu',
        subtitle: 'Dla wybranego meczu otrzymaj szczegółową analizę przedmeczową i pomeczową'
      },
      'special projects': {
        title: 'Projekty specjalne',
        subtitle: 'Jak zawodnik gra na wyjazdach? Jak zmienia się poziom między ligami? Kto jest dostępny na wypożyczenie? Zapytaj o wszystko, co przyjdzie Ci do głowy'
      },
      conversation: {
        title: 'Konsultacja',
        subtitle: 'Rozpocznij rozmowę z naszym zespołem'
      }
    },
    notesPlaceholder: 'Podaj ligę, profil, statystyki, trenera, zespół lub mecz, o które chcesz zapytać',
    chooseType: 'Wybierz typ raportu',
    requestSummary: 'Podsumowanie prośby',
    reportType: 'Typ raportu',
    reportLanguage: 'Język raportu',
    detailTitle: 'Śledzenie raportu',
    detailSubtitle: 'Wszystkie informacje o zamówionym raporcie'
  },
  bugReport: {
    modalSubtitle: 'Pomóż nam się ulepszać',
    about: 'Informacje',
    sendSuccess: 'Zgłoszenie wysłane. Sprawdź aktualizacje w Skrzynce',
    bugs: 'Błędy'
  },
  gbe: {
    autopass: 'Automatyczne zaliczenie',
    bandX: 'Kategoria {0}',
    bandXCont: 'Rozgrywki kontynentalne kategorii {0}',
    points: 'Punkty',
    titleWinner: 'Mistrz',
    qualifiedGroupsBandX: 'Awans do fazy grupowej rozgrywek kontynentalnych kat. {0}',
    qualifiedQualifiersBandX: 'Awans do kwalifikacji rozgrywek kontynentalnych kat. {0}',
    midTable: 'Środek tabeli',
    relegation: 'Spadek',
    promotion: 'Awans',
    final: 'Finał',
    semifinal: 'Półfinały',
    quarterfinal: 'Ćwierćfinały',
    round16: '1/8 finału',
    round32: '1/16 finału',
    groupstage: 'Faza grupowa',
    firstRound: '1. runda',
    secondRound: '2. runda',
    thirdRound: '3. runda',
    fourthRound: '4. runda',
    preliminaryRound: 'Runda wstępna',
    other: 'Inne',
    score: 'Wynik',
    totalSummary: 'Podsumowanie łączne',
    currentlyPlayingInUK: 'Zawodnik jest obywatelem Zjednoczonego Królestwa lub Irlandii albo stałym rezydentem w Zjednoczonym Królestwie',
    bandsAlert: 'Są minuty w więcej niż jednej kategorii – łączna wartość to maksimum',
    bandsAlertMax: 'Są minuty w więcej niż jednej kategorii – łączna wartość to maksimum',
    bandsAlertAvg: 'Są minuty w więcej niż jednej kategorii – łączna wartość to średnia',
    generate: 'Formularz GBE',
    debutYouthPlayer: 'Debiut zawodnika młodzieżowego',
    table1: {
      name: 'Występy międzynarodowe zawodnika',
      title1: 'Suma rankingów FIFA narodowej federacji zawodnika',
      title2: 'Występy międzynarodowe zawodnika'
    },
    table2: {
      name: 'Minuty ligowe zawodnika',
      title1: 'Minuty ligowe zawodnika'
    },
    table3: {
      name: 'Minuty w rozgrywkach kontynentalnych',
      title1: 'Minuty w rozgrywkach kontynentalnych'
    },
    table4: {
      name: 'Końcowa pozycja ligowa ostatniego klubu',
      title1: 'Końcowa pozycja ligowa ostatniego klubu'
    },
    table5: {
      name: 'Postęp kontynentalny ostatniego klubu',
      title1: 'Postęp w rozgrywkach kontynentalnych'
    },
    table6: {
      name: 'Jakość ligi obecnego klubu',
      title1: 'Kategoria obecnego klubu'
    },
    table7: {
      name: 'Młodzież – Debiut',
      title1: 'Kategoria'
    },
    table8: {
      name: 'Młodzież – Końcowa pozycja ligowa',
      title1: 'Końcowa pozycja ligowa ostatniego klubu'
    },
    table9: {
      name: 'Młodzież – Postęp kontynentalny',
      title1: 'Postęp kontynentalny'
    },
    table10: {
      name: 'Młodzież – Jakość ligi obecnego klubu',
      title1: 'Kategoria obecnego klubu'
    },
    table11: {
      name: 'Młodzież – Jakość ligi obecnego klubu',
      title1: 'Kategoria obecnego klubu'
    },
    table12: {
      name: 'Młodzież – Występy międzynarodowe',
      title1: 'Występy międzynarodowe zawodnika'
    }
  },
  mediaMode: {
    borderColor: 'Kolor obramowania',
    fillColor: 'Kolor wypełnienia',
    bgColor: 'Kolor tła',
    upperText: 'Tekst górny',
    lowerText: 'Tekst dolny',
    socialMedia: 'Media społecznościowe',
    textColor: 'Kolor tekstu',
    axisColor: 'Kolor osi',
    logo: 'Logo',
    comparisonBorderColor: 'Kolor obramowania (porównanie)',
    comparisonFillColor: 'Kolor wypełnienia (porównanie)',
    comparisonUpperText: 'Tekst górny (porównanie)',
    comparisonLowerText: 'Tekst dolny (porównanie)',
    homeFillColor: 'Kolor wypełnienia (dom)',
    homeBorderColor: 'Kolor obramowania (dom)',
    awayFillColor: 'Kolor wypełnienia (wyjazd)',
    awayBorderColor: 'Kolor obramowania (wyjazd)',
    face: 'Twarz',
    nationalTeam: 'Reprezentacja',
    comparisonFace: 'Twarz (porównanie)',
    upperTextX: 'Tekst górny {0}',
    lowerTextX: 'Tekst dolny {0}',
    borderColorX: 'Kolor obramowania {0}',
    fillColorX: 'Kolor wypełnienia {0}',
    homeFillColorX: 'Kolor wypełnienia (dom) {0}',
    homeBorderColorX: 'Kolor obramowania (dom) {0}',
    awayFillColorX: 'Kolor wypełnienia (wyjazd) {0}',
    awayBorderColorX: 'Kolor obramowania (wyjazd) {0}',
    faceX: 'Twarz {0}',
    selectField: 'Wybierz właściwość',
    orientationX: 'Orientacja {0}',
    searchBarPlaceholder: 'Szukaj zawodników i/lub meczów...',
    title: 'Pulpit medialny',
    pageSubtitle: 'Eksploruj i pobieraj mapy oraz grafiki',
    chooseChart: 'Wybierz wykres...',
    headerTextX: 'Tekst nagłówka {0}',
    avatarLineLength: 'Długość linii awatara',
    avatarLineWeight: 'Grubość linii awatara',
    avatarSize: 'Rozmiar awatara',
    chartX: 'Wykres {0}',
    chartHeaderFontSize: 'Rozmiar czcionki nagłówka wykresów',
    chartHeaderFontWeight: 'Grubość czcionki nagłówka wykresów',
    upperTextFontSize: 'Rozmiar czcionki tekstu górnego',
    upperTextFontWeight: 'Grubość czcionki tekstu górnego',
    lowerTextFontSize: 'Rozmiar czcionki tekstu dolnego',
    lowerTextFontWeight: 'Grubość czcionki tekstu dolnego',
    socialMediaFontSize: 'Rozmiar czcionki mediów społecznościowych',
    socialMediaFontWeight: 'Grubość czcionki mediów społecznościowych',
    subtitle: 'Podtytuł',
    subtitleFontSize: 'Rozmiar czcionki podtytułu',
    subtitleFontWeight: 'Grubość czcionki podtytułu',
    subtitleX: 'Podtytuł {0}',
    subtitleFontSizeX: 'Rozmiar czcionki podtytułu ${0}',
    subtitleFontWeightX: 'Grubość czcionki podtytułu ${0}',
    titleX: 'Tytuł {0}',
    titleFontSize: 'Rozmiar czcionki tytułu',
    titleFontWeight: 'Grubość czcionki tytułu',
    sponsor: 'Sponsor',
    fontFamily: 'Krój pisma'
  },
  documents: {
    types: {
      SCOUTING_REPORT: 'Raporty skautingowe',
      GAME_REPORT: 'Raporty meczowe',
      MEDICAL_REPORT: 'Raporty medyczne',
      PHYSICAL_REPORT: 'Raporty fizyczne',
      PSYCHOLOGICAL_REPORT: 'Raporty psychologiczne',
      OTHER: 'Inne',
      QUICK_NOTES: 'Szybkie notatki',
      PLAYER_REPORT: 'Raporty zawodników',
      GENERAL_COMMENTS: 'Uwagi ogólne',
      PLAYER_ANALYSIS: 'Analiza zawodnika'
    },
    uploadDocument: 'Prześlij dokument',
    notesPlaceholder: 'Wpisz opisowe notatki lub komentarze do dokumentu',
    notesPlaceholderAlt: 'Wpisz opisowe notatki lub komentarze o zawodniku',
    uploadedBy: 'Przesłano przez',
    updatedBy: 'Zaktualizowano przez',
    seeNotes: 'Zobacz notatki',
    addNote: 'Dodaj notatkę',
    rating: 'Ocena',
    position: 'Najlepsza pozycja',
    physical: 'Fizyczność',
    onBall: 'Z piłką',
    offBall: 'Bez piłki',
    mental: 'Mentalność',
    potential: 'Potencjał',
    conclusion: 'Wnioski',
    recommendation: {
      1: 'Pozyskać',
      2: 'Monitorować',
      3: 'Odrzucić',
      4: 'Interesujący',
      label: 'Rekomendacja'
    },
    match: 'Mecz',
    deleteQuickNote: 'Usuń notatkę',
    deleteQuickNoteMessage: 'Notatka zostanie trwale usunięta. Kontynuować?',
    noQuickNotes: 'Brak danych. Zacznij od dodania szybkich notatek!',
    deleteDocument: 'Usuń dokument',
    deleteDocumentMessage: 'Dokument zostanie trwale usunięty. Kontynuować?',
    noDocuments: 'Brak danych. Zacznij od dodania dokumentów!'
  },
  notifications: {
    newReportMessage: 'Nowa wiadomość w raporcie'
  },
  blog: {
    subtitle: 'Najnowsze artykuły, aktualizacje i wiadomości',
    newEntry: 'Nowy wpis',
    title: 'Tytuł',
    text: 'Tekst',
    link: 'Link',
    image: 'Obraz',
    author: 'Autor',
    date: 'Data publikacji',
    deleteEntry: 'Usuń wpis',
    deleteEntryMessage: 'Czy na pewno chcesz usunąć ten wpis?',
    readMore: 'Czytaj więcej'
  },
  positionsOrlegi: {
    GK: 'Bramkarz',
    DC: 'Obrońca',
    DR: 'Boczny obrońca',
    MC: 'Pomocnik',
    AMC: 'Ofensywny pomocnik',
    FW: 'Napastnik',
    FWR: 'Skrzydłowy'
  },
  library: {
    subtitle: 'Przeglądaj i udostępniaj przesłane dokumenty',
    mediaSubtitle: 'Przeglądaj i udostępniaj wyeksportowane wykresy',
    charts: 'Wykresy',
    goToLibrary: 'Przejdź do biblioteki'
  },
  scatterPlot: {
    bubbleSize: 'Rozmiar bąbla',
    byMinutes: 'Według minut',
    byAge: 'Według wieku',
    byMarketValue: 'Według wartości rynkowej'
  },
  eventChart: {
    successfulEvent: 'Udany',
    unsuccessfulEvent: 'Nieudany',
    possessionLost: 'Pomyślnie, nie udało się odzyskać',
    successfulPass: 'Udane podanie',
    unsuccessfulPass: 'Nieudane podanie',
    successfulCarry: 'Udane prowadzenie',
    unsuccessfulCarry: 'Nieudane prowadzenie',
    carryAndKeyPass: 'Prowadzenie & kluczowe podanie',
    carryAndAssist: 'Prowadzenie & asysta',
    carryAndShot: 'Prowadzenie & strzał',
    ballProgressionAndPass: 'Progresja & podanie',
    ballProgression: 'Progresja piłki',
    ballProgressionAndKeyPass: 'Progresja & kluczowe podanie',
    ballProgressionAndAssist: 'Progresja & asysta',
    ballProgressionAndShot: 'Progresja & strzał',
    ballProgressionAndGoal: 'Progresja & gol',
    pass: 'Podanie',
    carryAndPass: 'Prowadzenie & podanie',
    carryAndGoal: 'Prowadzenie & gol',
    totalTouches: 'Łącznie kontaktów',
    totalPasses: 'Łączne Podania',
    successful: 'Udane',
    unsuccessful: 'Nieudane',
    tacklePossessionLost: 'Sukces — utrata posiadania',
    gamesSelected: '{count} meczów wybranych',
    allGamesOfSeason: 'Wszystkie mecze sezonu',
    allGamesOfSeasons: 'Wszystkie mecze sezonów',
    allEvents: 'Wszystkie zdarzenia',
    eventTypesCount: '{count} typów zdarzeń',
    totalEvents: 'Całkowita liczba wydarzeń',
    zoneDominanceNote: 'Dotknięcia pokazane przez każdą drużynę w każdej strefie oznaczają tylko udane dotknięcia',
    selectedEvents: 'Wybrane wydarzenia'
  },
  event: {
    Pass: 'Podanie',
    TakeOn: 'Drybling',
    Takeon: 'Drybling',
    Foul: 'Faul',
    Error: 'Błąd',
    Tackle: 'Odbiór',
    Interception: 'Przechwyt',
    Clearance: 'Wybicie',
    MissedShot: 'Strzał niecelny',
    ShotOnPost: 'Strzał w obramowanie',
    SavedShot: 'Strzał obroniony',
    Goal: 'Gol',
    Aerial: 'Pojedynek powietrzny',
    BallRecovery: 'Odzysk',
    Dispossessed: 'Utrata',
    ChanceMissed: 'Zmarnowana okazja',
    BallTouch: 'Kontakt z piłką',
    BlockedPass: 'Zablokowane podanie',
    Challenge: 'Pojedynek',
    lossPossession: 'Utrata posiadania',
    OffsidePass: 'Podanie spalone',
    groundDuelsLost: 'Przegrane pojedynki naziemne',
    'Ball touch': 'Kontakt z piłką',
    Smother: 'Przytrzymanie',
    'Keeper pickup': 'Podjęcie piłki',
    'Good skill': 'Sztuczka',
    Punch: 'Pięściami',
    'Saved shot': 'Strzał obroniony',
    'Shot on post': 'Strzał w obramowanie',
    'Missed shot': 'Strzał niecelny',
    Save: 'Interwencja',
    'Take on': 'Drybling',
    'Offside pass': 'Podanie na spalony',
    Claim: 'Złapanie',
    'Blocked pass': 'Zablokowane podanie',
    KeeperPickup: 'Odbiór Strażnika',
    'Ball recovery': 'Odzysk',
    'Ball Recovery': 'Odzysk',
    'Chance missed': 'Zmarnowana okazja',
    'Loss possession': 'Utrata posiadania',
    Carries: 'Prowadzenia',
    BallProgression: 'Progresja piłki',
    MissedChance: 'Stracona szansa',
    Event: 'Wydarzenie',
    Shot: 'Strzał',
    Assist: 'Asysta',
    KeyPass: 'Kluczowe podanie',
    'Foul taken': 'Otrzymano faul'
  },
  leagueTab: {
    leagueTable: 'Tabela ligowa',
    matchdays: 'Kolejki',
    playerInsights: 'Wgląd zawodników',
    onlyLocalPlayers: 'Tylko lokalni gracze',
    teamInsights: 'Wgląd drużyn',
    head2head: 'Bezpośrednie mecze',
    addNewChart: 'Dodaj nowy wykres',
    rounds: {
      16: '1/8 finału',
      32: '1/16 finału',
      W: 'Zwycięzca',
      F: 'Finał',
      SF: 'Półfinały',
      QF: 'Ćwierćfinały',
      GR: 'Faza grupowa',
      '4R': '4. runda',
      '3R': '3. runda',
      '2R': '2. runda',
      '1R': '1. runda',
      PR: 'Runda wstępna',
      QPO1: 'Awans do 1/16 szczebel niżej',
      QPO2: 'Runda kwal. 1/8',
      QPO3: 'Runda kwalifikacyjna 32'
    },
    positions: 'Pozycje',
    prediction: 'Prognozy',
    predicted: 'Prognoza',
    groups: 'Grupy',
    ranking: 'Ranking',
    numberOfTeams: 'Liczba drużyn',
    statsWithMinimum: {
      message: 'Pokazywani tylko zawodnicy z więcej niż {0} {1} w wybranym sezonie',
      dribblesTotal90: 'dryblingów na 90 minut',
      crosses90: 'dośrodkowań na 90 minut',
      tacklesAttempted90: 'prób odbioru na 90 minut',
      aerialsTotal90: 'pojedynków powietrznych na 90 minut'
    },
    numberOfLeagues: 'Liczba lig',
    position: {
      titleWinner: 'Zdobywca tytułu',
      championsLeague: 'Liga Mistrzów',
      qualifierChampionsLeague: 'Kwalifikacje do Ligi Mistrzów',
      europeLeague: 'Liga Europy',
      qualifierEuropeLeague: 'Kwalifikacyjna Liga Europy',
      conferenceLeague: 'Liga Konferencyjna',
      qualifierConferenceLeague: 'Kwalifikacyjna Liga Konferencyjna',
      midTable: 'Środek stołu',
      relegation: 'Relegacja',
      promotion: 'Promocja',
      relegationPlayoff: 'Baraż o utrzymanie',
      promotionPlayoff: 'Baraż o awans',
      championshipGroup: 'Grupa mistrzowska',
      relegationGroup: 'Grupa spadkowa',
      championshipPlayoffs: 'Mistrzostwa w play-offach',
      preChampionshipPlayoffs2: 'Rozgrywki przed mistrzostwami 2',
      preChampionshipPlayoffs3: 'Rozgrywki przed mistrzostwami 3',
      playoffsQualifierBand3: 'Zespół kwalifikacyjny do play-offów 3',
      continentalGroup: 'Grupa Kontynentalna'
    },
    group: {
      1: 'A',
      2: 'B',
      3: 'C',
      4: 'D',
      5: 'mi',
      6: 'F',
      7: 'G',
      8: 'H',
      9: 'I',
      10: 'J',
      11: 'K',
      12: 'L'
    }
  },
  similarity: {
    subtitle: 'Znajdź podobnych zawodników',
    searchBarPlaceholder: 'Wyszukaj i wybierz zawodnika, aby znaleźć podobnych',
    radarFilters: 'Filtry radaru',
    similarityFilters: 'Filtry podobieństwa',
    playersFilters: 'Filtry zawodników',
    similarPlayers: 'Podobni zawodnicy',
    seasonWarning: 'Dostępne są tylko sezony w narzędziu Similarity, w których rozegrano ponad 450 minut'
  },
  squadBuilder: {
    subtitle: 'Zaprojektuj własne jedenastki',
    playerSelector: 'Wybór zawodnika',
    loadSquad: 'Wczytaj skład',
    yearsOld: 'l.',
    playersPerPosition: 'Zawodnicy na pozycję',
    custom: 'Własne',
    removeSquad: 'Usuń skład',
    removeSquadMessage: 'Na pewno usunąć skład?',
    deleteSquadSuccess: 'Skład pomyślnie usunięty',
    playerDetails: 'Widoczność szczegółów zawodnika',
    ageFormat: 'Format wieku',
    mainPlayer: 'Główny zawodnik',
    showDetails: 'Pokaż szczegóły',
    all: 'Wszyscy',
    squadPosition: 'Pozycja w składzie',
    noData: 'Brak danych. Zacznij od dodania zawodników na boisku!'
  },
  tours: {
    buttons: {
      dontShowAgain: 'Nie pokazuj ponownie',
      skipTour: 'Pomiń przewodnik',
      previous: 'Wstecz',
      next: 'Dalej',
      finish: 'Zakończ'
    },
    playerRadar: {
      step1: {
        title: 'KARTA ZAWODNIKA',
        message: 'Sprawdź podstawowe dane: wiek, wzrost, data kontraktu'
      },
      step2: {
        title: 'FILTR GBE',
        message: 'Sprawdza, czy zawodnik ma wystarczająco punktów GBE, by grać w UK'
      },
      step3: {
        title: 'DOSTĘPNOŚĆ',
        message: 'Procent dostępnych minut i minut rozegranych'
      },
      step4: {
        title: 'POZYCJE',
        message: 'W jakich pozycjach grał i ile minut na każdej'
      },
      step5: {
        title: 'FORMATY PREZENTACJI',
        message: 'Oceń formę w 4 wizualizacjach: radar, polarny, lizak i tekst – porównaj z pozycją'
      },
      step6: {
        title: 'RADAR FORMY',
        message: 'Wizualizacja wydajności. Panel interaktywny – najedź, aby poznać definicję metryki'
      },
      step7: {
        title: 'WYBÓR SEZONU',
        message: 'Wybierz lub dodaj sezony do oceny formy'
      },
      step8: {
        title: 'WŁASNE SZABLONY',
        message: 'Użyj własnych szablonów, by oceniać innymi metrykami niż standardowy radar'
      },
      step9: {
        title: 'POZYCJE ROZEGRANE',
        message: 'Zaznacz/odznacz pozycje, by mierzyć na wybranej pozycji'
      },
      step10: {
        title: 'WYBÓR MINIMUM I MAKSIMUM',
        message: 'Mierz względem maksimów/minimów sezonu, top5 lig lub własnego domyślnego sezonu'
      },
      step11: {
        title: 'PORÓWNANIA',
        message: 'Porównaj z poprzednią formą, innymi na pozycji i średnią pozycji'
      },
      step12: {
        title: 'FORMATY POBIERANIA',
        message: 'Dostępne trzy formaty: PNG, SVG i EMBED'
      }
    },
    playerRanking: {
      step1: {
        title: 'SEZON, KADRA I POZYCJA',
        message: 'Wybierz sezon, kadrę i pozycję do porównania'
      },
      step2: {
        title: 'PODSTAWOWE FILTRY',
        message: 'Filtruj po wieku, minutach i wzroście'
      },
      step3: {
        title: 'WYRÓŻNIANIE I WYKLUCZANIE',
        message: 'Wyróżnij wybranych zawodników i wyklucz zespoły z widoku'
      },
      step4: {
        title: 'FILTR WG KATEGORII',
        message: 'Filtruj statystyki wg kategorii: asocjacja, obrona, podania, prowadzenie itd.'
      },
      step5: {
        title: 'FORMATY POBIERANIA',
        message: 'Dostępne trzy formaty: PNG, SVG i EMBED'
      }
    },
    playerFinishing: {
      step1: {
        title: 'WYBÓR WIDOKU',
        message: 'Mapa wykończenia w widoku głównym, bramek oraz w tabeli dystrybucji'
      },
      step2: {
        title: 'WYBÓR SEZONÓW',
        message: 'Dodaj sezony, aby mierzyć skuteczność strzałów'
      },
      step3: {
        title: 'LOKALIZACJA STRZAŁU',
        message: 'Wybierz dokładne położenie (okręgi) lub strefy pola karnego/boiska (obszary)'
      },
      step4: {
        title: 'xG ON TARGET',
        message: 'Zaznacz xG to Goal i xG Completion, aby zobaczyć wartość dodaną po strzale'
      },
      step5: {
        title: 'RODZAJ STRZAŁU',
        message: 'Filtruj po typie strzału, strategii, strefie lub części ciała'
      },
      step6: {
        title: 'FILTR MINUT',
        message: 'Pasek minut do wyboru strzałów i goli w wybranych okresach meczu'
      },
      step7: {
        title: 'FORMATY POBIERANIA',
        message: 'Dostępne trzy formaty: PNG, SVG i EMBED'
      },
      step8: {
        title: 'MAPA STRZAŁÓW',
        message: 'Mapa jest interaktywna. Najedź, by sprawdzić xG strzału'
      }
    },
    playerKeyPass: {
      step1: {
        title: 'WYBÓR SEZONU',
        message: 'Dodaj sezony, aby mierzyć skuteczność podań kluczowych'
      },
      step2: {
        title: 'LOKALIZACJA KLUCZOWEGO PODANIA',
        message: 'Wybierz dokładne położenie (okrąg) lub strefy pola/boiska (obszary)'
      },
      step3: {
        title: 'WYKOŃCZENIE PO PODANIU',
        message: 'Filtruj po typie strzału, strategii, strefie lub części ciała po podaniu'
      },
      step4: {
        title: 'FILTR MINUT',
        message: 'Wybieraj strzały i gole według okresów meczu'
      },
      step5: {
        title: 'FORMATY POBIERANIA',
        message: 'Dostępne: PNG, SVG i EMBED'
      },
      step6: {
        title: 'MAPA KLUCZOWYCH PODAŃ',
        message: 'Mapa interaktywna. Najedź na okrąg, aby zobaczyć xA podania'
      }
    },
    playerThreat: {
      step1: {
        title: 'WYBÓR SEZONU',
        message: 'Dodaj sezony, aby mierzyć tworzone zagrożenie'
      },
      step2: {
        title: 'LOKALIZACJA ZAGROŻENIA',
        message: 'Wybierz dokładne położenie (okrąg) lub strefy boiska (obszary)'
      },
      step3: {
        title: 'AKCJA I ZAKOŃCZENIE',
        message: 'Zaznacz/odznacz typy akcji i zakończeń do wyświetlenia'
      },
      step4: {
        title: 'MINUTY I ZAGROŻENIE',
        message: 'Filtruj po okresie, minutach i wartości zagrożenia'
      },
      step5: {
        title: 'FORMATY POBIERANIA',
        message: 'Dostępne: PNG, SVG i EMBED'
      },
      step6: {
        title: 'MAPA ZAGROŻENIA',
        message: 'Mapa interaktywna. Najedź, by zobaczyć zagrożenie (xT) dla akcji/podań'
      }
    },
    playerTouches: {
      step1: {
        title: 'WYBÓR MECZU I ZDARZEŃ',
        message: 'Wybierz mecz i zdarzenia do wyświetlenia na mapie'
      },
      step2: {
        title: 'TYP ZDARZENIA',
        message: 'Zaznacz/odznacz zdarzenia ofensywne i defensywne'
      },
      step3: {
        title: 'FILTR WIDOKU',
        message: 'Filtr mapy: podstawowe akcje, mapa cieplna, okręgi lub pola'
      },
      step4: {
        title: 'FORMATY POBIERANIA',
        message: 'Dostępne: PNG, SVG i EMBED'
      },
      step5: {
        title: 'MAPA KONTAKTÓW',
        message: 'Mapa interaktywna. Kliknij zdarzenie, by je wyświetlić'
      }
    },
    playerAllGames: {
      step1: {
        title: 'AVAILABILITY',
        message: 'Check availability and minutes played on a game by game basis'
      },
      step2: {
        title: 'POSITIONS',
        message: 'Consult the positions in which he has played in each game'
      }
    },
    playerInjuries: {
      step1: {
        title: 'HISTORY AND DAYS LOST',
        message: 'Consult injuries of the last year or the whole history and range of injuries according to their duration in days'
      },
      step2: {
        title: 'INJURIES BY CLUB',
        message: 'Consult the injuries separated by season and/or club of his trajectory'
      }
    },
    playerInfo: {
      step1: {
        title: 'CAREER AND TRANSFERS',
        message: 'Możesz sprawdzać minuty, pozycję i historię dostępności w klubie i kadrze oraz transfery w całej karierze'
      }
    },
    teamOverview: {
      step1: {
        title: 'TEAM SHEET',
        message: 'Consult basic data of the team: average age, base formation, ELO or balance of transfers'
      },
      step2: {
        title: 'BASIC STATISTICS',
        message: 'Consult possession, xG, Shots, PPDA or Verticality'
      },
      step3: {
        title: 'RADAR AND SEASON',
        message: 'Wybierz radar, sezon oraz mecze dom/wyjazd do oceny wydajności zespołu'
      },
      step4: {
        title: 'FILTER BY COACH AND MATCHES',
        message: 'Wybierz wydajność według etapów dla każdego trenera'
      },
      step5: {
        title: 'PERFOMANCE RADAR',
        message: 'Panel jest interaktywny – najedź na metrykę, aby zobaczyć definicję'
      },
      step6: {
        title: 'IMAGE DOWNLOAD FORMATS',
        message: 'Two download formats are available: png and svg'
      },
      step7: {
        title: 'CALENDAR',
        message: 'View the team\'s match schedule'
      },
      step8: {
        title: 'BEST PLAYERS BY METRICS',
        message: 'W tym panelu wybierzesz metryki i zobaczysz, którzy zawodnicy są kluczowi'
      },
      step9: {
        title: 'NASTĘPNY MECZ I URAZY',
        message: 'Sprawdź kolejnego rywala oraz kontuzjowanych i zawieszonych zawodników'
      },
      step10: {
        title: 'GRAPHS AND TRENDS',
        message: 'View different graphs for the last 10 or 20 games'
      }
    },
    teamRoster: {
      step1: {
        title: 'VIEW TYPE',
        message: 'View the squad from 6 different categories: by position, end of contract, age, availability, age profile and pitch'
      }
    },
    teamLoans: {
      step1: {
        title: 'LOAN PLAYERS',
        message: 'Consult the players loaned to other teams and what position they play in'
      }
    },
    teamBeeswarm: {
      step1: {
        title: 'SEASON AND SQUAD',
        message: 'Filter by season, radar squad and compare with leagues of your choice'
      },
      step2: {
        title: 'PERFORMANCE BY METRICS',
        message: 'See where the team is in each metric compared to all the teams in the leagues previously selected'
      },
      step3: {
        title: 'IMAGE DOWNLOAD FORMATS',
        message: 'Three download formats are available: png, svg and embed'
      }
    },
    teamFinishingMap: {
      step1: {
        title: 'SEASON SELECTION',
        message: 'Add seasons to measure shooting efficiency'
      },
      step2: {
        title: 'OWN OR OPPONENT\'S FINISHING',
        message: 'Choose whether you want to see the team\'s or all its opponents\' completion map'
      },
      step3: {
        title: 'SHOT PLACEMENT',
        message: 'Wybierz widok strzałów: okręgi lub strefy (pola)'
      },
      step4: {
        title: 'SHOT TYPE',
        message: 'Filter by type of shot, strategy, area or body part'
      },
      step5: {
        title: 'FILTER MINUTES',
        message: 'Pasek minut do wyboru strzałów i goli w określonych okresach meczu'
      },
      step6: {
        title: 'IMAGE DOWNLOAD FORMATS',
        message: 'Three download formats are available: png, svg and embed'
      },
      step7: {
        title: 'SHOTS MAP',
        message: 'The map is interactive. Check each circle with the mouse to find out xG of each shot'
      }
    },
    teamKeyPassMap: {
      step1: {
        title: 'SEASON SELECTION',
        message: 'Add seasons to measure shooting efficiency'
      },
      step2: {
        title: 'OWN OR RIVAL KEY PASSES',
        message: 'Choose if you want to see a map of key passes of the team or all its rivals'
      },
      step3: {
        title: 'KEY PASS LOCATION',
        message: 'Wybierz dokładne położenie podania (okrąg) lub strefy pola/boiska (pola)'
      },
      step4: {
        title: 'TYPE OF FINISH AFTER PASS',
        message: 'Filter by type of shot, strategy, area or body part made after key pass'
      },
      step5: {
        title: 'FILTER MINUTES',
        message: 'Pasek minut do wyboru strzałów i goli w określonych okresach meczu'
      },
      step6: {
        title: 'IMAGE DOWNLOAD FORMATS',
        message: 'Three download formats are available: png, svg and embed'
      },
      step7: {
        title: 'SHOTS MAP',
        message: 'The map is interactive. Consult each circle with the mouse to know the xA of each pass'
      }
    },
    teamLatestGames: {
      step1: {
        title: 'OSTATNIE MECZE',
        message: 'Consult results, possession, xG and win % of all the team\'s matches'
      }
    },
    teamTransfers: {
      step1: {
        title: 'ARRIVALS',
        message: 'Consult all arrivals (purchases + transfers) per calendar year'
      },
      step2: {
        title: 'DEPARTURES',
        message: 'Consult all departures (sales + transfers) by calendar year'
      }
    },
    teamAnalysis: {
      step1: {
        title: 'TRENDS',
        message: 'Query team form through streaks, wins, clean sheets, comebacks, periods with goals or types of goals'
      },
      step2: {
        title: 'SET PIECE',
        message: 'Compare Performance of the Team beetween Set Pieces Plays and Open Plays and get a detailed overview of Set Pieces'
      },
      step3: {
        title: 'SUBSTITUTIONS',
        message: 'See when the team makes substitutions and which players are substituted the most'
      },
      step4: {
        title: 'CONNECTIONS',
        message: 'Consult the most common connections between players. Filter by season and type of play'
      },
      step5: {
        title: 'ATTACK ZONES',
        message: 'Discover attacking zones of the team and filter by season or type of attack'
      },
      step6: {
        title: 'FORMATIONS',
        message: 'Check the most used formations and their % of wins, draws and defeats with each of them'
      },
      step7: {
        title: 'SHOT ZONES',
        message: 'Filter by season, team or opponent, way of visualizing the map, shot types or minutes'
      },
      step8: {
        title: 'CROSSES',
        message: 'Query and filter by season, type of display, successful or unsuccessful, from where they start and finish or including corner kicks'
      },
      step9: {
        title: 'PLAYERS',
        message: 'Filter by season, type of display, successful or unsuccessful, from where they start and finish or including corner kicks'
      }
    },
    teamOnOff: {
      step1: {
        title: 'SEASONS AND MATCHES',
        message: 'Filter by season, matches or by home or away games'
      },
      step2: {
        title: 'PLAYERS',
        message: 'View the performance of all players in the squad through countless metrics'
      }
    }
  },
  alerts: {
    numPlayers: 'Liczba zawodników',
    newPlayersLastWeek: 'Nowi zawodnicy w ostatnim tygodniu',
    subtitle: 'Alerty, gdy nowi zawodnicy spełnią Twoje kryteria',
    generalSubtitle: 'Otrzymuj alerty o nowych zawodnikach wg kryteriów i wieści o ulubionych',
    subtitlePlayer: 'Alerty o wieściach dot. ulubionych zawodników',
    subtitleSearch: 'Alerty, gdy nowi zawodnicy spełnią kryteria',
    favorite: 'Ulubiony',
    newEventCalendar: 'Nowe wydarzenie',
    updatedEventCalendar: 'Zaktualizowane wydarzenie',
    newShareFrom: 'Nowe udostępnienie od',
    injuryAlert: 'Alert: kontuzja',
    contractAlert: 'Alert: kontrakt',
    teamAlert: 'Alert: transfer',
    marketValueAlert: 'Alert: wartość rynkowa',
    gameAlert: 'Alert: rozegrany mecz'
  },
  videoEvents: {
    highlights: 'Skróty',
    fullGame: 'Pełny mecz',
    autoplay: 'Autoodtwarzanie',
    searchBarPlaceholder: 'Szukaj zawodnika, meczu lub drużyny...',
    subtitle: 'Analizuj zdarzenia przez wideo',
    successful: 'Udane',
    unsuccessful: 'Nieudane',
    playing: 'Odtwarzanie',
    games: 'Mecze',
    moreFilters: 'Więcej filtrów...',
    startArea: 'Strefa startu',
    endArea: 'Strefa końca',
    select: 'Wybierz',
    selectLastXGames: 'Wybierz ostatnie {0} mecze',
    advancedFilters: 'Filtry zaawansowane',
    freeKicks: 'Rzuty wolne',
    cornerKicks: 'Rzuty rożne',
    allShots: 'Wszystkie strzały',
    generateZip: 'Pobierz wideo',
    zippedModalMessage: 'Tworzymy listę wideo i wkrótce wyślemy ją na e‑mail',
    clickToSeeVideo: 'Kliknij, aby zobaczyć wideo'
  },
  videoUpload: {
    subtitle: 'Prześlij wideo i utwórz nowy mecz',
    uploadVideo: 'Prześlij wideo',
    selectPeriod: 'Wybierz okres',
    gameData: 'Dane meczu',
    venue: 'Miejsce',
    matchType: 'Typ meczu',
    matchGroup: 'Grupa meczu',
    roundType: 'Typ rundy',
    roundNumber: 'Numer rundy',
    offsetFh: 'Offset I połowy',
    offsetSh: 'Offset II połowy',
    offsetFhOT: 'Offset dogr. I połowy',
    offsetShOT: 'Offset dogr. II połowy',
    homeLineup: 'Skład gospodarzy',
    awayLineup: 'Skład gości',
    existingPlayer: 'Istniejący zawodnik',
    newPlayer: 'Nowy zawodnik',
    startingTeam: 'Wyjściowy',
    saveAndUpload: 'Zapisz i prześlij',
    existingGame: 'Mecz już istnieje',
    sendToKora: 'Wyślij',
    invalidForm: 'Nieprawidłowy formularz',
    warningModalTitle: 'Wykryto nieprawidłowości',
    noScoreSheetWarning: 'Brak protokołu meczowego',
    onlyOnePartUploadedWarning: 'Załączono tylko jedną połowę',
    continueQuestion: 'kontynuować?',
    slaLimit: 'Przesłałeś {0} meczów z {1}. Limit to {2}',
    requestedGames: 'Zgłoszone mecze',
    limitClose: 'Pozostało tylko {0} meczów do zgłoszenia',
    limitReached: 'Osiągnięto limit przesyłania wideo. Dodatkowe mogą wiązać się z opłatami.',
    seasonFinishedWarning: 'To utworzy mecz w zakończonym sezonie. Sprawdź poprawność.',
    teamCountryWarning: 'Zespół z innego kraju niż wybrana liga. Sprawdź poprawność.',
    uploading: 'Przesyłanie',
    doNotNavigateAway: 'Nie zamykaj tej karty, odświeżaj stronę ani nie opuszczaj strony w trakcie przesyłania.',
    severalMinutes: 'Ten proces może zająć kilka minut.'
  },
  videoPlaylists: {
    subtitle: 'Zbiory filtrów skrótów wideo',
    savePlaylist: 'Zapisz playlistę',
    seeAllPlaylists: 'Zobacz wszystkie playlisty'
  },
  videoHighlights: {
    recap: 'Skrót',
    homeCondensed: 'Skrót domowy',
    awayCondensed: 'Skrót wyjazdowy',
    selectedActions: 'Wybrane akcje',
    noActions: 'Brak akcji spełniających kryteria filtrów',
    noGames: 'Nie przesłano jeszcze meczów',
    attackingActions: 'Akcje ofensywne',
    defensiveActions: 'Akcje defensywne',
    groundDuels: 'Pojedynki na ziemi',
    penaltiesProvoked: 'Wywalczone rzuty karne',
    goalkeeperActions: 'Akcje bramkarza',
    addSomeGames: 'Zacznij od dodania meczów!',
    goToVideoUploadTool: 'Przejdź do narzędzia przesyłania wideo',
    ballInPlay: 'Gra w toku',
    filterSeasons: 'Filtruj sezony',
    streaming: 'Stream',
    clips: 'Klipy',
    qualifiers: {
      Pass: 'Podanie',
      Save: 'Interwencja',
      'Saved Shot': 'Strzał obroniony',
      Shot: 'Strzał',
      Goal: 'Gol',
      'Missed Shot': 'Strzał niecelny',
      'Shot on Post': 'Strzał w obramowanie',
      Error: 'Błąd',
      Clearance: 'Wybicie',
      Aerial: 'Pojedynek powietrzny',
      Challenge: 'Pojedynek na ziemi – przegrany',
      Dispossessed: 'Utrata',
      Foul: 'Faul',
      Card: 'Kartka',
      'Offside Pass': 'Podanie na spalony',
      Claim: 'Przejęte dośrodkowanie',
      'Keeper Pickup': 'Podjęcie piłki',
      'Ball Touch': 'Kontakt z piłką',
      Dribble: 'Drybling',
      Interception: 'Przechwyt',
      Tackle: 'Odbiór',
      'Ball Recovery': 'Odzysk',
      Takeon: 'Drybling'
    },
    qualifierIds: {
      1: 'Długa piłka',
      2: 'Dośrodkowanie',
      5: 'Rzut wolny wykonany',
      6: 'Rzut rożny wykonany',
      9: 'Rzut karny',
      15: 'Głową',
      20: 'Prawa noga',
      21: 'Inna część ciała',
      22: 'Gra z akcji',
      23: 'Kontra',
      24: 'Stały fragment',
      25: 'Po rożnym',
      26: 'Rzut wolny',
      28: 'Samobój',
      29: 'Z asystą',
      31: 'Żółta kartka',
      32: 'Druga żółta',
      33: 'Czerwona kartka',
      72: 'Lewa noga',
      73: 'Lewa',
      82: 'Strzał obroniony (bez GK)',
      94: 'Blok obronny',
      123: 'Wyrzut bramkarza',
      124: 'Wznowienie od bramki',
      160: 'Aut – SFG',
      170: 'Akcja bramkowa',
      173: 'Sparowane bezpiecznie',
      174: 'Sparowane niebezpiecznie',
      177: 'Złapane',
      178: 'Na stojąco',
      179: 'W locie',
      182: 'Ręce',
      183: 'Stopy',
      185: 'Zablokowane dośrodkowanie',
      210: 'Asysta',
      215: 'Akcja indywidualna',
      279: 'Rozpoczęcie gry',
      285: 'Defensywa',
      286: 'Ofensywa'
    },
    areas: {
      goalArea: 'Pole bramkowe',
      boxLeft: 'Pole karne – lewa',
      boxCenter: 'Pole karne – środek',
      boxRight: 'Pole karne – prawa',
      outBoxDeepLeft: 'Poza polem – głęboko lewa',
      outBoxDeepRight: 'Poza polem – głęboko prawa',
      outBoxLeft: 'Poza polem – lewa',
      outBoxCentreLeft: 'Poza polem – środek-lewa',
      outBoxCentre: 'Poza polem – środek',
      outBoxCentreRight: 'Poza polem – środek-prawa',
      outBoxRight: 'Poza polem – prawa',
      midfieldLeft35: 'Środek pola – lewa',
      midfieldCentreLeft35: 'Środek pola – śr.-lewa',
      midfieldCentre35: 'Środek pola – środek',
      midfieldCentreRight35: 'Środek pola – śr.-prawa',
      midfieldRight35: 'Środek pola – prawa',
      ownGoalArea: 'Własne pole bramkowe',
      ownBoxLeft: 'Własne pole karne – lewa',
      ownBoxCenter: 'Własne pole karne – środek',
      ownBoxRight: 'Własne pole karne – prawa',
      ownFieldOutOfBoxDeepLeft: 'Własna połowa – głęboko lewa',
      ownFieldOutOfBoxDeepRight: 'Własna połowa – głęboko prawa',
      ownFieldOutOfBoxLeft: 'Własna połowa – lewa',
      ownFieldOutOfBoxCentreLeft: 'Własna połowa – śr.-lewa',
      ownFieldOutOfBoxCentre: 'Własna połowa – środek',
      ownFieldOutOfBoxCentreRight: 'Własna połowa – śr.-prawa',
      ownFieldOutOfBoxRight: 'Własna połowa – prawa',
      '6 YARD BOX': 'Goal area',
      'BOX RIGHT': 'Box right',
      'BOX CENTER': 'Box center',
      'BOX LEFT': 'Box left',
      'OUT BOX DEEP RIGHT': 'Out box deep right',
      'OUT BOX DEEP LEFT': 'Out box deep left',
      'OUT BOX RIGHT': 'Out box right',
      'OUT BOX LEFT': 'Out box left',
      'FINAL THIRD RIGHT': 'Final third right',
      'FINAL THIRD LEFT': 'Final third left',
      'FULL BOX': 'Full box',
      'OUT BOX DEEP RIGHT LARGE': 'Out box deep right large',
      'OUT BOX DEEP LEFT LARGE': 'Out box deep left large',
      'FINAL THIRD RIGHT LARGE': 'Final third right large',
      'FINAL THIRD LEFT LARGE': 'Final third left large',
      'OUT BOX CENTER RIGHT': 'Out box center right',
      'OUT BOX CENTER': 'Out box center',
      'OUT BOX CENTER LEFT': 'Out box center left',
      'FINAL THIRD CENTER RIGHT': 'Final third center right',
      'FINAL THIRD CENTER': 'Final third center',
      'FINAL THIRD CENTER LEFT': 'Final third center left',
      'OUT BOX CENTER RIGHT SMALL': 'Out box center right small',
      'OUT BOX CENTER SMALL': 'Out box center small',
      'OUT BOX CENTER LEFT SMALL': 'Out box center left small',
      'FINAL THIRD CENTER RIGHT LARGE': 'Final third center right large',
      'FINAL THIRD CENTER LARGE': 'Final third center large',
      'FINAL THIRD CENTER LEFT LARGE': 'Final third center left large',
      'OWN 6 YARD BOX': 'Own Goal area',
      'OWN BOX RIGHT': 'Own Box right',
      'OWN BOX CENTER': 'Own Box center',
      'OWN BOX LEFT': 'Own Box left',
      'OWN OUT BOX DEEP RIGHT': 'Own Out box deep right',
      'OWN OUT BOX DEEP LEFT': 'Own Out box deep left',
      'OWN OUT BOX RIGHT': 'Own Out box right',
      'OWN OUT BOX LEFT': 'Own Out box left',
      'OWN FINAL THIRD RIGHT': 'Own Final third right',
      'OWN FINAL THIRD LEFT': 'Own Final third left',
      'OWN FULL BOX': 'Own Full box',
      'OWN OUT BOX DEEP RIGHT LARGE': 'Own Out box deep right large',
      'OWN OUT BOX DEEP LEFT LARGE': 'Own Out box deep left large',
      'OWN FINAL THIRD RIGHT LARGE': 'Own Final third right large',
      'OWN FINAL THIRD LEFT LARGE': 'Own Final third left large',
      'OWN OUT BOX CENTER RIGHT': 'Own Out box center right',
      'OWN OUT BOX CENTER': 'Own Out box center',
      'OWN OUT BOX CENTER LEFT': 'Own Out box center left',
      'OWN FINAL THIRD CENTER RIGHT': 'Own Final third center right',
      'OWN FINAL THIRD CENTER': 'Own Final third center',
      'OWN FINAL THIRD CENTER LEFT': 'Own Final third center left',
      'OWN OUT BOX CENTER RIGHT SMALL': 'Own Out box center right small',
      'OWN OUT BOX CENTER SMALL': 'Own Out box center small',
      'OWN OUT BOX CENTER LEFT SMALL': 'Own Out box center left small',
      'OWN FINAL THIRD CENTER RIGHT LARGE': 'Own Final third center right large',
      'OWN FINAL THIRD CENTER LARGE': 'Own Final third center large',
      'OWN FINAL THIRD CENTER LEFT LARGE': 'Own Final third center left large'
    },
    outcomes: {
      success: 'Sukces',
      fail: 'Niepowodzenie',
      possessionWon: 'Odzyskane posiadanie',
      possessionNotWon: 'Bez odzyskania',
      received: 'Odebrane',
      provoked: 'Wymuszone'
    },
    homePlayerHighlights: 'Najważniejsze informacje o zawodnikach gospodarzy',
    awayPlayerHighlights: 'Najważniejsze informacje o zawodnikach gości'
  },
  share: {
    shareTo: 'Wyślij do',
    viaApp: 'Aplikacja (wiadomość Driblab)',
    viaEmail: 'E‑mail',
    description: 'Opis',
    titleTab: 'Udostępnienia',
    toMe: 'Otrzymane',
    fromMe: 'Wysłane',
    typeInternal: 'Wewnętrzne',
    typeExternal: 'Zewnętrzne',
    title: 'Udostępnione',
    subtitle: 'Przegląd elementów na liście udostępnień i Twoich udostępnień',
    selectUser: 'Wybierz użytkownika',
    expired: 'Wygasło',
    limitReached: 'Przekroczono limit użyć linku'
  },
  homeStats: {
    data: 'Dostępne dane',
    players: 'zawodników',
    totalPlayers: 'łącznie zawodników',
    teams: 'zespołów',
    totalTeams: 'łącznie zespołów',
    leagues: 'lig',
    totalLeagues: 'łącznie lig',
    seasons: 'sezonów',
    totalSeasons: 'łącznie sezonów',
    games: 'meczów',
    totalGames: 'łącznie meczów'
  },
  scoutingCalendar: {
    subtitle: 'Twórz i organizuj zadania skautingowe',
    myCalendars: 'Kalendarz prywatny',
    publicCalendars: 'Kalendarze publiczne',
    otherCalendars: 'Inne kalendarze',
    calendarSettings: 'Ustawienia kalendarza',
    moreInfo: 'Więcej informacji',
    individualScouting: 'Skauting indywidualny',
    matchScouting: 'Skauting meczowy',
    calendarView: {
      type: 'Typ kalendarza',
      month: 'Miesiąc',
      week: 'Tydzień',
      day: 'Dzień'
    },
    weekView: {
      type: 'Typ tygodnia',
      monSun: 'Poniedziałek - Niedziela',
      sunSat: 'Niedziela - Sobota',
      monFri: 'Poniedziałek - Piątek'
    },
    tasks: {
      addNew: 'Dodaj zadanie',
      myTasks: 'Moje zadania',
      filterTasks: 'Filtruj zadania',
      sharedWithMe: 'Udostępnione mnie',
      createTask: 'Utwórz zadanie',
      newTask: 'Nowe zadanie',
      taskName: 'Nazwa zadania',
      allDay: 'Cały dzień',
      startDate: 'Data rozpoczęcia',
      endDate: 'Data zakończenia',
      startHour: 'Godzina rozpoczęcia',
      endHour: 'Godzina zakończenia',
      assignedTo: 'Przypisany',
      assignedToMe: 'Przypisane do mnie',
      color: 'Kolor',
      scoutingType: 'Typ skautingu',
      taskLocation: 'Lokalizacja zadania',
      selectLeague: 'Wybierz ligę',
      selectMatch: 'Wybierz mecz',
      useMatchdate: 'Użyj daty meczu',
      stadium: 'Stadion',
      travel: 'Podróż',
      hotel: 'Hotel',
      tickets: 'Bilety',
      taskNotes: 'Wpisz notatki/komentarze dot. zadania',
      states: {
        toDo: 'Do zrobienia',
        inProgress: 'W trakcie',
        done: 'Zrobione'
      },
      type: {
        player: 'Ocena zawodnika',
        team: 'Ocena zespołu',
        other: 'Inne'
      },
      location: {
        stadium: 'Na stadionie',
        video: 'Wideo'
      },
      accommodation: {
        accommodationDetails: 'Szczegóły noclegu',
        ownArrangement: 'We własnym zakresie',
        required: 'Wymagane',
        notRequired: 'Niewymagane',
        booked: 'Zarezerwowane'
      },
      assignToMe: 'Przypisz do mnie',
      addOther: 'Dodaj inne',
      deleteTask: 'Usuń zadanie',
      deleteTaskMessage: 'Zadanie zostanie usunięte. Kontynuować?',
      cancelUpdate: 'Anuluj zmiany',
      cancelUpdateMessage: 'Zmiany nie zostaną zapisane. Kontynuować?',
      selectGame: 'Wybierz mecz, aby dodać pliki',
      noData: 'Brak danych. Zacznij od dodania zadań!',
      widgetSubtitle: 'Sprawdź swoje nadchodzące zadania',
      scoutingDetails: 'Szczegóły skautingu',
      taskDetails: 'Szczegóły zadania',
      playerDocuments: 'Dokumenty zawodnika',
      teamDocuments: 'Dokumenty drużyny',
      gameDocuments: 'Dokumenty meczu',
      taskDocuments: 'Dokumenty zadania',
      task: 'Zadanie'
    },
    nextGames: 'Następne mecze'
  },
  scoutingTasksBoard: {
    period: {
      week: 'Ten tydzień',
      month: 'Ten miesiąc',
      year: 'Ten rok'
    },
    noTasks: 'Utwórz nowe zadania lub przenieś tutaj!',
    goToBoard: 'Przejdź do tablicy'
  },
  profile: {
    title: 'Profil',
    subtitle: 'Dostosuj konto i szczegóły subskrypcji'
  },
  hub: {
    onlyHub: 'Dostępne tylko w Driblab Hub',
    blue: 'niebieski',
    purple: 'fioletowy',
    orange: 'pomarańczowy',
    grey: 'szary',
    indigo: 'indygo',
    teal: 'cyraneczka',
    lightBlue: 'jasnoniebieski',
    brown: 'brązowy'
  },
  uploadedGames: {
    subtitle: 'Wszystkie przesłane mecze',
    timeRequested: 'Czas zgłoszenia',
    timeReceived: 'Czas odebrania',
    diffHours: 'Różnica (godz.)',
    collectionCompleted: 'Zbieranie zakończone',
    dateFrom: 'Data od',
    dateTo: 'Data do',
    goToUploadedGames: 'Przejdź do przesłanych meczów',
    sla: 'SLA',
    matchDate: 'Data meczu',
    rejectedGame: 'Odrzucono',
    reviewed: 'Recenzję',
    requested: 'Wymagany',
    koraStatus: 'Stan Kory',
    aws: 'AWS-a',
    fullVideo: 'Pełne wideo',
    offset: 'Zrównoważyć',
    updateFullVideo: 'Zaktualizować pełny film?'
  },
  gameMap: {
    title: 'Mapa meczów',
    subtitle: 'Odkrywaj mecze na kolejne dni',
    warning: 'Czas i miejsce mogą być niepoprawne. Proszę potwierdzić informacje.',
    taskAdded: 'Zadanie utworzone. Sprawdź Kalendarz skautingu.'
  },
  leagueRequestAccess: {
    sendSuccess: 'Powiadomiono pomyślnie',
    notPermissions: 'Brak uprawnień do wyświetlenia',
    notPermissionsLeague: 'Brak uprawnień do tej ligi',
    notPermissionsGame: 'Brak uprawnień do tego meczu',
    requestAccessTo: 'Poproś o dostęp do',
    sendRequest: 'Wyślij prośbę'
  },
  videoTeams: {
    subtitle: 'Znajdź najnowsze mecze otagowane drużyną',
    noGamesUploaded: 'Nie przesłano jeszcze meczów'
  },
  scoutingAnalysis: {
    scoutingAnalysis: 'Analiza skautingowa',
    scoutingAnalyses: 'Analizy skautingowe',
    playerScoutingAnalyses: 'Analizy skaut. zawodników',
    gameScoutingAnalyses: 'Analizy skaut. meczów',
    analyses: 'Analizy',
    addReport: 'Dodaj analizę',
    technical: 'Techniczne',
    tactical: 'Taktyczne',
    physical: 'Fizyczne',
    mental: 'Mentalne',
    technicalNotes: 'Uwagi techniczne',
    tacticalNotes: 'Uwagi taktyczne',
    physicalNotes: 'Uwagi fizyczne',
    mentalNotes: 'Uwagi mentalne',
    conclusion: 'Wnioski',
    charactersMax: 'Maks. 1000 znaków',
    globalRating: 'Ocena ogólna',
    noData: 'Brak danych. Zacznij od dodania analiz skautingowych!',
    deleteAnalysis: 'Usuń analizę skautingową',
    deleteAnalysisMessage: 'Analiza zostanie trwale usunięta. Kontynuować?',
    avgTooltip: 'Średnia na podstawie końcowych ocen widocznych dla Ciebie',
    avgOverallScoreTooltip: 'Średnia na podstawie ogólnych ocen zawodnika widocznych dla Ciebie',
    scouter: 'Skaut',
    lastEdited: 'Ostatnia edycja',
    analysisFilters: 'Filtry analiz',
    generalFilters: 'Filtry ogólne',
    widgetSubtitle: 'Najnowsze dodane analizy',
    addPlayerReport: 'Dodaj analizę zawodnika',
    seeReports: 'Zobacz raporty',
    addGameReport: 'Dodaj analizę meczu',
    keyPlayers: 'Kluczowi zawodnicy',
    formation: 'Formacja',
    inPossession: 'W posiadaniu',
    notesIP: 'Uwagi w posiadaniu',
    outOfPossession: 'Bez piłki',
    notesOP: 'Uwagi bez piłki',
    transitions: 'Przejścia',
    notesTransitions: 'Uwagi do przejść',
    notesSP: 'Uwagi SFG',
    finalRating: 'Ocena końcowa',
    gameNotesPlaceholder: 'Wpisz notatki/komentarze dot. meczu',
    avgPotentialTooltip: 'Średnia na podstawie potencjału analiz widocznych dla Ciebie',
    potential: 'Potencjał',
    tags: 'Tagi',
    tagsPlaceholder: 'Dodaj kilka tagów',
    tagsHint: 'Wpisz i naciśnij Enter, aby dodać tag',
    exampleTags: {
      leadership: 'Przywództwo',
      resilience: 'Odporność',
      competitiveMindset: 'Konkurencyjny sposób myślenia',
      calmUnderPressure: 'Spokojnie pod presją',
      focus: 'Centrum',
      discipline: 'Dyscyplina',
      coachability: 'Możliwość trenowania',
      poorBodyLanguage: 'Zła mowa ciała',
      lowConfidence: 'Niska pewność siebie',
      easilyFrustrated: 'Łatwo sfrustrowany'
    },
    totals: 'Totals',
    byPossession: 'By Possession'
  },
  addPlayerForm: {
    noLeague: 'Tworzenie drużyny bez ligi może utrudnić indeksację i wyszukiwanie w aplikacji.'
  },
  expenses: {
    expense: 'Wydatek',
    expenses: 'Wydatki',
    addExpense: 'Dodaj wydatek',
    transportation: 'Transport',
    accommodation: 'Nocleg',
    dietary: 'Dieta',
    eventTicket: 'Bilet na wydarzenie',
    expenseType: 'Typ wydatku',
    amount: 'Kwota',
    expenseDate: 'Data wydatku',
    expenseFilters: 'Filtry wydatków',
    noData: 'Brak danych. Zacznij od dodania wydatków!',
    deleteExpense: 'Usuń wydatek',
    deleteExpenseMessage: 'Wydatek zostanie trwale usunięty. Kontynuować?'
  },
  disabledTooltips: {
    general: 'Ta funkcja jest obecnie wyłączona',
    youth: 'Musi być młodzież, aby ustawić wiek',
    unit: 'Statystyka musi być Runs, HSR lub SPR',
    seasonsWithout60MinsGames: 'Zawodnik nie zagrał >60 minut w pojedynczym meczu w wybranym sezonie',
    notEditable: 'Tego nie można edytować',
    noMatchdate: 'Brak daty meczu',
    selectGame: 'Najpierw wybierz mecz',
    selectPlayer: 'Najpierw wybierz zawodnika',
    selectTeam: 'Najpierw wybierz drużynę',
    selectBoxes: 'Wybierz wizualizację \'pola\'',
    selectYear: 'Najpierw wybierz rok',
    pdScoreNotAvailable: 'Ocena niedostępna dla graczy, którzy nie rozegrali 60 minut w meczu',
    pdSeasonNotAvailable: 'Brak danych fizycznych dla tego sezonu',
    pdGameNotAvailable: 'Brak danych fizycznych dla tego meczu'
  },
  leagueTypes: {
    regular: 'Liga',
    continental: 'Kontynentalne',
    nationalTeam: 'Reprezentacja',
    countryCup: 'Puchar kraju',
    qualifier: 'Eliminacje',
    playOff: 'Play-off',
    regionalLeague: 'Liga regionalna',
    friendly: 'Towarzyski',
    nationalFriendly: 'Towarzyski (reprez.)',
    nationaQualifier: 'Eliminacje (reprez.)'
  },
  playerSides: {
    'Left/Right': 'Lewa/Prawa',
    'Left/Centre/Right': 'Lewa/Środek/Prawa',
    Right: 'Prawa',
    Centre: 'Środek',
    'Centre/Right': 'Środek/Prawa',
    Left: 'Lewa',
    'Left/Centre': 'Lewa/Środek'
  },
  areaSelector: {
    selectAreas: 'Wybierz strefy',
    filterAreas: 'Filtruj strefy'
  },
  spatialCoverage: {
    lastDefenderDist: 'Odległość ostatniego obrońcy',
    defensiveLineDist: 'Odległość linii obrony',
    fullBackAvgDist: 'Średnia odległość bocznych obrońców',
    offensiveLineDist: 'Odległość linii ataku',
    distanceToGoal: 'Odległość do bramki',
    avgLineWidth: 'Śr. szerokość linii',
    leagueAvgDistanceToGoal: 'Śr. ligowa odl. do bramki',
    leagueAvgLineWidth: 'Śr. ligowa szer. linii',
    avgShort: 'Śr.',
    meters: 'metry',
    leagueAvgDist: 'Śr. ligowa odległość',
    distance: 'Odległość',
    avgPositionYAxis: 'Śr. odległość na boisku (Y)',
    leagueAvgPositionYAxis: 'Śr. ligowa odległość na boisku (Y)',
    lbRbDistanceSeparation: 'Odległość LB–RB',
    leagueAvgLbRbDistanceSeparation: 'Śr. ligowa odległość LB–RB',
    legendTeam: 'Drużyna',
    legendLeagueAvg: 'Śr. ligowa',
    maxLength: 'Maksymalna długość',
    maxWidth: 'Maksymalna szerokość',
    avgBlockDistance: 'Śr. odległość bloku'
  },
  arrigo: {
    beta: 'BETA',
    subtitle: 'Inteligentne dane',
    passesUnderPressureSubtitle: 'Analizuj skuteczność podań wykonanych pod presją defensywną',
    onBallPressureSubtitle: 'Analizuj naciski defensywne i ich skuteczność w zależności od stref na boisku',
    ballReceiptsInSpaceSubtitle: 'Analizuj podania otrzymane w przestrzeni według strefy pola',
    ballReceipts: 'wpływy kasowe',
    totalBallReceipts: 'Łączne Odbior Piłki',
    totalBallReceiptsCompleted: 'Łączne Odbicia Piłki Zakończone',
    completed: 'Zakończone',
    lineBreakingPassesSubtitle: 'Analizuj podania, które przełamują linie i stwarzają przewagę',
    bypassed: 'Ograć',
    oppsBypassed: 'Przeciwnicy pokonani',
    passer: 'Podający',
    passedTo: 'Podaj do',
    receivedFrom: 'Otrzymane z',
    distanceToNearestDefender: 'Odległość do najbliższego obrońcy',
    lineBreaking: 'Łamanie linii {0}',
    keyPass: 'Kluczowe przejście',
    receiver: 'Odbiornik',
    dynamicTracking: 'Dynamiczne śledzenie',
    eventLockTooltip: 'Niektórzy gracze nie byli widoczni podczas gry',
    bypassedPlayers: '{0} ominiętych zawodników',
    playersCount: '{0} zawodników',
    bothTeams: 'Obie drużyny',
    matchesCount: '{0} meczów',
    lbpType: {
      F: 'Linia ataku',
      M: 'Linia pomocy',
      B: 'Linia obrony',
      MF: 'Linia pomocy i ataku',
      BM: 'Linia obrony i pomocy',
      BF: 'Linia obrony i ataku',
      BMF: 'Linia obrony, pomocy i ataku'
    },
    lbpCategory: {
      'G-IN-T': 'Po ziemi wewnątrz (przełamuje linię obrony)',
      'G-IN-NT': 'Po ziemi wewnątrz (nie przełamuje linii obrony)',
      'G-OUT-T': 'Po ziemi na zewnątrz (przełamuje linię obrony)',
      'G-OUT-NT': 'Po ziemi na zewnątrz (nie przełamuje linii obrony)',
      'O-IN-T': 'Górą wewnątrz (przełamuje linię obrony)',
      'O-IN-NT': 'Górą wewnątrz (nie przełamuje linii obrony)',
      'O-OUT-T': 'Górą na zewnątrz (przełamuje linię obrony)',
      'O-OUT-NT': 'Górą na zewnątrz (nie przełamuje linii obrony)',
      ground: 'Po ziemi',
      over: 'Górą',
      inside: 'Wewnątrz',
      outside: 'Na zewnątrz',
      through: 'Przełamuje linię obrony',
      notThrough: 'Nie przełamuje linii obrony',
      throughAbbr: 'Przełamanie def. linia',
      notThroughAbbr: 'Nie łamie def. linia'
    },
    lbpCategorySplit: {
      G: 'Ground: Podanie zostało uziemione',
      O: 'Over: Piłka została wyrzucona w powietrze',
      OUT: 'Na zewnątrz: Przepustka wyszła na zewnątrz',
      IN: 'Wewnątrz: przepustka weszła do środka',
      T: 'Przełamuje linię obrony: podanie przełamuje linię obrony od środka',
      NT: 'Nie przełamuje linii obrony: podanie nie łamie jej od środka; omija ją z zewnątrz'
    },
    obrType: {
      OL: 'Zachodzić na siebie',
      UL: 'Podkład',
      RA: 'Biegnij naprzód',
      RB: 'Biegnij z tyłu',
      CR: 'Odbiornik krzyżowy',
      SP: 'Wsparcie',
      CS: 'Wkrótce'
    },
    visualization: 'Wizualizacja',
    points: 'Kółka',
    zones: 'Mapa Cieplna',
    pressureIntensity: 'Intensywność nacisku',
    pressureOutcome: 'Wynik nacisku',
    passesOutcome: 'Wynik Podań',
    strong: 'Silny',
    light: 'Lekki',
    normal: 'Normalny',
    successful: 'Sukces',
    unsuccessful: 'Niepowodzenie',
    presses: 'Naciski',
    passes: 'Przechodzi',
    passUnder: 'Przejdź pod',
    successRate: 'Wskaźnik sukcesu',
    pressureOn: 'Nacisk na',
    pressureOf: 'Presja',
    pressure: 'Nacisk',
    totalLabel: 'łącznie',
    totalPasses: 'Całkowita liczba Przejść',
    unknown: 'nieznany',
    selectGameToViewMap: 'Wybierz mecz, aby zobaczyć mapę nacisku',
    noEventsFoundForGame: 'Nie znaleziono zdarzeń nacisku dla tego meczu',
    noEventsFoundForTeamAndSeason: 'Nie znaleziono zdarzeń nacisku dla tego zespołu i sezonu',
    noEventsFoundForPlayerAndSeason: 'Nie znaleziono zdarzeń nacisku dla tego gracza i sezonu',
    noEventsMatchFilters: 'Nie znaleziono zdarzeń, które odpowiadają aktualnym filtrom',
    totalEventsAvailable: 'łączna liczba zdarzeń',
    passType: {
      P: 'Przechodzić',
      A: 'Wspierać',
      KP: 'Kluczowe przejście',
      PiOB: 'Przejdź do Opp. Skrzynka',
      PiFT: 'Przejdź do finałowej trzeciej części',
      SoPP: 'Zmiana Play Pass'
    },
    minFrom: 'Min. od',
    minTo: 'Min. do',
    secondFrom: 'Oddziel od',
    secondTo: 'Przejdź do',
    positionPlayed: 'Pozycja grana',
    highlight: 'Atrakcja',
    passTypeLabel: 'Typ przepustki',
    offBallRunSubtitle: 'Analizuj biegi bez piłki',
    insights: 'Spostrzeżenia',
    insightsSubtitle: 'Ranking najlepszych dzięki Advanced Arrigo Analytics',
    pressurePassTypeLabel: 'Pressure On Pass Type'
  },
  driblabAI: {
    chatText: 'Jak mogę Ci dzisiaj pomóc?',
    chatSubtext: 'Zapytaj o dane piłkarskie!',
    thinking: 'Myślący...',
    giveFeedback: 'Przekaż opinię',
    disclaimer: 'DriblabAI może popełniać błędy. Prosimy o zweryfikowanie informacji.',
    recent: 'Ostatni',
    noConversations: 'Tutaj zobaczysz swoje ostatnie rozmowy!',
    rename: 'Przemianować',
    deleteConversation: 'Usuń rozmowę',
    confirmDelete: 'Czy na pewno chcesz usunąć tę rozmowę?',
    feedback: 'Informacja zwrotna',
    feedbackQuestion: 'Czy ta odpowiedź była pomocna?',
    feedbackComments: 'Dodatkowe uwagi',
    feedbackPlaceholder: 'Powiedz nam, co było pomocne, a co można poprawić...',
    errorMessage: 'Nie można przetworzyć wiadomości. Spróbuj ponownie.',
    newConversation: 'Nowy czat',
    write: 'Napisz wiadomość...'
  },
  periodId: {
    1: 'Pierwsza połowa',
    2: 'Druga połowa',
    3: 'Dogrywka – 1°',
    4: 'Dogrywka – 2°',
    5: 'Rzuty karne',
    6: 'Pełny etat',
    7: 'Przed meczem',
    8: 'Opuszczony',
    9: 'Na żywo',
    10: '0-15',
    11: '16-30',
    12: '31+',
    13: '45-60',
    14: '61-75',
    15: '76+',
    '-1': 'Inny'
  }
};
